var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.tsx
import avatar from "./assets/avatar.png";
import camera from "./assets/camera.png";
import checkCircle from "./assets/checkCircle.svg";
import checkmark from "./assets/checkmark.png";
import clipBoard from "./assets/clipBoard.png";
import confetti from "./assets/confetti.png";
import createTeam from "./assets/createTeam.png";
import crown from "./assets/crown.png";
import highFive from "./assets/highFive.png";
import joinTeam from "./assets/joinTeam.png";
import mindfulMan from "./assets/mindfulMan.png";
import personalInfo from "./assets/personalInfo.png";
import selectAvatar from "./assets/selectAvatar.png";
import teamLink from "./assets/teamLink.png";
import trackHealthData from "./assets/trackHealthData.png";
import trackWearables from "./assets/trackWearables.png";
import uploadProfilePic from "./assets/uploadProfilePic.png";
import achievementEarned from "./assets/achievementEarned.png";
import completedChallenge from "./assets/completedChallenge.png";

// src/components/challenge-icon/components/alert/alert.component.tsx
import React from "react";
var Alert = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "alertIcon"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
      stroke: "currentColor",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.5984 17.9984C12.5984 18.3298 12.3298 18.5984 11.9984 18.5984C11.6671 18.5984 11.3984 18.3298 11.3984 17.9984C11.3984 17.6671 11.6671 17.3984 11.9984 17.3984C12.3298 17.3984 12.5984 17.6671 12.5984 17.9984Z",
      stroke: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12 14.4L12 6",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }
  )
);

// src/components/challenge-icon/components/arrow/arrow.component.tsx
import React2 from "react";
var Arrow = () => /* @__PURE__ */ React2.createElement(
  "svg",
  {
    width: "20",
    height: "18",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "arrowIcon"
  },
  /* @__PURE__ */ React2.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.75258 1.65852C9.11626 1.24288 9.07414 0.611119 8.6585 0.247437C8.24287 -0.116245 7.61111 -0.0741276 7.24742 0.341509L0.250558 8.33793C0.0946349 8.51429 0 8.7461 0 9.00001C0 9.25401 0.094699 9.4859 0.250716 9.66228L7.24742 17.6585C7.61111 18.0742 8.24287 18.1163 8.6585 17.7526C9.07414 17.3889 9.11626 16.7571 8.75258 16.3415L3.20377 10H19C19.5523 10 20 9.5523 20 9.00001C20 8.44773 19.5523 8.00001 19 8.00001H3.20377L8.75258 1.65852Z",
      fill: "currentColor"
    }
  )
);

// src/components/challenge-icon/components/calendar/calendar.component.tsx
import React3 from "react";
var Calendar = () => /* @__PURE__ */ React3.createElement(
  "svg",
  {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "calendarIcon"
  },
  /* @__PURE__ */ React3.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.752014 5.25C0.752014 4.42157 1.42359 3.75 2.25201 3.75H21.752C22.5804 3.75 23.252 4.42157 23.252 5.25V21.75C23.252 22.5784 22.5804 23.25 21.752 23.25H2.25201C1.42359 23.25 0.752014 22.5784 0.752014 21.75V5.25Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React3.createElement(
    "path",
    {
      d: "M0.752014 9.75H23.252",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React3.createElement(
    "path",
    {
      d: "M6.75201 6V0.75",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React3.createElement(
    "path",
    {
      d: "M17.252 6V0.75",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React3.createElement("circle", { cx: "6", cy: "14", r: "2", fill: "currentColor" })
);

// src/components/challenge-icon/components/chevron/chevron.component.tsx
import React4 from "react";
var Chevron = () => /* @__PURE__ */ React4.createElement(
  "svg",
  {
    width: "17",
    height: "20",
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "chevronIcon"
  },
  /* @__PURE__ */ React4.createElement(
    "path",
    {
      d: "M11.5 4L5.5 10L11.5 16",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/components/challenge-icon/components/circular-arrow/circular-arrow.component.tsx
import React5 from "react";
var CircularArrow = () => /* @__PURE__ */ React5.createElement(
  "svg",
  {
    width: "18",
    height: "16",
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "circularArrowIcon"
  },
  /* @__PURE__ */ React5.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.83279 2.23467C11.9635 2.21338 13.9415 3.33788 15.013 5.17963C16.0846 7.02139 16.0846 9.2967 15.013 11.1385C13.9415 12.9802 11.9635 14.1047 9.83279 14.0834V14.0834L9.82562 14.0834C8.20729 14.0827 6.65711 13.4318 5.52336 12.277C4.73946 11.4785 4.20011 10.4854 3.95151 9.41372L5.00911 10.103C5.35612 10.3292 5.82078 10.2312 6.04696 9.88423C6.27313 9.53722 6.17517 9.07256 5.82815 8.84639L3.4658 7.30668C3.40522 7.26577 3.3383 7.23346 3.26677 7.21154C3.17807 7.18427 3.08627 7.1742 2.99602 7.18038C2.888 7.18756 2.78607 7.21769 2.69517 7.266C2.60423 7.31413 2.52214 7.38157 2.45561 7.46691C2.43981 7.4871 2.42502 7.50812 2.41132 7.5299L0.871722 9.89106C0.64548 10.238 0.743349 10.7027 1.09032 10.929C1.43729 11.1552 1.90197 11.0573 2.12821 10.7104L2.56364 10.0426C2.90013 11.2696 3.54525 12.4032 4.45298 13.3278C5.86778 14.7689 7.80196 15.5815 9.82137 15.5834C12.4901 15.6088 14.9673 14.1998 16.3095 11.8928C17.6524 9.58472 17.6524 6.73336 16.3095 4.42531C14.9667 2.11726 12.4879 0.708061 9.8178 0.734747C9.40361 0.738887 9.0712 1.07801 9.07533 1.49221C9.07947 1.9064 9.4186 2.23881 9.83279 2.23467Z",
      fill: "currentColor"
    }
  )
);

// src/components/challenge-icon/components/clock/clock.component.tsx
import React6 from "react";
var Clock = () => /* @__PURE__ */ React6.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "clockIcon"
  },
  /* @__PURE__ */ React6.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React6.createElement(
    "path",
    {
      d: "M12 12V8.25",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React6.createElement(
    "path",
    {
      d: "M12 12L16.687 16.688",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/components/challenge-icon/components/close/close.component.tsx
import React7 from "react";
var Close = () => /* @__PURE__ */ React7.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "closeIcon"
  },
  /* @__PURE__ */ React7.createElement(
    "path",
    {
      d: "M5 5L19 19",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React7.createElement(
    "path",
    {
      d: "M5 19L19 5.00002",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/components/challenge-icon/components/cog/cog.component.tsx
import React8 from "react";
var Cog = () => /* @__PURE__ */ React8.createElement(
  "svg",
  {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "cogIcon"
  },
  /* @__PURE__ */ React8.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.70705 2.497C10.037 2.86331 10.5069 3.07245 11 3.07245C11.493 3.07245 11.9629 2.86331 12.2929 2.497L13.1341 1.57399C13.6281 1.02725 14.4127 0.850485 15.0935 1.13256C15.7742 1.41464 16.2038 2.09454 16.1663 2.83046L16.1032 4.07536C16.0785 4.56646 16.2626 5.04509 16.6101 5.39304C16.9575 5.74098 17.4359 5.9258 17.927 5.90182L19.1719 5.83869C19.9073 5.80243 20.5861 6.23248 20.8675 6.91292C21.1488 7.59336 20.972 8.37721 20.4257 8.87092L19.4991 9.70679C19.1333 10.0372 18.9245 10.5072 18.9245 11.0002C18.9245 11.4931 19.1333 11.9631 19.4991 12.2935L20.4257 13.1294C20.9724 13.6234 21.1492 14.408 20.8671 15.0887C20.585 15.7695 19.9051 16.1991 19.1692 16.1616L17.9243 16.0985C17.4321 16.0732 16.9522 16.2577 16.6037 16.6062C16.2552 16.9547 16.0708 17.4345 16.0961 17.9267L16.1592 19.1716C16.1918 19.9037 15.7629 20.5779 15.0859 20.8584C14.409 21.139 13.6289 20.9659 13.1341 20.4254L12.2973 19.4998C11.9671 19.134 11.4973 18.9252 11.0044 18.9252C10.5116 18.9252 10.0418 19.134 9.71149 19.4998L8.87118 20.4254C8.37713 20.9685 7.59564 21.1435 6.91716 20.863C6.23869 20.5826 5.80888 19.9068 5.8425 19.1734L5.90652 17.9285C5.93184 17.4363 5.74737 16.9564 5.39887 16.6079C5.05037 16.2594 4.57049 16.075 4.07829 16.1003L2.83338 16.1634C2.09776 16.2018 1.41758 15.7731 1.13487 15.0929C0.852161 14.4127 1.02811 13.6282 1.57425 13.1338L2.49992 12.298C2.86577 11.9675 3.07455 11.4976 3.07455 11.0046C3.07455 10.5116 2.86577 10.0417 2.49992 9.71124L1.57425 8.87092C1.02995 8.37718 0.854254 7.59486 1.13517 6.91579C1.41609 6.23673 2.09312 5.80716 2.82716 5.84224L4.07206 5.90538C4.56522 5.93131 5.04619 5.74659 5.39521 5.39723C5.74424 5.04786 5.92848 4.56672 5.90208 4.07359L5.8425 2.82779C5.80808 2.09407 6.23759 1.41759 6.91627 1.13664C7.59494 0.855685 8.37692 1.03063 8.87118 1.57399L9.70705 2.497Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React8.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 15.0021C13.21 15.0021 15.0015 13.2106 15.0015 11.0006C15.0015 8.79067 13.21 6.99915 11 6.99915C8.79006 6.99915 6.99854 8.79067 6.99854 11.0006C6.99854 13.2106 8.79006 15.0021 11 15.0021Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/components/highlight-card/heart-icon/heart-icon.component.tsx
import React9 from "react";
import {
  genesisStyled,
  css
} from "@leagueplatform/genesis-commons";
var StyledPath = genesisStyled.path(
  ({ fillColor, strokeColor }) => css(__spreadValues({
    fill: fillColor
  }, strokeColor && { stroke: strokeColor }))
);
var HeartIcon = ({ fillColor }) => /* @__PURE__ */ React9.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "heartIcon"
  },
  /* @__PURE__ */ React9.createElement(
    StyledPath,
    {
      d: "M12 22L2.62481 11.8374C1.80161 10.9823 1.25825 9.87967 1.07169 8.68581C0.885136 7.49194 1.06484 6.26735 1.58536 5.18551V5.18551C1.97855 4.36873 2.55289 3.66072 3.26106 3.11981C3.96923 2.5789 4.79095 2.22057 5.65852 2.07436C6.5261 1.92814 7.41469 1.99822 8.25109 2.27882C9.08749 2.55941 9.84776 3.0425 10.4692 3.68827L12 5.27885L13.5308 3.68827C14.1522 3.0425 14.9125 2.55941 15.7489 2.27882C16.5853 1.99822 17.4739 1.92814 18.3415 2.07436C19.2091 2.22057 20.0308 2.5789 20.7389 3.11981C21.4471 3.66072 22.0214 4.36873 22.4146 5.18551V5.18551C22.9352 6.26735 23.1149 7.49194 22.9283 8.68581C22.7417 9.87967 22.1984 10.9823 21.3752 11.8374L12 22Z",
      fillColor,
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/components/challenge-icon/components/hyperlink/hyperlink.component.tsx
import React10 from "react";
var HyperLink = () => /* @__PURE__ */ React10.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "hyperlinkIcon"
  },
  /* @__PURE__ */ React10.createElement(
    "path",
    {
      d: "M12.3428 16.0149C11.6179 17.5227 9.79382 18.1703 8.26012 17.4645V17.4645C6.73059 16.7499 6.0736 14.9517 6.78963 13.4398L7.72269 11.4851C8.44732 9.97736 10.2712 9.32968 11.8047 10.0355V10.0355C12.6771 10.4412 13.3051 11.2279 13.5 12.1593",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React10.createElement(
    "path",
    {
      d: "M11.5668 7.98525C12.303 6.47733 14.1553 5.82963 15.7128 6.53554V6.53554C17.2657 7.25019 17.9328 9.04798 17.2061 10.5598L16.2586 12.5148C15.5225 14.0227 13.6701 14.6704 12.1126 13.9645V13.9645C11.3551 13.618 10.7737 12.9895 10.5 12.2212",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/components/challenge-icon/components/linkout/linkout.component.tsx
import React11 from "react";
var Linkout = () => /* @__PURE__ */ React11.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "linkoutIcon"
  },
  /* @__PURE__ */ React11.createElement(
    "path",
    {
      d: "M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React11.createElement(
    "path",
    {
      d: "M15 3H21V9",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React11.createElement(
    "path",
    {
      d: "M11.5 12.5L21 3",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/components/challenge-icon/components/prize/prize.component.tsx
import React12 from "react";
var Prize = () => /* @__PURE__ */ React12.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "prizeIcon"
  },
  /* @__PURE__ */ React12.createElement(
    "path",
    {
      d: "M4.807 13.042L0.75 18L4.5 18.75L6 23.25L9.944 16.992",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React12.createElement(
    "path",
    {
      d: "M19.193 13.042L23.25 18L19.5 18.75L18 23.25L14.056 16.992",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React12.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 17.25C16.5563 17.25 20.25 13.5563 20.25 9C20.25 4.44365 16.5563 0.75 12 0.75C7.44365 0.75 3.75 4.44365 3.75 9C3.75 13.5563 7.44365 17.25 12 17.25Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React12.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.531 4.29199L13.779 6.74999H15.906C16.1456 6.74413 16.3644 6.88581 16.457 7.1069C16.5496 7.32799 16.4972 7.58326 16.325 7.74999L14.372 9.66799L15.454 12.153C15.5518 12.3864 15.4896 12.6561 15.2995 12.8231C15.1094 12.9902 14.8338 13.0171 14.615 12.89L12 11.419L9.385 12.89C9.16617 13.0171 8.89063 12.9902 8.70051 12.8231C8.5104 12.6561 8.4482 12.3864 8.546 12.153L9.628 9.66799L7.675 7.74599C7.50277 7.57926 7.45037 7.32399 7.54301 7.1029C7.63564 6.88181 7.85436 6.74013 8.094 6.74599H10.221L11.47 4.29199C11.5739 4.09533 11.7781 3.97229 12.0005 3.97229C12.2229 3.97229 12.4271 4.09533 12.531 4.29199Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/components/challenge-icon/components/question/question.component.tsx
import React13 from "react";
var Question = () => /* @__PURE__ */ React13.createElement(
  "svg",
  {
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "questionIcon",
    "aria-hidden": true
  },
  /* @__PURE__ */ React13.createElement(
    "path",
    {
      d: "M8.5 15.5C12.6421 15.5 16 12.1421 16 8C16 3.85786 12.6421 0.5 8.5 0.5C4.35786 0.5 1 3.85786 1 8C1 12.1421 4.35786 15.5 8.5 15.5Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeMiterlimit: "10"
    }
  ),
  /* @__PURE__ */ React13.createElement(
    "path",
    {
      d: "M8.5 11.5C8.45055 11.5 8.40222 11.5147 8.36111 11.5421C8.32 11.5696 8.28795 11.6086 8.26903 11.6543C8.25011 11.7 8.24516 11.7503 8.2548 11.7988C8.26445 11.8473 8.28826 11.8918 8.32322 11.9268C8.35819 11.9617 8.40273 11.9855 8.45123 11.9952C8.49972 12.0048 8.54999 11.9999 8.59567 11.981C8.64135 11.962 8.6804 11.93 8.70787 11.8889C8.73534 11.8478 8.75 11.7994 8.75 11.75C8.75 11.6837 8.72366 11.6201 8.67678 11.5732C8.62989 11.5263 8.5663 11.5 8.5 11.5Z",
      fill: "white",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React13.createElement(
    "path",
    {
      d: "M6.5 5.99999C6.50007 5.63334 6.60093 5.27376 6.79155 4.96056C6.98217 4.64736 7.25522 4.39259 7.58085 4.22409C7.90649 4.05559 8.27218 3.97984 8.63795 4.00513C9.00372 4.03042 9.35551 4.15577 9.65486 4.36748C9.9542 4.5792 10.1896 4.86912 10.3353 5.20558C10.481 5.54203 10.5314 5.91206 10.481 6.27523C10.4306 6.6384 10.2814 6.98073 10.0496 7.26481C9.81778 7.54888 9.51235 7.76377 9.16667 7.88599C8.97161 7.95495 8.80275 8.08271 8.68335 8.25166C8.56395 8.42061 8.49989 8.62243 8.5 8.82932V9.49999",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

// src/asset-map.tsx
var CHALLENGES_ASSET_MAP = {
  CHALLENGES_ALERT: Alert,
  CHALLENGES_ARROW: Arrow,
  CHALLENGES_AVATAR: avatar,
  CHALLENGES_CALENDAR: Calendar,
  CHALLENGES_CAMERA: camera,
  CHALLENGES_CLOCK: Clock,
  CHALLENGES_CLOSE: Close,
  CHALLENGES_CHECK_CIRCLE: checkCircle,
  CHALLENGES_CHECKMARK: checkmark,
  CHALLENGES_CHEVRON: Chevron,
  CHALLENGES_CIRCULAR_ARROW: CircularArrow,
  CHALLENGES_CLIP_BOARD: clipBoard,
  CHALLENGES_COG: Cog,
  CHALLENGES_CONFETTI: confetti,
  CHALLENGES_CREATE_TEAM: createTeam,
  CHALLENGES_CROWN: crown,
  CHALLENGES_HEART_ICON: HeartIcon,
  CHALLENGES_HIGH_FIVE: highFive,
  CHALLENGES_HYPERLINK: HyperLink,
  CHALLENGES_JOIN_TEAM: joinTeam,
  CHALLENGES_MINDFUL_MAN: mindfulMan,
  CHALLENGES_LINKOUT: Linkout,
  CHALLENGES_PERSONAL_INFO: personalInfo,
  CHALLENGES_PRIZE: Prize,
  CHALLENGES_QUESTION: Question,
  CHALLENGES_SELECT_AVATAR: selectAvatar,
  CHALLENGES_TEAM_LINK: teamLink,
  CHALLENGES_TRACK_HEALTH_DATA: trackHealthData,
  CHALLENGES_TRACK_WEARABLES: trackWearables,
  CHALLENGES_UPLOAD_PROFILE_PIC: uploadProfilePic,
  CHALLENGES_ACHIEVEMENT_EARNED: achievementEarned,
  CHALLENGES_COMPLETED_CHALLENGE: completedChallenge
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(CHALLENGES_ASSET_MAP);
};

// src/challenge.routes.tsx
import React98 from "react";
import { Routes, Route } from "@leagueplatform/routing";

// src/pages/join-team-page/join-team-page.page.tsx
import React29, { useEffect as useEffect3, useState as useState3 } from "react";
import {
  LinkLegacy as Link5,
  useParamsLegacy as useParams9
} from "@leagueplatform/routing";
import {
  HeadingOne as HeadingOne2,
  BodyOne as BodyOne3,
  Box as Box10,
  Flex as Flex9
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl9 } from "@leagueplatform/locales";

// src/constants/challenges.constants.tsx
var CHALLENGES_UTM_SOURCE = "Challenges";
var CONTENT_MAX_WIDTH = "792px";
var BUTTON_CONTAINER_MAX_WIDTH = "384px";
var PROFILE_PICTURE_SIZE = "140px";
var PROFILE_SELECT_CONTAINER_FIXED_HEIGHT = "388px";
var LOAD_MORE_BUTTON_MAX_WIDTH = "327px";
var LEADERBOARD_SPINNER_FIXED_HEIGHT = "200px";
var PRIVACY_POLICY_MAX_WIDTH = "475px";
var MODAL_CTA_MAX_WIDTH = "280px";
var MODAL_IMAGE_HEIGHT = 200;
var CREATE_TEAM_BUTTON_CONTAINER_MAX_WIDTH = {
  _: "240px",
  tablet: "184px"
};
var CREATE_TEAM_MODAL_HEADING_FONT = {
  _: "heading2",
  tablet: "heading1"
};
var DEBOUNCE_DELAY_INTERVAL = 400;
var noopFunction = () => {
};
var CHALLENGE_STATUS = /* @__PURE__ */ ((CHALLENGE_STATUS2) => {
  CHALLENGE_STATUS2["UPCOMING"] = "upcoming";
  CHALLENGE_STATUS2["ACTIVE"] = "active";
  CHALLENGE_STATUS2["CLOSED"] = "closed";
  return CHALLENGE_STATUS2;
})(CHALLENGE_STATUS || {});

// src/pages/join-team-page/join-team-page.page.tsx
import {
  BackButtonArrow as BackButtonArrow4,
  FullPageError as FullPageError2
} from "@leagueplatform/web-common-components";
import { JOURNEY_ROUTES as JOURNEY_ROUTES5 } from "@leagueplatform/health-journey-common";

// src/hooks/use-challenges-analytics.hook.tsx
import { useParamsLegacy as useParams2 } from "@leagueplatform/routing";
import {
  trackAnalyticsEvent,
  PRODUCT_AREA,
  SUB_PRODUCT_AREA
} from "@leagueplatform/analytics";

// src/constants/analytics.constants.tsx
var CHALLENGE_CAMPAIGN_TYPE = "challenge";
var SIGN_UP_ANALYTICS_SCREEN_NAMES = /* @__PURE__ */ ((SIGN_UP_ANALYTICS_SCREEN_NAMES3) => {
  SIGN_UP_ANALYTICS_SCREEN_NAMES3["ACCEPT_PRIVACY_POLICY"] = "challenges privacy screen";
  SIGN_UP_ANALYTICS_SCREEN_NAMES3["QUIT_SIGN_UP"] = "quit sign-up confirmation";
  SIGN_UP_ANALYTICS_SCREEN_NAMES3["SIGN_UP_SUCCESS"] = "sign-up success";
  SIGN_UP_ANALYTICS_SCREEN_NAMES3["WEARABLES_CONNECTION"] = "connect app or device from health campaign";
  SIGN_UP_ANALYTICS_SCREEN_NAMES3["SELECT_TEAM_AVATAR"] = "select team avatar";
  return SIGN_UP_ANALYTICS_SCREEN_NAMES3;
})(SIGN_UP_ANALYTICS_SCREEN_NAMES || {});
var SIGN_UP_ANALYTICS_DETAILS = /* @__PURE__ */ ((SIGN_UP_ANALYTICS_DETAILS2) => {
  SIGN_UP_ANALYTICS_DETAILS2["CHANGE_TEAM_AVATAR"] = "change team avatar";
  SIGN_UP_ANALYTICS_DETAILS2["CONFIRM"] = "confirm";
  SIGN_UP_ANALYTICS_DETAILS2["CONTINUE"] = "continue";
  SIGN_UP_ANALYTICS_DETAILS2["COPY"] = "copy";
  SIGN_UP_ANALYTICS_DETAILS2["CREATE_TEAM"] = "create team";
  SIGN_UP_ANALYTICS_DETAILS2["EXIT"] = "exit";
  SIGN_UP_ANALYTICS_DETAILS2["GO_TO_JOURNEY"] = "go to journey";
  SIGN_UP_ANALYTICS_DETAILS2["JOIN_TEAM"] = "join or create a team";
  SIGN_UP_ANALYTICS_DETAILS2["NOT_NOW"] = "not now";
  SIGN_UP_ANALYTICS_DETAILS2["SELECT_TEAM_AVATAR"] = "select team avatar";
  SIGN_UP_ANALYTICS_DETAILS2["TRACK_AUTOMATICALLY"] = "track progress automatically";
  SIGN_UP_ANALYTICS_DETAILS2["TRACK_MANUALLY"] = "track manually instead";
  SIGN_UP_ANALYTICS_DETAILS2["VIEW_DETAILS"] = "view challenge details";
  SIGN_UP_ANALYTICS_DETAILS2["VIEW_TEAM_DETAILS"] = "view team details";
  return SIGN_UP_ANALYTICS_DETAILS2;
})(SIGN_UP_ANALYTICS_DETAILS || {});
var CLP_SCREEN_NAMES = /* @__PURE__ */ ((CLP_SCREEN_NAMES3) => {
  CLP_SCREEN_NAMES3["LEAVE_CHALLENGE"] = "leave challenge";
  CLP_SCREEN_NAMES3["CHALLENGES_PRIVACY_SETTINGS"] = "challenges privacy settings";
  return CLP_SCREEN_NAMES3;
})(CLP_SCREEN_NAMES || {});
var CLP_DETAIL = /* @__PURE__ */ ((CLP_DETAIL2) => {
  CLP_DETAIL2["NAVIGATE_TO_HELP_CENTER"] = "help center";
  CLP_DETAIL2["SIGN_UP"] = "sign up";
  CLP_DETAIL2["JOIN_CREATE_TEAM"] = "join or create a team";
  CLP_DETAIL2["LEAVE_CHALLENGE"] = "leave challenge";
  CLP_DETAIL2["VIEW_MORE"] = "view more";
  CLP_DETAIL2["HIDE_ACTIVITY"] = "hide activity";
  CLP_DETAIL2["SHOW_ACTIVITY"] = "show activity";
  CLP_DETAIL2["SETTINGS"] = "settings";
  CLP_DETAIL2["INTERACT_HIGHLIGHTS"] = "interact with highlights";
  CLP_DETAIL2["EXIT"] = "exit";
  CLP_DETAIL2["SETTINGS_MENU_PRIVACY"] = "settings menu - privacy";
  CLP_DETAIL2["SETTINGS_MENU_LEAVE_CHALLENGE"] = "settings menu - leave challenge";
  return CLP_DETAIL2;
})(CLP_DETAIL || {});

// src/pages/challenge-landing-page/hooks/use-get-challenge-by-id-data.hook.ts
import { useQuery } from "react-query";
import { useParamsLegacy as useParams } from "@leagueplatform/routing";
import {
  getChallengeDataById,
  CHALLENGES_PATH
} from "@leagueplatform/health-journey-api";
var useGetChallengeByIdData = () => {
  const { challengeId } = useParams();
  return useQuery(
    [CHALLENGES_PATH, challengeId],
    () => getChallengeDataById(challengeId),
    // setting a stale time of 5 minutes such that we can access data
    // without re-triggering the request (helpful for analytics)
    // we invalidate the cache when a user signs up and/or leaves the challenge
    // so the staleTime shouldn't cause the UI to be out of date
    { staleTime: 3e5 }
  );
};

// src/hooks/use-challenges-analytics.hook.tsx
var useChallengesAnalytics = () => {
  const { challengeId } = useParams2();
  const { data: challengeData } = useGetChallengeByIdData();
  const baseAnalyticsObj = {
    product_area: PRODUCT_AREA.JOURNEY,
    sub_product_area: SUB_PRODUCT_AREA.CHALLENGES,
    health_campaign_name: challengeData == null ? void 0 : challengeData.data.title,
    health_campaign_id: challengeId,
    challenge_status: challengeData == null ? void 0 : challengeData.data.status,
    health_campaign_type: CHALLENGE_CAMPAIGN_TYPE
  };
  const trackChallengesAnalyticsEvent = (eventType, analyticsProps) => {
    if (challengeData == null ? void 0 : challengeData.data) {
      trackAnalyticsEvent(eventType, __spreadValues(__spreadValues({}, baseAnalyticsObj), analyticsProps));
    }
  };
  return {
    trackChallengesAnalyticsEvent
  };
};

// src/pages/join-team-page/join-team-page.page.tsx
import { EVENT_NAME as EVENT_NAME7 } from "@leagueplatform/analytics";

// src/utils/enrollment-period-status.util.ts
import { isAfter, isBefore, parseISO } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
var getZonedNow = (defaultTimezone) => defaultTimezone ? utcToZonedTime(/* @__PURE__ */ new Date(), defaultTimezone) : /* @__PURE__ */ new Date();
var getZonedDatestring = (dateString, defaultTimezone) => defaultTimezone ? utcToZonedTime(new Date(parseISO(dateString)), defaultTimezone) : new Date(parseISO(dateString));
var isEnrollmentOpen = (startEnroll, endEnroll, defaultTimezone) => {
  const now = getZonedNow(defaultTimezone);
  const start = getZonedDatestring(startEnroll, defaultTimezone);
  const end = getZonedDatestring(endEnroll, defaultTimezone);
  return isAfter(now, start) && isBefore(now, end);
};
var isBeforeEnrollmentPeriod = (startEnroll, defaultTimezone) => {
  const now = getZonedNow(defaultTimezone);
  const start = getZonedDatestring(startEnroll, defaultTimezone);
  return isBefore(now, start);
};
var isAfterEnrollmentPeriod = (endEnroll, defaultTimezone) => {
  const now = getZonedNow(defaultTimezone);
  const end = getZonedDatestring(endEnroll, defaultTimezone);
  return isAfter(now, end);
};

// src/pages/join-team-page/join-team-page.page.tsx
import { handleStaticAsset as handleStaticAsset5 } from "@leagueplatform/asset-config";

// src/hooks/use-get-user-profile.hook.ts
import { useQuery as useQuery2 } from "react-query";
import {
  getUserProfile,
  GET_USER_PROFILE_MESSAGE_TYPE
} from "@leagueplatform/user-profile-api";
var useGetUserProfile = () => useQuery2([GET_USER_PROFILE_MESSAGE_TYPE], () => getUserProfile());

// src/pages/join-team-page/components/teams-option/teams-option.component.tsx
import React14 from "react";
import {
  Flex,
  Box,
  Image,
  HeadingFour,
  BodyTwo
} from "@leagueplatform/genesis-commons";

// src/components/challenge-icon/challenge-icon.component.tsx
import { handleStaticAsset } from "@leagueplatform/asset-config";
var ChallengeIcon = ({ iconType }) => {
  switch (iconType) {
    case "ALERT" /* ALERT */:
      return handleStaticAsset("CHALLENGES_ALERT" /* CHALLENGES_ALERT */, {
        isComponent: true
      });
    case "ARROW" /* ARROW */:
      return handleStaticAsset("CHALLENGES_ARROW" /* CHALLENGES_ARROW */, {
        isComponent: true
      });
    case "CALENDAR" /* CALENDAR */:
      return handleStaticAsset("CHALLENGES_CALENDAR" /* CHALLENGES_CALENDAR */, {
        isComponent: true
      });
    case "CHEVRON" /* CHEVRON */:
      return handleStaticAsset("CHALLENGES_CHEVRON" /* CHALLENGES_CHEVRON */, {
        isComponent: true
      });
    case "CIRCULAR_ARROW" /* CIRCULAR_ARROW */:
      return handleStaticAsset(
        "CHALLENGES_CIRCULAR_ARROW" /* CHALLENGES_CIRCULAR_ARROW */,
        {
          isComponent: true
        }
      );
    case "CLOCK" /* CLOCK */:
      return handleStaticAsset("CHALLENGES_CLOCK" /* CHALLENGES_CLOCK */, {
        isComponent: true
      });
    case "CLOSE" /* CLOSE */:
      return handleStaticAsset("CHALLENGES_CLOSE" /* CHALLENGES_CLOSE */, {
        isComponent: true
      });
    case "COG" /* COG */:
      return handleStaticAsset("CHALLENGES_COG" /* CHALLENGES_COG */, {
        isComponent: true
      });
    case "HYPERLINK" /* HYPERLINK */:
      return handleStaticAsset("CHALLENGES_HYPERLINK" /* CHALLENGES_HYPERLINK */, {
        isComponent: true
      });
    case "LINKOUT" /* LINKOUT */:
      return handleStaticAsset("CHALLENGES_LINKOUT" /* CHALLENGES_LINKOUT */, {
        isComponent: true
      });
    case "PRIZE" /* PRIZE */:
      return handleStaticAsset("CHALLENGES_PRIZE" /* CHALLENGES_PRIZE */, {
        isComponent: true
      });
    case "QUESTION" /* QUESTION */:
      return handleStaticAsset("CHALLENGES_QUESTION" /* CHALLENGES_QUESTION */, {
        isComponent: true
      });
    default:
      return null;
  }
};

// src/pages/join-team-page/components/teams-option/teams-option.component.tsx
import { EVENT_NAME as EVENT_NAME2, PRODUCT_AREA as PRODUCT_AREA2 } from "@leagueplatform/analytics";
var TeamsOption = ({
  image,
  heading,
  description,
  setChoice
}) => {
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME2.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA2.JOURNEY,
    screen_name: "join or create team" /* JOIN_OR_CREATE_TEAM */,
    detail
  });
  const handleClick = () => {
    handleAnalyticsClick(heading.toLowerCase());
    setChoice();
  };
  return /* @__PURE__ */ React14.createElement(
    Flex,
    {
      as: "button",
      paddingY: "two",
      paddingInlineEnd: "two",
      paddingInlineStart: "oneAndHalf",
      marginTop: "half",
      marginBottom: "one",
      borderWidth: "thin",
      borderRadius: "medium",
      borderColor: "onSurface.border.subdued",
      backgroundColor: "tertiary.background.default",
      alignItems: "center",
      width: "100%",
      onClick: handleClick
    },
    /* @__PURE__ */ React14.createElement(
      Image,
      {
        src: image,
        alt: "",
        size: "four",
        "aria-hidden": true,
        display: { _: "none", phone: "block" }
      }
    ),
    /* @__PURE__ */ React14.createElement(
      Box,
      {
        textAlign: "start",
        marginInlineStart: { phone: "oneAndHalf" },
        marginInlineEnd: { _: "two", phone: "four", tablet: "three" }
      },
      /* @__PURE__ */ React14.createElement(HeadingFour, { as: "p" }, heading),
      description && /* @__PURE__ */ React14.createElement(BodyTwo, { marginTop: "half" }, description)
    ),
    /* @__PURE__ */ React14.createElement(Box, { transform: "rotate(180deg)", marginInlineStart: "auto" }, /* @__PURE__ */ React14.createElement(ChallengeIcon, { iconType: "CHEVRON" /* CHEVRON */ }))
  );
};

// src/pages/join-team-page/components/join-team/join-team.component.tsx
import React18, { useState } from "react";
import { useParamsLegacy as useParams5 } from "@leagueplatform/routing";
import {
  BackButtonArrow,
  FullPageError,
  LoadingIndicator
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import {
  Box as Box4,
  Flex as Flex3,
  HeadingThree,
  TextField,
  VisuallyHidden,
  Label,
  LabelText
} from "@leagueplatform/genesis-commons";

// src/pages/join-team-page/hooks/use-get-all-teams.hook.ts
import { useParamsLegacy as useParams3 } from "@leagueplatform/routing";
import { useQuery as useQuery3 } from "react-query";
import {
  getAllTeams
} from "@leagueplatform/health-journey-api";
var ALL_TEAMS_QUERY_KEY = "allTeams";
var useGetAllTeams = () => {
  const { challengeId } = useParams3();
  return useQuery3(
    [ALL_TEAMS_QUERY_KEY, challengeId],
    () => getAllTeams(challengeId),
    {
      enabled: !!challengeId
    }
  );
};

// src/pages/join-team-page/components/join-team/join-team.component.tsx
import { JOURNEY_ROUTES as JOURNEY_ROUTES2 } from "@leagueplatform/health-journey-common";

// src/pages/join-team-page/components/teams-list/teams-list.component.tsx
import React17 from "react";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { Box as Box3, BodyTwoSecondary } from "@leagueplatform/genesis-commons";

// src/pages/join-team-page/components/teams-list-item/teams-list-item.component.tsx
import React16 from "react";
import {
  Flex as Flex2,
  Box as Box2,
  SubtitleTwo,
  Caption
} from "@leagueplatform/genesis-commons";

// src/components/challenge-profile-picture/challenge-profile-picture.component.tsx
import React15 from "react";
import { CoverImage, BodyOne } from "@leagueplatform/genesis-commons";

// src/utils/format-user-name.util.ts
var formatUserName = ({
  firstName,
  lastName,
  isInitials
}) => {
  if (isInitials) {
    return `${firstName.charAt(0)} ${lastName.charAt(0)}`;
  }
  return `${firstName} ${lastName.charAt(0)}.`;
};

// src/components/challenge-profile-picture/challenge-profile-picture.component.tsx
import { StackLayout } from "@leagueplatform/genesis-core";
var ChallengeProfilePicture = ({
  profilePicture,
  firstName,
  lastName,
  isOnPodium,
  backgroundColor = "$decorativeBrandPrimaryDefault"
}) => {
  if (profilePicture) {
    return /* @__PURE__ */ React15.createElement(
      CoverImage,
      {
        alt: "",
        borderRadius: "circle",
        size: "100%",
        src: profilePicture,
        role: "presentation"
      }
    );
  }
  return /* @__PURE__ */ React15.createElement(
    StackLayout,
    {
      horizontalAlignment: "center",
      css: {
        backgroundColor,
        borderRadius: "$circle",
        justifyContent: "center",
        size: "100%"
      }
    },
    /* @__PURE__ */ React15.createElement(
      BodyOne,
      __spreadValues({
        color: "onSurface.text.reversed",
        fontWeight: "bold"
      }, isOnPodium && { fontSize: "heading2" }),
      formatUserName({
        firstName,
        lastName,
        isInitials: true
      })
    )
  );
};

// src/pages/join-team-page/components/teams-list-item/teams-list-item.component.tsx
import { JOURNEY_ROUTES } from "@leagueplatform/health-journey-common";
import {
  LinkLegacy as Link,
  useParamsLegacy as useParams4
} from "@leagueplatform/routing";
import { useIntl } from "@leagueplatform/locales";
var TeamListItem = ({
  teamId,
  teamName,
  avatar: avatar2,
  maxMembers,
  memberCount
}) => {
  const { formatMessage } = useIntl();
  const { challengeId } = useParams4();
  const spotsAvailable = maxMembers - memberCount;
  return /* @__PURE__ */ React16.createElement("li", { key: teamId }, /* @__PURE__ */ React16.createElement(
    Flex2,
    {
      as: Link,
      to: JOURNEY_ROUTES.getChallengeTeamDetails(challengeId, `${teamId}`),
      padding: "one",
      textDecoration: "none",
      borderTop: "1px solid",
      borderColor: "onSurface.border.subdued",
      alignItems: "center",
      justifyContent: "space-between"
    },
    /* @__PURE__ */ React16.createElement(Flex2, null, /* @__PURE__ */ React16.createElement(Box2, { size: "twoAndHalf" }, /* @__PURE__ */ React16.createElement(
      ChallengeProfilePicture,
      {
        profilePicture: avatar2,
        firstName: teamName,
        lastName: ""
      }
    )), /* @__PURE__ */ React16.createElement(Box2, { marginInlineStart: "one" }, /* @__PURE__ */ React16.createElement(SubtitleTwo, { as: "p" }, teamName), /* @__PURE__ */ React16.createElement(Caption, null, formatMessage(
      { id: "X_TEAM_MEMBERS" },
      { memberTotal: memberCount }
    ), " ", "\u2022 ", formatMessage({ id: "X_SPOTS_AVAILABLE" }, { spotsAvailable })))),
    /* @__PURE__ */ React16.createElement(Box2, { transform: "rotate(180deg)" }, /* @__PURE__ */ React16.createElement(ChallengeIcon, { iconType: "CHEVRON" /* CHEVRON */ }))
  ));
};

// src/pages/join-team-page/components/teams-list/teams-list.component.tsx
var TeamsList = ({ teamsList }) => {
  const { formatMessage } = useIntl2();
  return /* @__PURE__ */ React17.createElement(Box3, { "aria-live": "polite", width: "100%" }, /* @__PURE__ */ React17.createElement(BodyTwoSecondary, { marginBottom: "half" }, formatMessage({ id: "RESULT_COUNT" }, { count: teamsList.length })), /* @__PURE__ */ React17.createElement(
    Box3,
    { as: "ul" },
    // Returning a new array based on a search term match
    teamsList.map((team) => {
      const { id, name, avatarUrl, maxMembers, memberCount } = team;
      return /* @__PURE__ */ React17.createElement(
        TeamListItem,
        {
          teamId: id,
          teamName: name,
          avatar: avatarUrl,
          maxMembers,
          memberCount,
          key: id
        }
      );
    })
  ));
};

// src/pages/join-team-page/components/join-team/join-team.component.tsx
var JoinTeam = ({ backTo }) => {
  var _a;
  const { challengeId } = useParams5();
  const { formatMessage } = useIntl3();
  const [searchTerm, setSearchTerm] = useState("");
  const { isLoading, error, data: allTeamsData } = useGetAllTeams();
  if (isLoading)
    return /* @__PURE__ */ React18.createElement(LoadingIndicator, null);
  if (error || !(allTeamsData == null ? void 0 : allTeamsData.data))
    return /* @__PURE__ */ React18.createElement(
      FullPageError,
      {
        route: JOURNEY_ROUTES2.getChallengeJoinTeam(challengeId),
        error
      }
    );
  const teamsList = (_a = allTeamsData == null ? void 0 : allTeamsData.data) == null ? void 0 : _a.filter(
    (team) => team.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return /* @__PURE__ */ React18.createElement(
    Box4,
    {
      maxWidth: CONTENT_MAX_WIDTH,
      marginX: { _: "twoAndHalf", tablet: "auto" },
      marginY: { _: "twoAndHalf", tablet: "five" }
    },
    /* @__PURE__ */ React18.createElement(Flex3, { alignItems: "center", width: "100%" }, /* @__PURE__ */ React18.createElement(
      BackButtonArrow,
      {
        onClick: backTo,
        marginTop: "quarter",
        marginInlineStart: { _: "none", laptop: "minusTwo" }
      }
    ), /* @__PURE__ */ React18.createElement(HeadingThree, { as: "h1", marginInlineStart: "half" }, formatMessage({ id: "SEARCH_FOR_TEAM" }))),
    /* @__PURE__ */ React18.createElement(Box4, { width: "100%" }, /* @__PURE__ */ React18.createElement("form", { onSubmit: (e) => e.preventDefault(), role: "search" }, /* @__PURE__ */ React18.createElement(Label, { htmlFor: "team_search" }, /* @__PURE__ */ React18.createElement(VisuallyHidden, null, /* @__PURE__ */ React18.createElement(LabelText, null, formatMessage({ id: "SEARCH_FOR_TEAM" })))), /* @__PURE__ */ React18.createElement(
      TextField,
      {
        name: "team_search",
        id: "team_search",
        type: "search",
        onChange: (e) => {
          setSearchTerm(e.currentTarget.value);
        },
        placeholder: formatMessage({ id: "SEARCH_FOR_TEAM" }),
        height: "three",
        width: "100%",
        marginTop: "two",
        marginBottom: { _: "one", laptop: "two" }
      }
    ))),
    /* @__PURE__ */ React18.createElement(TeamsList, { teamsList })
  );
};

// src/pages/join-team-page/components/join-team-page-skeleton-loader/join-team-page-skeleton-loader.component.tsx
import React19 from "react";
import { Flex as Flex4 } from "@leagueplatform/genesis-commons";
import {
  BackButtonArrow as BackButtonArrow2,
  SkeletonBox
} from "@leagueplatform/web-common-components";
import {
  LinkLegacy as Link2,
  useParamsLegacy as useParams6
} from "@leagueplatform/routing";
import { JOURNEY_ROUTES as JOURNEY_ROUTES3 } from "@leagueplatform/health-journey-common";
var JoinTeamPageSkeletonLoader = () => {
  const { challengeId } = useParams6();
  return /* @__PURE__ */ React19.createElement(
    Flex4,
    {
      as: "section",
      flexDirection: { _: "column", laptop: "row" },
      alignItems: { _: "center", laptop: "initial" },
      padding: { _: "oneAndHalf", phone: "twoAndHalf" },
      marginTop: "two",
      justifyContent: "center"
    },
    /* @__PURE__ */ React19.createElement(Flex4, { marginBottom: "twoAndHalf", width: "100%", maxWidth: CONTENT_MAX_WIDTH }, /* @__PURE__ */ React19.createElement(
      BackButtonArrow2,
      {
        as: Link2,
        justifyContent: "initial",
        marginInlineEnd: { _: "one", phone: "twoAndHalf" },
        marginY: "half",
        onClick: noopFunction,
        to: JOURNEY_ROUTES3.getChallengeDetails(challengeId),
        size: "three",
        marginTop: "half"
      }
    ), /* @__PURE__ */ React19.createElement(Flex4, { flexDirection: "column", width: "100%" }, /* @__PURE__ */ React19.createElement(
      SkeletonBox,
      {
        width: "100%",
        maxWidth: CONTENT_MAX_WIDTH,
        height: "100px",
        backgroundColor: "interactive.background.disabled",
        role: "presentation",
        marginTop: "half"
      }
    ), /* @__PURE__ */ React19.createElement(
      SkeletonBox,
      {
        backgroundColor: "interactive.background.disabled",
        marginTop: "two",
        height: "160px",
        role: "presentation"
      }
    ), /* @__PURE__ */ React19.createElement(
      SkeletonBox,
      {
        backgroundColor: "interactive.background.disabled",
        marginTop: "one",
        height: "160px",
        role: "presentation"
      }
    )))
  );
};

// src/pages/join-team-page/constants/join-team-page.constants.ts
var JOIN_TEAM_CONTAINER_MAX_WIDTH = "1080px";
var JOIN_TEAM_PROFILE_PICTURE_SIZE = "180px";
var INPUT_MAX_WIDTH = "483px";

// src/pages/join-team-page/components/create-team/create-team.component.tsx
import React28, { useEffect as useEffect2, useState as useState2 } from "react";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import {
  Box as Box9,
  Flex as Flex8,
  HeadingOne,
  HeadingThree as HeadingThree2,
  Link as Link4,
  PrimaryButton as PrimaryButton3,
  Label as Label3,
  LabelText as LabelText2,
  TextInput as TextInput2,
  VisuallyHidden as VisuallyHidden4
} from "@leagueplatform/genesis-commons";
import { EVENT_NAME as EVENT_NAME6 } from "@leagueplatform/analytics";
import { Formik as Formik2, Form as Form2, Field as Field2 } from "formik";
import { BackButtonArrow as BackButtonArrow3 } from "@leagueplatform/web-common-components";

// src/components/choose-profile-picture/choose-profile-picture.component.tsx
import React20 from "react";
import { CoverImage as CoverImage2 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
var ChooseProfilePicture = ({
  photoUrl,
  size
}) => {
  const { formatMessage } = useIntl4();
  const camera2 = handleStaticAsset2(
    "CHALLENGES_CAMERA" /* CHALLENGES_CAMERA */
  );
  return /* @__PURE__ */ React20.createElement(
    CoverImage2,
    {
      src: (photoUrl == null ? void 0 : photoUrl.length) ? photoUrl : camera2,
      alt: (photoUrl == null ? void 0 : photoUrl.length) ? formatMessage({ id: "PROFILE_PHOTO" }) : "",
      size,
      alignSelf: "center",
      borderRadius: "circle",
      role: photoUrl ? "img" : "presentation"
    }
  );
};

// src/components/error-with-icon/error-with-icon.component.tsx
import React21 from "react";
import { ErrorMessage } from "@leagueplatform/genesis-commons";
var ErrorWithIcon = ({ errorMessage }) => /* @__PURE__ */ React21.createElement(
  ErrorMessage,
  {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "two",
    role: "alert"
  },
  /* @__PURE__ */ React21.createElement(ChallengeIcon, { iconType: "ALERT" /* ALERT */ }),
  /* @__PURE__ */ React21.createElement(ErrorMessage, { as: "span", marginInlineStart: "one" }, errorMessage)
);

// src/pages/join-team-page/hooks/use-create-team.hook.ts
import { useParamsLegacy as useParams7 } from "@leagueplatform/routing";
import { useMutation } from "react-query";
import { postCreateTeam } from "@leagueplatform/health-journey-api";
import { toastActions, TOAST_STATUS } from "@leagueplatform/toast-messages";
import { EVENT_NAME as EVENT_NAME3 } from "@leagueplatform/analytics";
var useCreateTeam = (setTeamId, setDisplayCreateTeamSuccess) => {
  const { challengeId } = useParams7();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  return useMutation(
    ({ teamName, teamPhoto }) => postCreateTeam({ challengeId, teamName, teamPhoto }),
    {
      onSuccess: (response) => {
        trackChallengesAnalyticsEvent(EVENT_NAME3.BUTTON_CLICKED, {
          screen_name: "create team" /* CREATE_TEAM */,
          detail: "create team" /* CREATE_TEAM */
        });
        setTeamId(response.data.id);
        setDisplayCreateTeamSuccess(true);
      },
      onError: () => {
        toastActions.add({
          type: TOAST_STATUS.ERROR,
          textId: "UNABLE_TO_CREATE_TEAM",
          shouldAutoClose: false
        });
      }
    }
  );
};

// src/pages/join-team-page/components/team-photo-modal/team-photo-modal.component.tsx
import React24 from "react";
import { Box as Box5 } from "@leagueplatform/genesis-commons";
import { Modal } from "@leagueplatform/genesis-core";

// src/components/select-avatar/select-avatar.component.tsx
import React23 from "react";
import { Formik, Form } from "formik";
import { EVENT_NAME as EVENT_NAME4 } from "@leagueplatform/analytics";
import {
  HeadingTwo,
  BodyOneSecondary,
  Flex as Flex5,
  PrimaryButton,
  ErrorMessage as ErrorMessage2,
  css as css2,
  genesisStyled as genesisStyled2,
  Spinner
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import { CHALLENGE_TYPES as CHALLENGE_TYPES2 } from "@leagueplatform/health-journey-api";
import { ErrorState } from "@leagueplatform/web-common-components";

// src/hooks/use-get-avatars.hook.ts
import { useQuery as useQuery4 } from "react-query";
import {
  getAvatars
} from "@leagueplatform/health-journey-api";
var GET_AVATARS_QUERY_KEY = "getAvatarsData";
var useGetAvatars = (avatarType) => useQuery4(
  [GET_AVATARS_QUERY_KEY, avatarType],
  () => getAvatars(avatarType)
);

// src/components/select-avatar/avatar-radio-option/avatar-radio-option.component.tsx
import React22 from "react";
import {
  Label as Label2,
  CoverImage as CoverImage3,
  Image as Image2,
  VisuallyHidden as VisuallyHidden2
} from "@leagueplatform/genesis-commons";
import { Field } from "formik";
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";
var AvatarRadioOption = ({
  image,
  alt,
  selected,
  value,
  disabled
}) => {
  const labelRef = React22.useRef(null);
  const inputId = `avatar_input_${value}`;
  const checkmark2 = handleStaticAsset3(
    "CHALLENGES_CHECKMARK" /* CHALLENGES_CHECKMARK */
  );
  return /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(VisuallyHidden2, null, /* @__PURE__ */ React22.createElement(
    Field,
    {
      id: inputId,
      type: "radio",
      name: "selectedAvatar",
      value,
      onFocus: () => {
        var _a;
        return (_a = labelRef.current) == null ? void 0 : _a.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      },
      disabled
    }
  )), /* @__PURE__ */ React22.createElement(
    Label2,
    __spreadProps(__spreadValues({
      htmlFor: inputId,
      borderRadius: "circle",
      size: PROFILE_PICTURE_SIZE,
      margin: "threeQuarters",
      padding: "quarter",
      position: "relative"
    }, selected && {
      borderColor: "success.border.default",
      borderWidth: "thicker",
      padding: "none"
    }), {
      ref: labelRef
    }),
    /* @__PURE__ */ React22.createElement(CoverImage3, { src: image, size: "100%", alt, borderRadius: "circle" }),
    selected && /* @__PURE__ */ React22.createElement(
      Image2,
      {
        src: checkmark2,
        alt: "",
        position: "absolute",
        bottom: "quarter",
        insetInlineEnd: "quarter",
        width: "oneAndHalf"
      }
    )
  ));
};

// src/components/select-avatar/select-avatar.component.tsx
var AVATAR_SELECT_LABEL = "selectAvatarLabel";
var AVATAR_SELECT_DESCRIPTION = "selectAvatarDescription";
var { SELECT_TEAM_AVATAR } = SIGN_UP_ANALYTICS_SCREEN_NAMES;
var { CONFIRM } = SIGN_UP_ANALYTICS_DETAILS;
var StyledForm = genesisStyled2(Form)`
  width: 100%;
  margin: 0 auto;
`;
var SelectAvatar = ({
  challengeType,
  onSubmit,
  signUpIsLoading
}) => {
  var _a;
  const { formatMessage, $tifelse } = useIntl5();
  const isChallengeTypeUser = challengeType === CHALLENGE_TYPES2.USER;
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const {
    isLoading,
    error,
    data: avatarData
  } = useGetAvatars(
    isChallengeTypeUser ? CHALLENGE_TYPES2.USER : CHALLENGE_TYPES2.TEAM
  );
  const handleSubmitAnalytics = () => trackChallengesAnalyticsEvent(EVENT_NAME4.BUTTON_CLICKED, {
    screen_name: SELECT_TEAM_AVATAR,
    detail: CONFIRM
  });
  const initialValues = {
    selectedAvatar: ""
  };
  if (isLoading)
    return /* @__PURE__ */ React23.createElement(
      Flex5,
      {
        justifyContent: "center",
        color: "decorative.brand.primary.default",
        height: PROFILE_SELECT_CONTAINER_FIXED_HEIGHT
      },
      /* @__PURE__ */ React23.createElement(Spinner, { isLoading: true })
    );
  if (error || !((_a = avatarData == null ? void 0 : avatarData.data) == null ? void 0 : _a.length))
    return /* @__PURE__ */ React23.createElement(
      ErrorState,
      {
        headingString: formatMessage({ id: "GET_AVATARS_ERROR" }),
        hideButton: true,
        error
      }
    );
  return /* @__PURE__ */ React23.createElement(
    Flex5,
    {
      flexDirection: "column",
      textAlign: isChallengeTypeUser ? "center" : "start",
      alignItems: isChallengeTypeUser ? "center" : "normal"
    },
    /* @__PURE__ */ React23.createElement(
      HeadingTwo,
      {
        id: AVATAR_SELECT_LABEL,
        fontSize: isChallengeTypeUser ? "heading2" : CREATE_TEAM_MODAL_HEADING_FONT
      },
      formatMessage({
        id: "SELECT_AVATAR"
      })
    ),
    /* @__PURE__ */ React23.createElement(
      BodyOneSecondary,
      {
        marginTop: "one",
        marginBottom: isChallengeTypeUser ? "oneAndHalf" : "two",
        id: AVATAR_SELECT_DESCRIPTION
      },
      $tifelse(
        isChallengeTypeUser,
        "PROFILE_PHOTO_DESCRIPTION",
        "TEAMS_SELECT_AVATAR_DESCRIPTION"
      )
    ),
    /* @__PURE__ */ React23.createElement(
      Formik,
      {
        initialValues,
        onSubmit: (values) => {
          handleSubmitAnalytics();
          onSubmit(values.selectedAvatar);
        },
        validate: (values) => {
          const errors = {};
          if (values.selectedAvatar === "") {
            errors.selectedAvatar = formatMessage({
              id: "SELECT_AVATAR_ERROR"
            });
          }
          return errors;
        },
        validateOnBlur: false,
        validateOnChange: false
      },
      ({ values, errors }) => /* @__PURE__ */ React23.createElement(StyledForm, null, /* @__PURE__ */ React23.createElement(
        Flex5,
        {
          "aria-describedby": AVATAR_SELECT_DESCRIPTION,
          "aria-labelledby": AVATAR_SELECT_LABEL,
          borderColor: "secondary.border.default",
          borderStyle: "dashed",
          borderWidth: "thin",
          css: css2({
            "&:focus-within": {
              boxShadow: "focusRing"
            }
          }),
          flexWrap: "wrap",
          height: PROFILE_SELECT_CONTAINER_FIXED_HEIGHT,
          justifyContent: "space-around",
          marginX: "auto",
          maxWidth: CONTENT_MAX_WIDTH,
          overflow: "auto",
          padding: "one",
          role: "radiogroup"
        },
        avatarData.data.map(({ id, name, url }) => /* @__PURE__ */ React23.createElement(
          AvatarRadioOption,
          {
            key: id,
            image: url,
            alt: name,
            value: url,
            selected: values.selectedAvatar === url,
            disabled: signUpIsLoading
          }
        ))
      ), /* @__PURE__ */ React23.createElement(
        Flex5,
        {
          flexDirection: "column",
          maxWidth: isChallengeTypeUser ? BUTTON_CONTAINER_MAX_WIDTH : "unset",
          marginInlineStart: "auto",
          marginInlineEnd: "auto"
        },
        errors.selectedAvatar && /* @__PURE__ */ React23.createElement(
          ErrorMessage2,
          {
            display: "flex",
            alignItems: "center",
            alignSelf: isChallengeTypeUser ? "normal" : "center",
            marginTop: "two",
            role: "alert"
          },
          /* @__PURE__ */ React23.createElement(ChallengeIcon, { iconType: "ALERT" /* ALERT */ }),
          /* @__PURE__ */ React23.createElement(ErrorMessage2, { as: "span", marginInlineStart: "one" }, errors.selectedAvatar)
        ),
        /* @__PURE__ */ React23.createElement(
          PrimaryButton,
          {
            alignSelf: isChallengeTypeUser ? "normal" : "flex-end",
            marginTop: (
              // Fix this!
              // eslint-disable-next-line no-nested-ternary
              isChallengeTypeUser ? errors.selectedAvatar ? "two" : "five" : "oneAndHalf"
            ),
            marginBottom: isChallengeTypeUser ? "oneAndHalf" : "none",
            width: "100%",
            maxWidth: isChallengeTypeUser ? "unset" : CREATE_TEAM_BUTTON_CONTAINER_MAX_WIDTH,
            type: "submit",
            isLoading: signUpIsLoading
          },
          formatMessage({
            id: "CONFIRM"
          })
        )
      ))
    )
  );
};

// src/pages/join-team-page/components/team-photo-modal/team-photo-modal.component.tsx
import { CHALLENGE_TYPES as CHALLENGE_TYPES3 } from "@leagueplatform/health-journey-api";

// src/utils/get-file-from-image-url.util.ts
var getFileFromImageUrl = (imageUrl, newFileName) => __async(void 0, null, function* () {
  const res = yield fetch(imageUrl);
  const imageBlob = yield res.blob();
  return new File([imageBlob], newFileName);
});

// src/hooks/use-upload-profile-photo.hooks.ts
import { toastActions as toastActions2, TOAST_STATUS as TOAST_STATUS2 } from "@leagueplatform/toast-messages";
import { useMutation as useMutation2, useQueryClient } from "react-query";
import { uploadFile } from "@leagueplatform/league-content-api";
import {
  setUserProfile,
  GET_USER_PROFILE_MESSAGE_TYPE as GET_USER_PROFILE_MESSAGE_TYPE2
} from "@leagueplatform/user-profile-api";
var useUploadUserProfilePhoto = () => {
  const uploadProfilePhoto = useMutation2((file) => uploadFile(file));
  return (file) => __async(void 0, null, function* () {
    try {
      const response = yield uploadProfilePhoto.mutateAsync(file);
      const referenceId = response == null ? void 0 : response.reference_id;
      if (!referenceId)
        throw new Error();
      return referenceId;
    } catch (error) {
      toastActions2.add({
        type: TOAST_STATUS2.ERROR,
        textId: "PROFILE_UPDATE_FAILED"
      });
    }
  });
};

// src/pages/join-team-page/components/team-photo-modal/team-photo-modal.component.tsx
var TeamPhotoModal = ({
  displayTeamPhotoModal,
  closeTeamPhotoModal,
  setTeamPhotoUrl,
  setTeamPhotoRefId
}) => {
  const modalOnDismiss = () => {
    closeTeamPhotoModal();
  };
  const uploadTeamPhoto = useUploadUserProfilePhoto();
  const confirmTeamProfilePhoto = (photoUrl) => __async(void 0, null, function* () {
    const file = yield getFileFromImageUrl(photoUrl, "teamPhoto");
    const teamPhotoId = yield uploadTeamPhoto(file);
    setTeamPhotoUrl(photoUrl);
    setTeamPhotoRefId(teamPhotoId);
    modalOnDismiss();
  });
  return /* @__PURE__ */ React24.createElement(Modal.Root, { open: displayTeamPhotoModal, onOpenChange: modalOnDismiss }, /* @__PURE__ */ React24.createElement(Box5, { paddingX: { tablet: "one" }, paddingTop: { tablet: "one" } }, /* @__PURE__ */ React24.createElement(Modal.Content, { width: "66vw" }, /* @__PURE__ */ React24.createElement(
    SelectAvatar,
    {
      challengeType: CHALLENGE_TYPES3.TEAM,
      onSubmit: confirmTeamProfilePhoto,
      signUpIsLoading: false
    }
  ))));
};

// src/pages/join-team-page/components/create-team/create-team-success.component.tsx
import React27 from "react";
import { useParamsLegacy as useParams8 } from "@leagueplatform/routing";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import {
  Box as Box8,
  HeadingTwo as HeadingTwo2,
  BodyOne as BodyOne2,
  Link as Link3
} from "@leagueplatform/genesis-commons";

// src/components/modal-content-with-image/modal-content-with-image.component.tsx
import React25 from "react";
import {
  Flex as Flex6,
  Image as Image3,
  CoverImage as CoverImage4,
  Box as Box6
} from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset4 } from "@leagueplatform/asset-config";
var MODAL_CONTENT_MAXWIDTH = { _: "445px", tablet: CONTENT_MAX_WIDTH };
var MODAL_IMAGE_MAXWIDTH = { _: "150px", tablet: "240px" };
var CONFETTI_WIDTH = { _: "247px", phone: "308px" };
var CONFETTI_HEIGHT = { _: "227px", phone: "284px" };
var PROFILE_PICTURE_SIZE2 = { _: "160px", phone: "200px" };
var PROFILE_TOP_VALUE = { _: "35px", phone: "45px" };
var PROFILE_INLINE_START_VALUE = { _: "45px", phone: "60px" };
var ModalContentWithImage = ({
  image,
  children,
  isSuccessScreen,
  marginTop
}) => {
  const confetti2 = handleStaticAsset4(
    "CHALLENGES_CONFETTI" /* CHALLENGES_CONFETTI */
  );
  return /* @__PURE__ */ React25.createElement(
    Flex6,
    {
      width: "100%",
      maxWidth: MODAL_CONTENT_MAXWIDTH,
      margin: "none",
      marginInlineStart: "auto",
      marginInlineEnd: "auto",
      marginTop: marginTop != null ? marginTop : "none",
      justifyContent: "space-between",
      alignItems: isSuccessScreen ? "center" : "flex-start",
      flexDirection: { _: "column", tablet: "row" }
    },
    isSuccessScreen ? /* @__PURE__ */ React25.createElement(
      Box6,
      {
        position: "relative",
        marginBottom: { _: "one", tablet: "unset" },
        marginInlineStart: { _: "auto", tablet: "unset" },
        marginInlineEnd: { _: "auto", tablet: "four" }
      },
      /* @__PURE__ */ React25.createElement(
        CoverImage4,
        {
          src: image.src,
          alt: "",
          borderRadius: "circle",
          insetInlineStart: PROFILE_INLINE_START_VALUE,
          position: "absolute",
          size: PROFILE_PICTURE_SIZE2,
          top: PROFILE_TOP_VALUE,
          role: "presentation"
        }
      ),
      /* @__PURE__ */ React25.createElement(
        CoverImage4,
        {
          src: confetti2,
          alt: "",
          height: CONFETTI_HEIGHT,
          position: "relative",
          width: CONFETTI_WIDTH,
          role: "presentation"
        }
      )
    ) : /* @__PURE__ */ React25.createElement(
      Image3,
      {
        src: image.src,
        alt: image.alt,
        maxWidth: MODAL_IMAGE_MAXWIDTH,
        marginInlineEnd: { _: "auto", tablet: "four" },
        marginInlineStart: { _: "auto", tablet: "unset" },
        marginBottom: { _: "one", tablet: "unset" }
      }
    ),
    /* @__PURE__ */ React25.createElement(Flex6, { flexDirection: "column", width: "100%" }, children)
  );
};

// src/components/copy-link/copy-link.component.tsx
import React26, { useEffect, useRef } from "react";
import {
  VisuallyHidden as VisuallyHidden3,
  TextInput,
  PrimaryButton as PrimaryButton2,
  Flex as Flex7,
  Box as Box7
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { toastActions as toastActions3, TOAST_STATUS as TOAST_STATUS3 } from "@leagueplatform/toast-messages";
var CopyLink = ({
  joinTeamLink = window.location.href,
  onClick
}) => {
  const { formatMessage } = useIntl6();
  const TEAM_INVITE_LINK_INPUT = "teamInviteLinkInput";
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef == null ? void 0 : inputRef.current) {
      inputRef.current.selectionStart = 0;
      inputRef.current.selectionEnd = 0;
    }
  }, [inputRef]);
  const copyLinkOnClick = () => __async(void 0, null, function* () {
    try {
      yield navigator.clipboard.writeText(joinTeamLink);
      toastActions3.add({
        type: TOAST_STATUS3.SUCCESS,
        textId: "INVITE_LINK_COPIED_TO_CLIPBOARD"
      });
    } catch (e) {
      toastActions3.add({
        type: TOAST_STATUS3.ERROR,
        textId: "UNABLE_TO_COPY_TO_CLIPBOARD"
      });
    }
  });
  const handleCopyLinkClick = () => {
    copyLinkOnClick();
    onClick == null ? void 0 : onClick();
  };
  return /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(VisuallyHidden3, null, /* @__PURE__ */ React26.createElement("label", { htmlFor: TEAM_INVITE_LINK_INPUT }, formatMessage({
    id: "TEAM_INVITE_LINK"
  }))), /* @__PURE__ */ React26.createElement(
    TextInput,
    {
      id: TEAM_INVITE_LINK_INPUT,
      name: TEAM_INVITE_LINK_INPUT,
      readOnly: true,
      value: joinTeamLink,
      width: "100%",
      ref: inputRef
    }
  ), /* @__PURE__ */ React26.createElement(PrimaryButton2, { marginTop: "two", onClick: handleCopyLinkClick, width: "100%" }, /* @__PURE__ */ React26.createElement(Flex7, { justifyContent: "center", alignItems: "center" }, /* @__PURE__ */ React26.createElement(ChallengeIcon, { iconType: "HYPERLINK" /* HYPERLINK */ }), /* @__PURE__ */ React26.createElement(Box7, { as: "span", marginInlineStart: "half" }, formatMessage({ id: "COPY" })))));
};

// src/pages/join-team-page/components/create-team/create-team-success.component.tsx
import { JOURNEY_ROUTES as JOURNEY_ROUTES4 } from "@leagueplatform/health-journey-common";
import highFive2 from "./assets/highFive.png";
import { EVENT_NAME as EVENT_NAME5 } from "@leagueplatform/analytics";
var MODAL_CONTENT_MARGIN_TOP = {
  _: "none",
  tablet: "five"
};
var CreateTeamSuccess = ({
  teamPhoto,
  teamId
}) => {
  const { formatMessage } = useIntl7();
  const { challengeId } = useParams8();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const generateTLPUrl = () => {
    const baseUrl = window.location.origin;
    const teamDetailsUrlSegment = JOURNEY_ROUTES4.getChallengeTeamDetails(
      challengeId,
      teamId
    );
    return baseUrl + teamDetailsUrlSegment;
  };
  const handleAnalyticsClick = (detail) => {
    trackChallengesAnalyticsEvent(EVENT_NAME5.BUTTON_CLICKED, {
      screen_name: "create team success" /* CREATE_TEAM_SUCCESS */,
      detail
    });
  };
  return /* @__PURE__ */ React27.createElement(Box8, { paddingTop: { _: "four", tablet: "five" } }, /* @__PURE__ */ React27.createElement(
    ModalContentWithImage,
    {
      image: {
        src: (teamPhoto == null ? void 0 : teamPhoto.length) ? teamPhoto : highFive2,
        alt: ""
      },
      marginTop: MODAL_CONTENT_MARGIN_TOP,
      isSuccessScreen: true
    },
    /* @__PURE__ */ React27.createElement(HeadingTwo2, { marginTop: "oneAndHalf" }, formatMessage({ id: "CREATE_TEAM_SUCCESS" })),
    /* @__PURE__ */ React27.createElement(BodyOne2, { marginTop: "one", marginBottom: "two" }, formatMessage({ id: "CREATE_TEAM_SUCCESS_DESCRIPTION" })),
    /* @__PURE__ */ React27.createElement(
      CopyLink,
      {
        joinTeamLink: generateTLPUrl(),
        onClick: () => handleAnalyticsClick("copy" /* COPY */)
      }
    ),
    /* @__PURE__ */ React27.createElement(Box8, { width: "100%", textAlign: "center" }, /* @__PURE__ */ React27.createElement(
      Link3,
      {
        href: JOURNEY_ROUTES4.getChallengeTeamDetails(challengeId, teamId),
        marginTop: "two",
        onClick: () => handleAnalyticsClick("view team details" /* VIEW_TEAM_DETAILS */)
      },
      formatMessage({ id: "VIEW_TEAM_DETAILS" })
    ))
  ));
};

// src/pages/join-team-page/components/create-team/create-team.component.tsx
var CreateTeam = ({ backTo }) => {
  const { formatMessage, $tifelse } = useIntl8();
  const [teamPhotoUrl, setTeamPhotoUrl] = useState2("");
  const [teamPhotoRefId, setTeamPhotoRefId] = useState2("");
  const [displayTeamPhotoModal, setDisplayTeamPhotoModal] = useState2(false);
  const [displayCreateTeamSuccess, setDisplayCreateTeamSuccess] = useState2(false);
  const [teamId, setTeamId] = useState2("");
  const createTeamMutation = useCreateTeam(
    setTeamId,
    setDisplayCreateTeamSuccess
  );
  const createNewTeam = (values) => {
    createTeamMutation.mutate({
      teamName: values.teamName,
      teamPhoto: teamPhotoRefId
    });
  };
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  useEffect2(() => {
    trackChallengesAnalyticsEvent(EVENT_NAME6.SCREEN_LOADED, {
      screen_name: "create team" /* CREATE_TEAM */
    });
  }, []);
  const handleOnClickAvatarLink = () => {
    trackChallengesAnalyticsEvent(EVENT_NAME6.BUTTON_CLICKED, {
      screen_name: "create team" /* CREATE_TEAM */,
      detail: teamPhotoUrl ? "change team avatar" /* CHANGE_TEAM_AVATAR */ : "select team avatar" /* SELECT_TEAM_AVATAR */
    });
    setDisplayTeamPhotoModal(true);
  };
  return /* @__PURE__ */ React28.createElement(
    Box9,
    {
      marginX: { _: "two", tablet: "three", desktop: "auto" },
      marginY: { _: "twoAndHalf", tablet: "five" },
      maxWidth: JOIN_TEAM_CONTAINER_MAX_WIDTH
    },
    !displayCreateTeamSuccess && /* @__PURE__ */ React28.createElement(Flex8, { alignItems: "center" }, /* @__PURE__ */ React28.createElement(BackButtonArrow3, { onClick: backTo, marginTop: "half" }), /* @__PURE__ */ React28.createElement(
      HeadingThree2,
      {
        as: "p",
        marginInlineStart: { _: "half", tablet: "oneAndHalf" }
      },
      formatMessage({ id: "CREATE_A_TEAM" })
    )),
    /* @__PURE__ */ React28.createElement(VisuallyHidden4, null, /* @__PURE__ */ React28.createElement(HeadingOne, null, formatMessage({ id: "CREATE_A_TEAM" }))),
    displayCreateTeamSuccess ? /* @__PURE__ */ React28.createElement(CreateTeamSuccess, { teamPhoto: teamPhotoUrl, teamId }) : /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(
      Formik2,
      {
        initialValues: { teamName: "" },
        onSubmit: (values) => createNewTeam(values),
        validate: (values) => {
          const errors = {};
          if (values.teamName === "") {
            errors.teamName = formatMessage({ id: "TEAM_NAME_ERROR" });
          }
          return errors;
        },
        validateOnBlur: false,
        validateOnChange: false
      },
      ({ errors }) => /* @__PURE__ */ React28.createElement(Form2, null, /* @__PURE__ */ React28.createElement(
        Flex8,
        {
          flexDirection: "column",
          alignItems: "center",
          paddingY: { _: "five", tablet: "four" },
          marginX: "auto",
          maxWidth: CONTENT_MAX_WIDTH
        },
        /* @__PURE__ */ React28.createElement(
          ChooseProfilePicture,
          {
            photoUrl: teamPhotoUrl,
            size: JOIN_TEAM_PROFILE_PICTURE_SIZE
          }
        ),
        /* @__PURE__ */ React28.createElement(
          Link4,
          {
            as: "button",
            type: "button",
            marginY: { _: "oneAndHalf", tablet: "two" },
            paddingY: "threeQuarters",
            paddingX: "three",
            backgroundColor: "inherit",
            border: "none",
            onClick: handleOnClickAvatarLink
          },
          $tifelse(
            !!teamPhotoUrl,
            "CHANGE_TEAM_AVATAR",
            "SELECT_TEAM_AVATAR"
          )
        ),
        /* @__PURE__ */ React28.createElement(
          Label3,
          {
            marginBottom: { tablet: "twoAndHalf" },
            width: "100%",
            maxWidth: INPUT_MAX_WIDTH
          },
          /* @__PURE__ */ React28.createElement(LabelText2, { textAlign: "start", marginBottom: "quarter" }, formatMessage({ id: "TEAM_NAME_LABEL" })),
          /* @__PURE__ */ React28.createElement(
            Field2,
            {
              as: TextInput2,
              name: "teamName",
              type: "text",
              error: errors.teamName
            }
          ),
          errors.teamName && /* @__PURE__ */ React28.createElement(ErrorWithIcon, { errorMessage: errors.teamName })
        ),
        /* @__PURE__ */ React28.createElement(
          PrimaryButton3,
          {
            type: "submit",
            marginTop: errors.teamName ? "oneAndHalf" : "five",
            paddingX: "four",
            isLoading: createTeamMutation.isLoading
          },
          formatMessage({ id: "CREATE_TEAM" })
        )
      ))
    ), /* @__PURE__ */ React28.createElement(
      TeamPhotoModal,
      {
        displayTeamPhotoModal,
        closeTeamPhotoModal: () => setDisplayTeamPhotoModal(false),
        setTeamPhotoUrl,
        setTeamPhotoRefId
      }
    ))
  );
};

// src/pages/join-team-page/join-team-page.page.tsx
var JoinTeamPage = () => {
  var _a, _b, _c, _d;
  const [teamChoice, setTeamChoice] = useState3();
  const { formatMessage } = useIntl9();
  const { challengeId } = useParams9();
  const { isLoading, error, data: challengeData } = useGetChallengeByIdData();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const { data: userData } = useGetUserProfile();
  const { default_timezone: defaultTimezone } = userData || {};
  useEffect3(() => {
    if (!teamChoice) {
      trackChallengesAnalyticsEvent(EVENT_NAME7.SCREEN_LOADED, {
        screen_name: "join or create team" /* JOIN_OR_CREATE_TEAM */
      });
    }
  }, [challengeData, teamChoice]);
  if (isLoading)
    return /* @__PURE__ */ React29.createElement(JoinTeamPageSkeletonLoader, null);
  if (error || !(challengeData == null ? void 0 : challengeData.data))
    return /* @__PURE__ */ React29.createElement(FullPageError2, { error, route: JOURNEY_ROUTES5.programsHome() });
  const { endEnroll, maxTeamSize, startEnroll } = challengeData.data;
  const enrollmentOpen = isEnrollmentOpen(
    startEnroll,
    endEnroll,
    defaultTimezone
  );
  const userIsEnrolled = ((_c = (_b = (_a = challengeData.data) == null ? void 0 : _a.userChallenge) == null ? void 0 : _b.data) == null ? void 0 : _c.enrollmentStatus) === "enrolled";
  const teamsEnabled = maxTeamSize > 0;
  const userIsOnTeam = !!((_d = challengeData.data.challengeTeam) == null ? void 0 : _d.data.id);
  const userCanJoinTeam = userIsEnrolled && teamsEnabled && !userIsOnTeam && enrollmentOpen;
  if (!userCanJoinTeam)
    return /* @__PURE__ */ React29.createElement(FullPageError2, { error: null, route: JOURNEY_ROUTES5.programsHome() });
  if (teamChoice === "join" /* JOIN */)
    return /* @__PURE__ */ React29.createElement(JoinTeam, { backTo: () => setTeamChoice(void 0) });
  if (teamChoice === "create" /* CREATE */)
    return /* @__PURE__ */ React29.createElement(CreateTeam, { backTo: () => setTeamChoice(void 0) });
  const joinTeam2 = handleStaticAsset5(
    "CHALLENGES_JOIN_TEAM" /* CHALLENGES_JOIN_TEAM */
  );
  const createTeam2 = handleStaticAsset5(
    "CHALLENGES_JOIN_TEAM" /* CHALLENGES_JOIN_TEAM */
  );
  return /* @__PURE__ */ React29.createElement(
    Box10,
    {
      marginX: { _: "twoAndHalf", tablet: "auto" },
      marginY: "five",
      maxWidth: CONTENT_MAX_WIDTH
    },
    /* @__PURE__ */ React29.createElement(Flex9, { alignItems: "center" }, /* @__PURE__ */ React29.createElement(
      BackButtonArrow4,
      {
        as: Link5,
        marginInlineEnd: { _: "one", phone: "twoAndHalf" },
        marginTop: "half",
        onClick: noopFunction,
        to: JOURNEY_ROUTES5.getChallengeDetails(challengeId)
      }
    ), /* @__PURE__ */ React29.createElement(HeadingOne2, null, formatMessage({ id: "TEAMS" }))),
    /* @__PURE__ */ React29.createElement(Box10, { marginInlineStart: "four" }, /* @__PURE__ */ React29.createElement(BodyOne3, { marginTop: "one", marginBottom: "three" }, formatMessage({ id: "CHALLENGE_TEAMS_DESCRIPTION" })), /* @__PURE__ */ React29.createElement(
      TeamsOption,
      {
        image: joinTeam2,
        heading: formatMessage({ id: "JOIN_A_TEAM" }),
        description: formatMessage({ id: "JOIN_TEAM_DESCRIPTION" }),
        setChoice: () => setTeamChoice("join" /* JOIN */)
      }
    ), /* @__PURE__ */ React29.createElement(
      TeamsOption,
      {
        image: createTeam2,
        heading: formatMessage({ id: "CREATE_A_TEAM" }),
        description: formatMessage({ id: "CREATE_TEAM_DESCRIPTION" }),
        setChoice: () => setTeamChoice("create" /* CREATE */)
      }
    ))
  );
};

// src/pages/settings-page/settings-page.page.tsx
import React31, { useEffect as useEffect5 } from "react";
import { EVENT_NAME as EVENT_NAME9 } from "@leagueplatform/analytics";
import { Divider, HeadingText } from "@leagueplatform/genesis-core";
import { ProgramLayout } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import {
  FullPageError as FullPageError3,
  LoadingIndicator as LoadingIndicator2
} from "@leagueplatform/web-common-components";

// src/hooks/use-get-challenge-privacy-setting.hooks.ts
import { useQuery as useQuery5 } from "react-query";
import {
  getChallengeConfig
} from "@leagueplatform/health-journey-api";
var CHALLENGE_PRIVACY_SETTING_QUERY_KEY = "ChallengeConfig";
var useGetChallengePrivacySetting = () => {
  var _a;
  const { data: challengeData } = useGetChallengeByIdData();
  const userChallengeId = (_a = challengeData == null ? void 0 : challengeData.data.userChallenge) == null ? void 0 : _a.data.id;
  return useQuery5(
    [CHALLENGE_PRIVACY_SETTING_QUERY_KEY, userChallengeId],
    () => getChallengeConfig(userChallengeId),
    {
      enabled: !!userChallengeId,
      // since we are using enabled here, the query will ignore query client invalidateQueries for challenge privacy config calls that would normally result in the query refetching, so we have cacheTime 0 to account for that when navigating back to the setting page after successfully updating privacy settings
      cacheTime: 0
    }
  );
};

// src/components/privacy-settings-toggle/privacy-settings-toggle.component.tsx
import React30, { useState as useState4 } from "react";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import { StackLayout as StackLayout2, UtilityText } from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME8 } from "@leagueplatform/analytics";
import { SwitchIndicator } from "@leagueplatform/web-common-components";

// src/hooks/use-debounced-patch-privacy-config.hook.ts
import { useEffect as useEffect4 } from "react";
import { useDebounce } from "@leagueplatform/web-common";

// src/hooks/use-patch-privacy-config.hook.ts
import { useMutation as useMutation3, useQueryClient as useQueryClient2 } from "react-query";
import {
  CHALLENGE_HIGHLIGHTS_PATH,
  patchChallengesPrivacySetting
} from "@leagueplatform/health-journey-api";
var usePatchPrivacyConfig = (showFeedItems, originalShowFeedItems, setShowFeedItems) => {
  const { data: challengeData } = useGetChallengeByIdData();
  const { id: userChallengeId } = challengeData.data.userChallenge.data;
  const queryClient = useQueryClient2();
  const { mutate } = useMutation3(
    () => patchChallengesPrivacySetting(userChallengeId, showFeedItems),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([CHALLENGE_HIGHLIGHTS_PATH]);
        queryClient.invalidateQueries([CHALLENGE_PRIVACY_SETTING_QUERY_KEY]);
      },
      onError: () => {
        setShowFeedItems(originalShowFeedItems);
      }
    }
  );
  return mutate;
};

// src/hooks/use-debounced-patch-privacy-config.hook.ts
var useDebouncedPatchPrivacyConfigMutation = ({
  showFeedItems,
  setShowFeedItems,
  originalShowFeedItems
}) => {
  const debouncedShowFeedItems = useDebounce(
    showFeedItems,
    DEBOUNCE_DELAY_INTERVAL
  );
  const patchPrivacyConfigMutation = usePatchPrivacyConfig(
    showFeedItems,
    originalShowFeedItems,
    setShowFeedItems
  );
  useEffect4(() => {
    if (debouncedShowFeedItems !== originalShowFeedItems) {
      patchPrivacyConfigMutation();
    }
  }, [
    debouncedShowFeedItems,
    patchPrivacyConfigMutation,
    originalShowFeedItems
  ]);
};

// src/components/privacy-settings-toggle/privacy-settings-toggle.component.tsx
var { CHALLENGES_PRIVACY_SETTINGS } = CLP_SCREEN_NAMES;
var { HIDE_ACTIVITY, SHOW_ACTIVITY } = CLP_DETAIL;
var SettingsToggle = ({
  originalShowFeedItems
}) => {
  const { formatMessage } = useIntl10();
  const [showFeedItems, setShowFeedItems] = useState4(originalShowFeedItems);
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  useDebouncedPatchPrivacyConfigMutation({
    showFeedItems,
    setShowFeedItems,
    originalShowFeedItems
  });
  const handleAnalyticsClick = (detail) => {
    trackChallengesAnalyticsEvent(EVENT_NAME8.BUTTON_CLICKED, {
      screen_name: CHALLENGES_PRIVACY_SETTINGS,
      detail
    });
  };
  const updateActivitySetting = () => {
    handleAnalyticsClick(!showFeedItems ? SHOW_ACTIVITY : HIDE_ACTIVITY);
    setShowFeedItems(!showFeedItems);
  };
  return /* @__PURE__ */ React30.createElement(
    StackLayout2,
    {
      orientation: {
        "@initial": "vertical",
        "@laptop": "horizontal",
        "@desktop": "horizontal"
      },
      horizontalAlignment: "spaceBetween",
      verticalAlignment: "center",
      spacing: "$oneAndHalf"
    },
    /* @__PURE__ */ React30.createElement(UtilityText, null, formatMessage({ id: "CHALLENGE_ACTIVITY_DETAIL" })),
    /* @__PURE__ */ React30.createElement(
      StackLayout2,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$oneAndHalf",
        horizontalAlignment: {
          "@initial": "start",
          "@laptop": "end",
          "@desktop": "end"
        }
      },
      /* @__PURE__ */ React30.createElement(
        UtilityText,
        {
          as: "label",
          emphasis: "emphasized",
          htmlFor: "show-activity-switch",
          css: {
            color: "$interactiveActionPrimary"
          }
        },
        formatMessage({ id: "SHOW_MY_ACTIVITY" })
      ),
      /* @__PURE__ */ React30.createElement(
        SwitchIndicator,
        {
          id: "show-activity-switch",
          onClick: updateActivitySetting,
          checked: showFeedItems
        }
      )
    )
  );
};

// src/pages/settings-page/settings-page.page.tsx
var { CHALLENGES_PRIVACY_SETTINGS: CHALLENGES_PRIVACY_SETTINGS2 } = CLP_SCREEN_NAMES;
var SettingsPage = () => {
  const { data: challengeData, isLoading, error } = useGetChallengeByIdData();
  const {
    data: challengeConfig,
    isLoading: challengeConfigLoading,
    error: challengeConfigError
  } = useGetChallengePrivacySetting();
  const { formatMessage } = useIntl11();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  useEffect5(() => {
    trackChallengesAnalyticsEvent(EVENT_NAME9.SCREEN_LOADED, {
      screen_name: CHALLENGES_PRIVACY_SETTINGS2
    });
  }, []);
  if (isLoading || challengeConfigLoading)
    return /* @__PURE__ */ React31.createElement(LoadingIndicator2, null);
  if (error || challengeConfigError || !(challengeData == null ? void 0 : challengeData.data) || !(challengeConfig == null ? void 0 : challengeConfig.data))
    return /* @__PURE__ */ React31.createElement(FullPageError3, { error: challengeConfigError });
  const originalShowFeedItems = challengeConfig == null ? void 0 : challengeConfig.data.showFeedItems;
  return /* @__PURE__ */ React31.createElement(
    ProgramLayout,
    {
      header: /* @__PURE__ */ React31.createElement(
        HeadingText,
        {
          level: "1",
          size: "xxl",
          css: {
            marginY: "$threeQuarters"
          }
        },
        formatMessage({ id: "PRIVACY" })
      ),
      content: /* @__PURE__ */ React31.createElement(React31.Fragment, null, /* @__PURE__ */ React31.createElement(Divider, { css: { marginBottom: "$three" } }), /* @__PURE__ */ React31.createElement(SettingsToggle, { originalShowFeedItems }))
    }
  );
};

// src/pages/challenge-landing-page/challenge-landing-page.page.tsx
import React81, { useState as useState11 } from "react";
import { useParamsLegacy as useParams23 } from "@leagueplatform/routing";
import { useIntl as useIntl52 } from "@leagueplatform/locales";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES13,
  ENABLE_CHALLENGES_FAQ,
  ENABLE_CHALLENGE_ACTIVITIES_TAB,
  AchievementCalloutBanner,
  ProgramLayout as ProgramLayout2
} from "@leagueplatform/health-journey-common";
import { useFeatureFlagQuery } from "@leagueplatform/user-profile-api";
import { Responsive as Responsive4, StackLayout as StackLayout21, Tabs } from "@leagueplatform/genesis-core";
import { FullPageError as FullPageError4 } from "@leagueplatform/web-common-components";

// src/components/empty-activity-state/empty-activity-state.component.tsx
import React32 from "react";
import {
  Box as Box11,
  HeadingFour as HeadingFour2,
  BodyOneSecondary as BodyOneSecondary2
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl12 } from "@leagueplatform/locales";
var EmptyActivityState = ({
  activityDescription
}) => {
  const { formatMessage } = useIntl12();
  return /* @__PURE__ */ React32.createElement(
    Box11,
    {
      backgroundColor: "surface.background.secondary",
      borderColor: "onSurface.border.subdued",
      borderRadius: "medium",
      borderWidth: "thin",
      marginBottom: "oneAndHalf",
      paddingX: "one",
      paddingY: "twoAndHalf",
      textAlign: "center"
    },
    /* @__PURE__ */ React32.createElement(HeadingFour2, { as: "h2" }, formatMessage({ id: "NO_ACTIVITY_TITLE" })),
    /* @__PURE__ */ React32.createElement(BodyOneSecondary2, { marginTop: "half" }, activityDescription)
  );
};

// src/components/highlight-feed/highlight-feed.component.tsx
import React37 from "react";

// src/components/highlight-card/highlight-card.component.tsx
import React35, { useState as useState5 } from "react";
import { useParamsLegacy as useParams10 } from "@leagueplatform/routing";
import { useIntl as useIntl16 } from "@leagueplatform/locales";
import {
  Image as Image4,
  Flex as Flex10,
  Box as Box13,
  SubtitleTwo as SubtitleTwo2,
  Caption as Caption2,
  useTheme,
  BodyOne as BodyOne4
} from "@leagueplatform/genesis-commons";
import {
  Button,
  StackLayout as StackLayout3,
  UtilityText as UtilityText4,
  VisuallyHidden as VisuallyHidden5
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME10, SCREEN_NAMES as SCREEN_NAMES2 } from "@leagueplatform/analytics";
import {
  CHALLENGE_HIGHLIGHT_REACTION_TYPES as CHALLENGE_HIGHLIGHT_REACTION_TYPES2
} from "@leagueplatform/health-journey-api";
import { handleStaticAsset as handleStaticAsset7 } from "@leagueplatform/asset-config";

// src/components/highlight-card/likes-modal.component.tsx
import React33 from "react";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import {
  Modal as Modal2,
  Box as Box12,
  HeadingText as HeadingText2,
  UtilityText as UtilityText2
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset6 } from "@leagueplatform/asset-config";
var LIKES_MODAL_MAX_WIDTH = 500;
var LIKES_MODAL_LIST_HEIGHT = 220;
var LIKES_MODAL_ARIA_LABEL = "likesModalHeading";
var LikesModal = ({
  displayLikesModal,
  setDisplayLikesModal,
  activityLikes
}) => {
  const { formatMessage } = useIntl13();
  return /* @__PURE__ */ React33.createElement(
    Modal2.Root,
    {
      open: displayLikesModal,
      onOpenChange: (open) => setDisplayLikesModal(open)
    },
    /* @__PURE__ */ React33.createElement(
      Modal2.Content,
      {
        css: {
          ".GDS-modal": {
            maxWidth: LIKES_MODAL_MAX_WIDTH,
            paddingTop: "oneAndHalf",
            paddingInlineStart: "two",
            paddingBottom: "none",
            paddingInlineEnd: "none"
          }
        },
        "aria-labelledby": LIKES_MODAL_ARIA_LABEL
      },
      /* @__PURE__ */ React33.createElement(Box12, { css: { alignItems: "center", display: "flex" } }, handleStaticAsset6("CHALLENGES_HEART_ICON" /* CHALLENGES_HEART_ICON */, {
        isComponent: true,
        props: {
          fillColor: "onSurface.text.primary"
        }
      }), /* @__PURE__ */ React33.createElement(
        HeadingText2,
        {
          size: "lg",
          level: "2",
          id: LIKES_MODAL_ARIA_LABEL,
          css: { marginInlineStart: "$threeQuarters" }
        },
        formatMessage(
          { id: "X_LIKES" },
          { activityLikes: activityLikes.length }
        ).toLowerCase()
      )),
      /* @__PURE__ */ React33.createElement(
        Box12,
        {
          as: "ul",
          css: {
            marginTop: "$threeQuarters",
            height: LIKES_MODAL_LIST_HEIGHT,
            overflowY: "auto"
          }
        },
        activityLikes.map((like, index) => {
          const { firstName, lastName, avatar: avatar2 } = like;
          const formattedName = formatUserName({ firstName, lastName });
          return /* @__PURE__ */ React33.createElement(
            Box12,
            {
              as: "li",
              key: `${firstName}_${lastName}_${index}`,
              css: {
                paddingTop: "$threeQuarters",
                paddingBottom: "$threeQuarters",
                alignItems: "center",
                display: "flex"
              }
            },
            /* @__PURE__ */ React33.createElement(
              Box12,
              {
                css: {
                  marginInlineEnd: "$one",
                  width: "$twoAndHalf",
                  height: "$twoAndHalf"
                }
              },
              /* @__PURE__ */ React33.createElement(
                ChallengeProfilePicture,
                {
                  profilePicture: avatar2,
                  firstName,
                  lastName
                }
              )
            ),
            /* @__PURE__ */ React33.createElement(
              UtilityText2,
              {
                as: "p",
                size: "sm",
                css: { typography: "$subtitleTwo" }
              },
              formattedName
            )
          );
        })
      )
    )
  );
};

// src/components/highlight-card/constants/highlight-card.constants.tsx
var PRIMARY_AVATAR_SIZE = 40;
var SECONDARY_AVATAR_SIZE = 20;

// src/components/highlight-card/hooks/use-get-highlight-details.util.ts
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import { SHORT_DATE_FORMAT } from "@leagueplatform/web-common";
import {
  CHALLENGE_HIGHLIGHT_IMAGE_TYPES,
  CHALLENGE_HIGHLIGHT_REACTION_TYPES
} from "@leagueplatform/health-journey-api";
var useGetHighlightDetails = (highlight) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { formatDate } = useIntl14();
  const { data: userData } = useGetUserProfile();
  const { default_timezone: defaultTimezone } = userData || {};
  const {
    firstName,
    lastName,
    teamName,
    createdAt,
    images,
    reactions,
    challengeFeedItemReaction
  } = highlight;
  const formattedName = (firstName == null ? void 0 : firstName.length) ? formatUserName({ firstName, lastName }) : teamName;
  const formattedDate = formatDate(createdAt, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT), {
    timeZone: defaultTimezone
  }));
  const userPhoto = (_a = images == null ? void 0 : images.filter(
    (image) => image.type === CHALLENGE_HIGHLIGHT_IMAGE_TYPES.USER
  )[0]) == null ? void 0 : _a.imageUrl;
  const teamPhoto = (_b = images == null ? void 0 : images.filter(
    (image) => image.type === CHALLENGE_HIGHLIGHT_IMAGE_TYPES.TEAM
  )[0]) == null ? void 0 : _b.imageUrl;
  const activityImage = (_c = images == null ? void 0 : images.filter(
    (image) => image.type === CHALLENGE_HIGHLIGHT_IMAGE_TYPES.HIGHLIGHT
  )[0]) == null ? void 0 : _c.imageUrl;
  const numberOfLikes = (_d = reactions == null ? void 0 : reactions.filter(
    (reaction) => reaction.type === CHALLENGE_HIGHLIGHT_REACTION_TYPES.LIKE
  )[0]) == null ? void 0 : _d.count;
  const likeReactionId = (_f = (_e = challengeFeedItemReaction == null ? void 0 : challengeFeedItemReaction.data) == null ? void 0 : _e.filter(
    (data) => data.reactionType === CHALLENGE_HIGHLIGHT_REACTION_TYPES.LIKE
  )[0]) == null ? void 0 : _f.id;
  const likesData = (_h = (_g = challengeFeedItemReaction == null ? void 0 : challengeFeedItemReaction.data) == null ? void 0 : _g.filter(
    (data) => data.reactionType === CHALLENGE_HIGHLIGHT_REACTION_TYPES.LIKE
  )[0]) == null ? void 0 : _h.userProfiles;
  const userLikedHighlight = (_i = reactions == null ? void 0 : reactions.filter(
    (reaction) => reaction.type === CHALLENGE_HIGHLIGHT_REACTION_TYPES.LIKE
  )[0]) == null ? void 0 : _i.reacted;
  return {
    activityImage,
    formattedDate,
    formattedName,
    likesData,
    likeReactionId,
    numberOfLikes,
    teamPhoto,
    userLikedHighlight,
    userPhoto
  };
};

// src/components/highlight-card/hooks/use-debounced-react-to-highlight-mutation.hook.ts
import { useEffect as useEffect6 } from "react";
import { useDebounce as useDebounce2 } from "@leagueplatform/web-common";

// src/components/highlight-card/hooks/use-react-to-highlight.hook.ts
import { useMutation as useMutation4, useQueryClient as useQueryClient3 } from "react-query";
import {
  CHALLENGE_PATCH_OPERATIONS,
  patchHighlightReaction,
  CHALLENGE_HIGHLIGHTS_PATH as CHALLENGE_HIGHLIGHTS_PATH2
} from "@leagueplatform/health-journey-api";
var useReactToHighlight = (reactionId, highlightEventType, originalLikedState, debouncedIsLiked, setIsLiked) => {
  const queryClient = useQueryClient3();
  const operationType = debouncedIsLiked ? CHALLENGE_PATCH_OPERATIONS.ADD : CHALLENGE_PATCH_OPERATIONS.REMOVE;
  const { mutate } = useMutation4(
    () => patchHighlightReaction(reactionId, operationType),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([CHALLENGE_HIGHLIGHTS_PATH2]);
      },
      onError: () => {
        setIsLiked(originalLikedState);
      }
    }
  );
  return mutate;
};

// src/components/highlight-card/hooks/use-debounced-react-to-highlight-mutation.hook.ts
var useDebouncedReactToHighlightMutation = ({
  isLiked,
  setIsLiked,
  userLikedHighlight,
  likeReactionId,
  highlightEventType
}) => {
  const debouncedIsLiked = useDebounce2(isLiked, DEBOUNCE_DELAY_INTERVAL);
  const reactToHighlightMutation = useReactToHighlight(
    likeReactionId,
    highlightEventType,
    userLikedHighlight,
    debouncedIsLiked,
    setIsLiked
  );
  useEffect6(() => {
    if (debouncedIsLiked !== userLikedHighlight) {
      reactToHighlightMutation();
    }
  }, [debouncedIsLiked, reactToHighlightMutation, userLikedHighlight]);
};

// src/components/highlight-card/hooks/use-highlight-description.util.tsx
import React34 from "react";
import { useIntl as useIntl15 } from "@leagueplatform/locales";
import {
  CHALLENGE_HIGHLIGHT_EVENT_TYPES as CHALLENGE_HIGHLIGHT_EVENT_TYPES2
} from "@leagueplatform/health-journey-api";
import { UtilityText as UtilityText3 } from "@leagueplatform/genesis-core";
var strong = (msg) => /* @__PURE__ */ React34.createElement(UtilityText3, { as: "strong", emphasis: "emphasized" }, msg);
var useHighlightDescription = ({
  event,
  teamName,
  challengeTitle
}) => {
  const { formatMessage, $tifelse, formatNumber } = useIntl15();
  switch (event.type) {
    case CHALLENGE_HIGHLIGHT_EVENT_TYPES2.CHALLENGE:
      return {
        displayDescription: formatMessage(
          { id: "JOINED_CHALLENGE_HIGHLIGHT" },
          { challengeTitle, strong }
        ),
        analyticsDescription: formatMessage(
          { id: "JOINED_CHALLENGE_HIGHLIGHT" },
          { challengeTitle }
        )
      };
    case CHALLENGE_HIGHLIGHT_EVENT_TYPES2.TEAM:
      return {
        displayDescription: $tifelse(
          event.value === "Created" /* CREATED */,
          "CREATED_TEAM_HIGHLIGHT",
          "JOINED_TEAM_HIGHLIGHT",
          { teamName, strong }
        ),
        analyticsDescription: $tifelse(
          event.value === "Created" /* CREATED */,
          "CREATED_TEAM_HIGHLIGHT",
          "JOINED_TEAM_HIGHLIGHT",
          { teamName }
        )
      };
    case CHALLENGE_HIGHLIGHT_EVENT_TYPES2.STEPS:
    case CHALLENGE_HIGHLIGHT_EVENT_TYPES2.MINUTES: {
      const eventValue = typeof event.value === "string" ? parseInt(event.value, 10) : event.value;
      return {
        displayDescription: $tifelse(
          event.type === CHALLENGE_HIGHLIGHT_EVENT_TYPES2.STEPS,
          "STEPS_WALKED_HIGHLIGHT",
          "ACTIVE_MINUTES_HIGHLIGHT",
          { total: formatNumber(eventValue), strong }
        ),
        analyticsDescription: $tifelse(
          event.type === CHALLENGE_HIGHLIGHT_EVENT_TYPES2.STEPS,
          "STEPS_WALKED_HIGHLIGHT",
          "ACTIVE_MINUTES_HIGHLIGHT",
          { total: formatNumber(eventValue) }
        )
      };
    }
    case CHALLENGE_HIGHLIGHT_EVENT_TYPES2.MINDFUL_MINUTE: {
      const minutes = typeof event.value === "string" ? parseInt(event.value, 10) : event.value;
      return {
        displayDescription: formatMessage(
          {
            id: "MINDFUL_MINUTES_HIGHLIGHT"
          },
          { total: formatNumber(minutes), strong }
        ),
        analyticsDescription: formatMessage(
          {
            id: "MINDFUL_MINUTES_HIGHLIGHT"
          },
          { total: formatNumber(minutes) }
        )
      };
    }
    case CHALLENGE_HIGHLIGHT_EVENT_TYPES2.ACHIEVEMENT:
      return {
        displayDescription: formatMessage(
          { id: "EARNED_ACHIEVEMENT_HIGHLIGHT" },
          { achievement: event.value, strong }
        ),
        analyticsDescription: formatMessage(
          { id: "EARNED_ACHIEVEMENT_HIGHLIGHT" },
          { achievement: event.value }
        )
      };
    case CHALLENGE_HIGHLIGHT_EVENT_TYPES2.COMPLETED_ACTIVITY:
      return {
        displayDescription: formatMessage(
          { id: "COMPLETED_ACTIVITY_HIGHLIGHT" },
          { strong }
        ),
        analyticsDescription: formatMessage({
          id: "COMPLETED_ACTIVITY_HIGHLIGHT"
        })
      };
    default:
      return { displayDescription: "", analyticsDescription: "" };
  }
};

// src/components/highlight-card/highlight-card.component.tsx
var LIKE_BUTTON_HOVER_STYLES = {
  backgroundColor: "transparent",
  color: "$interactiveActionPrimary"
};
var HighlightCard = ({
  highlight,
  challengeTitle,
  userChallengeId
}) => {
  const theme = useTheme();
  const { formatMessage, $tifelse } = useIntl16();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const { firstName, lastName, teamName, event } = highlight;
  const { teamId } = useParams10();
  const {
    activityImage,
    formattedDate,
    formattedName,
    likesData,
    likeReactionId,
    numberOfLikes,
    teamPhoto,
    userPhoto,
    userLikedHighlight
  } = useGetHighlightDetails(highlight);
  const highlightDescription = useHighlightDescription({
    event,
    teamName,
    challengeTitle
  });
  const [isLiked, setIsLiked] = useState5(userLikedHighlight);
  const [displayedNumberOfLikes, setDisplayedNumberOfLikes] = useState5(numberOfLikes);
  const [displayLikesModal, setDisplayLikesModal] = useState5(false);
  const { displayDescription, analyticsDescription } = highlightDescription;
  useDebouncedReactToHighlightMutation({
    isLiked,
    setIsLiked,
    userLikedHighlight,
    likeReactionId,
    highlightEventType: event.type
  });
  const handleAnalyticsEvent = (sub_detail) => {
    trackChallengesAnalyticsEvent(EVENT_NAME10.BUTTON_CLICKED, __spreadValues({
      screen_name: teamId ? "team details" /* TEAM_DETAILS */ : SCREEN_NAMES2.HEALTH_CAMPAIGN_DETAIL,
      detail: "interact with highlights" /* INTERACT_HIGHLIGHTS */,
      sub_detail,
      highlight_name: analyticsDescription.replace(/(<([^>]+)>)/gi, "")
    }, teamId ? { team_id: teamId, team_name: teamName } : { tab_name: "highlights" /* HIGHLIGHTS */ }));
  };
  const toggleLikeButton = () => {
    setIsLiked(!isLiked);
    setDisplayedNumberOfLikes(
      !isLiked ? displayedNumberOfLikes + 1 : displayedNumberOfLikes - 1
    );
    handleAnalyticsEvent(
      !isLiked ? CHALLENGE_HIGHLIGHT_REACTION_TYPES2.LIKE : CHALLENGE_HIGHLIGHT_REACTION_TYPES2.UNLIKE
    );
  };
  const displayLikesDividerLine = userChallengeId && displayedNumberOfLikes > 0;
  return /* @__PURE__ */ React35.createElement(
    Flex10,
    {
      borderColor: "onSurface.border.subdued",
      borderRadius: "medium",
      borderWidth: "thin",
      "data-testid": "highlightCard",
      flexDirection: "column",
      width: "100%"
    },
    /* @__PURE__ */ React35.createElement(Box13, { padding: "one" }, /* @__PURE__ */ React35.createElement(Flex10, null, /* @__PURE__ */ React35.createElement(Box13, null, /* @__PURE__ */ React35.createElement(
      Box13,
      {
        size: PRIMARY_AVATAR_SIZE,
        marginInlineEnd: "threeQuarters",
        position: "relative"
      },
      /* @__PURE__ */ React35.createElement(
        ChallengeProfilePicture,
        {
          profilePicture: (firstName == null ? void 0 : firstName.length) ? userPhoto : teamPhoto,
          firstName,
          lastName
        }
      ),
      firstName && teamName && /* @__PURE__ */ React35.createElement(
        Box13,
        {
          size: SECONDARY_AVATAR_SIZE,
          position: "absolute",
          bottom: "0",
          insetInlineEnd: "0",
          borderWidth: "thin",
          borderStyle: "solid",
          borderColor: "onSurface.border.subdued",
          borderRadius: "circle"
        },
        /* @__PURE__ */ React35.createElement(
          ChallengeProfilePicture,
          {
            profilePicture: teamPhoto,
            firstName: teamName,
            lastName: ""
          }
        )
      )
    )), /* @__PURE__ */ React35.createElement(Box13, null, /* @__PURE__ */ React35.createElement(SubtitleTwo2, { as: "p" }, formattedName), /* @__PURE__ */ React35.createElement(Caption2, { as: "p", color: "onSurface.text.subdued" }, firstName && teamName && `${teamName} \u2022 `, formattedDate))), /* @__PURE__ */ React35.createElement(Flex10, { marginTop: "one", flexDirection: "column", alignItems: "center" }, /* @__PURE__ */ React35.createElement(BodyOne4, { textAlign: "center", "data-testid": "highlightDescription" }, displayDescription), activityImage && /* @__PURE__ */ React35.createElement(
      Image4,
      {
        src: activityImage,
        alt: "",
        marginTop: "one",
        width: (
          // Activity image should take the full width of the highlight card, accounting for card padding + border
          `calc(100% + ${theme.space.two}px + 2px)`
        )
      }
    ))),
    /* @__PURE__ */ React35.createElement(
      StackLayout3,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$none"
      },
      userChallengeId && /* @__PURE__ */ React35.createElement(
        Button,
        {
          onClick: toggleLikeButton,
          quiet: true,
          priority: "secondary",
          css: {
            color: "$interactiveActionPrimary",
            border: "transparent",
            padding: "$one",
            "&:hover,&:active": LIKE_BUTTON_HOVER_STYLES
          }
        },
        /* @__PURE__ */ React35.createElement(Flex10, null, handleStaticAsset7("CHALLENGES_HEART_ICON" /* CHALLENGES_HEART_ICON */, {
          isComponent: true,
          props: {
            fillColor: isLiked ? "interactive.action.primary" : "inherit"
          }
        })),
        /* @__PURE__ */ React35.createElement(VisuallyHidden5, null, $tifelse(isLiked, "LIKED", "LIKE"))
      ),
      displayLikesDividerLine && /* @__PURE__ */ React35.createElement(
        UtilityText4,
        {
          css: {
            color: "$onSurfaceBorderSubdued"
          },
          "aria-hidden": true
        },
        "|"
      ),
      displayedNumberOfLikes > 0 && /* @__PURE__ */ React35.createElement(
        Button,
        {
          onClick: () => {
            setDisplayLikesModal(!displayLikesModal);
            handleAnalyticsEvent(
              CHALLENGE_HIGHLIGHT_REACTION_TYPES2.VIEW_LIKES
            );
          },
          quiet: true,
          priority: "secondary",
          css: {
            color: "$interactiveActionPrimary",
            border: "transparent",
            padding: "$one",
            "&:hover,&:active": __spreadProps(__spreadValues({}, LIKE_BUTTON_HOVER_STYLES), {
              textDecoration: "underline"
            })
          }
        },
        /* @__PURE__ */ React35.createElement(Box13, { as: "span" }, formatMessage(
          { id: "X_LIKES" },
          { activityLikes: displayedNumberOfLikes }
        ).toLowerCase())
      )
    ),
    likesData && /* @__PURE__ */ React35.createElement(
      LikesModal,
      {
        displayLikesModal,
        setDisplayLikesModal,
        activityLikes: likesData
      }
    )
  );
};

// src/components/highlight-feed/highlight-feed.component.tsx
import { Spinner as Spinner2, StackLayout as StackLayout4 } from "@leagueplatform/genesis-core";
import { ErrorState as ErrorState2 } from "@leagueplatform/web-common-components";

// src/hooks/use-get-highlights-feed-by-id.ts
import { useInfiniteQuery } from "react-query";
import { useParamsLegacy as useParams11 } from "@leagueplatform/routing";
import {
  getHighlightsFeedById,
  CHALLENGE_HIGHLIGHTS_PATH as CHALLENGE_HIGHLIGHTS_PATH3
} from "@leagueplatform/health-journey-api";
var useGetHighlightsFeedById = (feedType, id) => {
  const { challengeId } = useParams11();
  return useInfiniteQuery(
    [CHALLENGE_HIGHLIGHTS_PATH3, id, "infinite"],
    ({ pageParam }) => getHighlightsFeedById(feedType, id, challengeId, pageParam),
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage.links.next || !lastPage.data.length) {
          return void 0;
        }
        const { next } = lastPage.links;
        return next.slice(next.indexOf("/v1/"));
      }
    }
  );
};

// src/components/leaderboard/load-more-cta/load-more-cta.component.tsx
import React36 from "react";
import { Button as Button2 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl17 } from "@leagueplatform/locales";
var LoadMoreCTA = ({
  isFetchingNextPage,
  fetchNextPage,
  onClick
}) => {
  const { formatMessage } = useIntl17();
  const handleClick = () => {
    fetchNextPage();
    onClick == null ? void 0 : onClick();
  };
  return /* @__PURE__ */ React36.createElement(
    Button2,
    {
      loading: isFetchingNextPage,
      onClick: handleClick,
      priority: "secondary",
      width: "fillContainer",
      css: {
        maxWidth: LOAD_MORE_BUTTON_MAX_WIDTH
      }
    },
    formatMessage({ id: "VIEW_MORE" })
  );
};

// src/components/highlight-feed/highlight-feed.component.tsx
import { useIntl as useIntl18 } from "@leagueplatform/locales";
var HighlightFeed = ({
  feedType,
  challengeOrTeamId,
  challengeTitle,
  userChallengeId
}) => {
  const {
    data: highlights,
    fetchNextPage,
    isLoading,
    isError,
    isFetchingNextPage,
    hasNextPage,
    error
  } = useGetHighlightsFeedById(feedType, challengeOrTeamId);
  let flattenedHighlights;
  if (highlights == null ? void 0 : highlights.pages) {
    flattenedHighlights = highlights.pages.reduce(
      (acc, { data: highlightsData }) => acc.concat(highlightsData),
      []
    );
  }
  const { $t } = useIntl18();
  if (isLoading) {
    return /* @__PURE__ */ React37.createElement(
      StackLayout4,
      {
        horizontalAlignment: "center",
        verticalAlignment: "center",
        css: { height: "$five", margin: "$five auto" }
      },
      /* @__PURE__ */ React37.createElement(Spinner2, { loading: true, tint: "$decorativeBrandPrimaryDefault", size: "$three" })
    );
  }
  if (isError || !flattenedHighlights) {
    return /* @__PURE__ */ React37.createElement(ErrorState2, { error });
  }
  if (!(flattenedHighlights == null ? void 0 : flattenedHighlights.length)) {
    return /* @__PURE__ */ React37.createElement(
      EmptyActivityState,
      {
        activityDescription: $t({ id: "NO_HIGHLIGHTS_ACTIVITY_DESCRIPTION" })
      }
    );
  }
  return /* @__PURE__ */ React37.createElement(StackLayout4, { spacing: "$one", horizontalAlignment: "center" }, flattenedHighlights.map((highlight) => /* @__PURE__ */ React37.createElement(
    HighlightCard,
    {
      highlight,
      challengeTitle,
      userChallengeId,
      key: highlight.id
    }
  )), hasNextPage && /* @__PURE__ */ React37.createElement(
    LoadMoreCTA,
    {
      isFetchingNextPage,
      fetchNextPage
    }
  ));
};

// src/components/challenge-link/challenge-link.component.tsx
import React38 from "react";
import { LinkLegacy as Link6 } from "@leagueplatform/routing";
import {
  HeadingFour as HeadingFour3,
  Overline,
  Flex as Flex11,
  Box as Box14
} from "@leagueplatform/genesis-commons";
var ChallengeLink = ({
  to,
  title,
  description
}) => /* @__PURE__ */ React38.createElement(
  Flex11,
  {
    as: Link6,
    alignItems: "center",
    backgroundColor: "surface.background.primary",
    borderColor: "onSurface.border.subdued",
    borderRadius: "medium",
    borderWidth: "thin",
    justifyContent: "space-between",
    marginBottom: "one",
    padding: "oneAndHalf",
    textDecoration: "none",
    to
  },
  /* @__PURE__ */ React38.createElement(Box14, null, /* @__PURE__ */ React38.createElement(Overline, { as: "p" }, title), /* @__PURE__ */ React38.createElement(HeadingFour3, { as: "p" }, description)),
  /* @__PURE__ */ React38.createElement(
    Flex11,
    {
      as: "span",
      alignItems: "center",
      color: "onSurface.text.subdued",
      transform: "rotate(180deg)"
    },
    /* @__PURE__ */ React38.createElement(ChallengeIcon, { iconType: "CHEVRON" /* CHEVRON */ })
  )
);

// src/pages/challenge-landing-page/challenge-landing-page.page.tsx
import { CHALLENGE_HIGHLIGHT_FEED_TYPES as CHALLENGE_HIGHLIGHT_FEED_TYPES2 } from "@leagueplatform/health-journey-api";
import { EVENT_NAME as EVENT_NAME23, SCREEN_NAMES as SCREEN_NAMES9 } from "@leagueplatform/analytics";

// src/pages/challenge-landing-page/components/challenge-faq/challenge-faq.component.tsx
import React39 from "react";
import {
  HeadingText as HeadingText3,
  ParagraphText,
  StackLayout as StackLayout5,
  TextAction
} from "@leagueplatform/genesis-core";
import { useHelpCenterLinks } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME11, SCREEN_NAMES as SCREEN_NAMES3 } from "@leagueplatform/analytics";
var ChallengeFAQ = () => {
  const { formatMessage } = useIntl19();
  const { healthProgramsAndJourneyLearnMoreLink } = useHelpCenterLinks(
    CHALLENGES_UTM_SOURCE
  );
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME11.BUTTON_CLICKED, {
    screen_name: SCREEN_NAMES3.HEALTH_CAMPAIGN_DETAIL,
    detail
  });
  return /* @__PURE__ */ React39.createElement(StackLayout5, { spacing: "$half" }, /* @__PURE__ */ React39.createElement(HeadingText3, { level: "2", size: "sm" }, formatMessage({ id: "CHALLENGE_FAQ_HEADING" })), /* @__PURE__ */ React39.createElement(ParagraphText, null, formatMessage(
    { id: "CHALLENGE_FAQ_CONTENT" },
    {
      helpCenterLink: /* @__PURE__ */ React39.createElement(
        TextAction,
        {
          href: healthProgramsAndJourneyLearnMoreLink,
          rel: "noopener noreferrer",
          target: "_blank",
          onClick: () => handleAnalyticsClick("help center" /* NAVIGATE_TO_HELP_CENTER */)
        },
        formatMessage({ id: "HELP_CENTER" })
      )
    }
  )));
};

// src/pages/challenge-landing-page/components/challenge-heading/challenge-heading.component.tsx
import React51 from "react";
import { useIntl as useIntl28 } from "@leagueplatform/locales";
import { ProgramHeading } from "@leagueplatform/health-journey-common";
import {
  Box as Box19,
  Responsive as Responsive2,
  StackLayout as StackLayout10,
  UtilityText as UtilityText10,
  queryHelpers as queryHelpers3,
  useMediaQuery as useMediaQuery3
} from "@leagueplatform/genesis-core";

// src/components/progress-tracker/progress-tracker.component.tsx
import React41 from "react";
import { StackLayout as StackLayout7, UtilityText as UtilityText6 } from "@leagueplatform/genesis-core";
import { ProgramDetailCard } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl21 } from "@leagueplatform/locales";
import { ProgressBar } from "@leagueplatform/web-common-components";

// src/pages/challenge-landing-page/components/sidebar/components/your-ranking/your-ranking.component.tsx
import React40 from "react";
import { useIntl as useIntl20 } from "@leagueplatform/locales";

// src/hooks/use-get-invidual-user-rank.hook.ts
import { useQuery as useQuery6 } from "react-query";
import { useParamsLegacy as useParams12 } from "@leagueplatform/routing";
import {
  getIndividualUserRank
} from "@leagueplatform/health-journey-api";
var INDIVIDUAL_USER_RANK_QUERY_KEY = "getIndividualUserRankData";
var useGetIndividualUserRank = () => {
  const { challengeId } = useParams12();
  const { data: userData } = useGetUserProfile();
  return useQuery6(
    [INDIVIDUAL_USER_RANK_QUERY_KEY, challengeId],
    () => getIndividualUserRank(challengeId, userData == null ? void 0 : userData.user_id),
    { enabled: !!(userData == null ? void 0 : userData.user_id) }
  );
};

// src/pages/challenge-landing-page/components/sidebar/components/your-ranking/your-ranking.component.tsx
import { StackLayout as StackLayout6, UtilityText as UtilityText5 } from "@leagueplatform/genesis-core";
var YourRanking = () => {
  var _a;
  const { formatMessage } = useIntl20();
  const { data: userRankData } = useGetIndividualUserRank();
  const rank = (_a = userRankData == null ? void 0 : userRankData.data[0]) == null ? void 0 : _a.rank;
  return /* @__PURE__ */ React40.createElement(
    StackLayout6,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      css: {
        backgroundColor: "$surfaceBackgroundSecondary",
        borderRadius: "$medium",
        padding: "$threeQuarters $one"
      }
    },
    /* @__PURE__ */ React40.createElement(UtilityText5, null, formatMessage({ id: "YOUR_RANKING" })),
    /* @__PURE__ */ React40.createElement(UtilityText5, { emphasis: "emphasized" }, rank ? formatMessage({ id: "XTH_PLACE" }, { currentRank: rank }) : "-")
  );
};

// src/components/progress-tracker/progress-tracker.component.tsx
var ProgressTracker = () => {
  const { formatMessage } = useIntl21();
  const { data: challengeData } = useGetChallengeByIdData();
  const { challengeType, totalActivities, userChallenge } = challengeData.data;
  const progress = userChallenge == null ? void 0 : userChallenge.data.progress;
  const completedActivities = (progress == null ? void 0 : progress.completedActivities) || 0;
  if (!totalActivities) {
    return null;
  }
  const isGroupChallenge = challengeType === "group";
  const completionPercentage = Math.round(
    completedActivities / totalActivities * 100
  );
  return /* @__PURE__ */ React41.createElement(ProgramDetailCard, { heading: formatMessage({ id: "CHALLENGE_PROGRESS" }) }, /* @__PURE__ */ React41.createElement(
    StackLayout7,
    {
      horizontalAlignment: "stretch",
      spacing: "$oneAndHalf",
      orientation: {
        "@mobileLandscape": "horizontal",
        "@tablet": "horizontal",
        "@initial": "vertical"
      }
    },
    /* @__PURE__ */ React41.createElement(StackLayout7, { spacing: "$half", horizontalAlignment: "stretch" }, /* @__PURE__ */ React41.createElement(StackLayout7, { orientation: "horizontal", spacing: "$quarter" }, /* @__PURE__ */ React41.createElement(
      UtilityText6,
      {
        size: "sm",
        emphasis: "emphasized",
        css: { color: "$onSurfaceTextSuccess" }
      },
      formatMessage(
        { id: "X_PERCENT_COMPLETE" },
        { number: completionPercentage }
      )
    ), /* @__PURE__ */ React41.createElement(UtilityText6, { size: "sm", emphasis: "emphasized" }, "\u2022"), /* @__PURE__ */ React41.createElement(UtilityText6, { size: "sm", emphasis: "subtle" }, formatMessage(
      { id: "X_OF_Y_ACTIVITIES" },
      { completed: completedActivities, total: totalActivities }
    ))), /* @__PURE__ */ React41.createElement(
      ProgressBar,
      {
        current: completedActivities,
        total: totalActivities,
        customBarFillColor: "input.border.success"
      }
    )),
    isGroupChallenge && /* @__PURE__ */ React41.createElement(YourRanking, null)
  ));
};

// src/components/challenge-details-contents/challenge-details-contents.component.tsx
import React43 from "react";
import { useIntl as useIntl23 } from "@leagueplatform/locales";
import {
  Box as Box15,
  Icon,
  Responsive,
  StackLayout as StackLayout8,
  UtilityText as UtilityText8,
  queryHelpers,
  useMediaQuery
} from "@leagueplatform/genesis-core";
import { SHORT_DATE_FORMAT as SHORT_DATE_FORMAT3 } from "@leagueplatform/web-common";

// src/pages/challenge-landing-page/components/sidebar/components/enrollment-status-information/enrollment-status-information.component.tsx
import React42 from "react";
import { useIntl as useIntl22 } from "@leagueplatform/locales";
import { StatusBadge, UtilityText as UtilityText7 } from "@leagueplatform/genesis-core";
import {
  SHORT_DATE_AND_TIME_FORMAT,
  SHORT_DATE_FORMAT as SHORT_DATE_FORMAT2
} from "@leagueplatform/web-common";
var EnrollmentStatusInformation = () => {
  var _a, _b, _c;
  const { formatMessage, formatDate } = useIntl22();
  const { data: challengeData } = useGetChallengeByIdData();
  const { data: userData } = useGetUserProfile();
  const { default_timezone: defaultTimezone } = userData || {};
  const {
    challengeType,
    endEnroll,
    startEnroll,
    status,
    endDate,
    totalActivities,
    userChallenge
  } = challengeData.data;
  const { UPCOMING, ACTIVE, CLOSED } = CHALLENGE_STATUS;
  const isSoloChallenge = challengeType === "solo";
  const isNowBeforeStartEnrollDate = isBeforeEnrollmentPeriod(
    startEnroll,
    defaultTimezone
  );
  const enrollmentOpen = isEnrollmentOpen(
    startEnroll,
    endEnroll,
    defaultTimezone
  );
  const userIsEnrolled = ((_a = userChallenge == null ? void 0 : userChallenge.data) == null ? void 0 : _a.enrollmentStatus) === "enrolled";
  const allActivitiesCompleted = ((_c = (_b = userChallenge == null ? void 0 : userChallenge.data) == null ? void 0 : _b.progress) == null ? void 0 : _c.completedActivities) === totalActivities;
  const challengeIsClosed = status === CLOSED;
  const dateFormatOptions = __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT2), {
    timeZone: defaultTimezone
  });
  const dateAndTimeFormatOptions = __spreadProps(__spreadValues({}, SHORT_DATE_AND_TIME_FORMAT), {
    timeZone: defaultTimezone
  });
  switch (true) {
    case (isSoloChallenge && userIsEnrolled && !challengeIsClosed):
    case (userIsEnrolled && status === UPCOMING):
      return /* @__PURE__ */ React42.createElement(
        StatusBadge,
        {
          label: formatMessage({ id: "JOINED" }),
          status: "success",
          showLight: false
        }
      );
    case (userIsEnrolled && status === ACTIVE):
      return /* @__PURE__ */ React42.createElement(StatusBadge, { label: formatMessage({ id: "ACTIVE" }), status: "success" });
    case (userIsEnrolled && challengeIsClosed && allActivitiesCompleted):
      return /* @__PURE__ */ React42.createElement(
        StatusBadge,
        {
          label: formatMessage(
            { id: "COMPLETED_ON_DATE" },
            {
              date: formatDate(endDate, dateFormatOptions)
            }
          ),
          status: "neutral"
        }
      );
    case (userIsEnrolled && challengeIsClosed):
      return /* @__PURE__ */ React42.createElement(
        StatusBadge,
        {
          label: formatMessage(
            { id: "ENDED_ON_DATE" },
            {
              date: formatDate(endDate, dateFormatOptions)
            }
          ),
          status: "error"
        }
      );
    case isSoloChallenge:
      return /* @__PURE__ */ React42.createElement(
        StatusBadge,
        {
          label: formatMessage({ id: "AVAILABLE" }),
          status: "neutral",
          showLight: false
        }
      );
    case isNowBeforeStartEnrollDate:
      return /* @__PURE__ */ React42.createElement(UtilityText7, null, formatMessage(
        { id: "SIGN_UP_BEGINS_DATE" },
        {
          date: formatDate(startEnroll, dateAndTimeFormatOptions)
        }
      ));
    case enrollmentOpen:
      return /* @__PURE__ */ React42.createElement(UtilityText7, null, formatMessage(
        { id: "SIGN_UP_BY_DATE" },
        {
          date: formatDate(endEnroll, dateAndTimeFormatOptions)
        }
      ));
    case !challengeIsClosed:
      return /* @__PURE__ */ React42.createElement(UtilityText7, null, formatMessage({
        id: "SIGN_UP_PERIOD_PASSED"
      }));
    case challengeIsClosed:
    default:
      return /* @__PURE__ */ React42.createElement(
        StatusBadge,
        {
          label: formatMessage(
            { id: "ENDED_ON_DATE" },
            {
              date: formatDate(endDate, dateFormatOptions)
            }
          ),
          status: "error"
        }
      );
  }
};

// src/components/challenge-details-contents/challenge-details-contents.component.tsx
var ChallengeDetailsContents = () => {
  var _a;
  const { formatMessage, formatDate } = useIntl23();
  const { data: userData } = useGetUserProfile();
  const { default_timezone: defaultTimezone } = userData || {};
  const isMobile = useMediaQuery(queryHelpers.down("mobileLandscape"));
  const { data: challengeData } = useGetChallengeByIdData();
  const { challengeType, endDate, status, startDate, userChallenge } = challengeData.data;
  const isSoloChallenge = challengeType === "solo";
  const userIsEnrolled = ((_a = userChallenge == null ? void 0 : userChallenge.data) == null ? void 0 : _a.enrollmentStatus) === "enrolled";
  const displayClockIcon = !isSoloChallenge && !userIsEnrolled && status !== "closed" /* CLOSED */;
  const dateFormatOptions = __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT3), {
    timeZone: defaultTimezone
  });
  return /* @__PURE__ */ React43.createElement(
    StackLayout8,
    {
      spacing: "$one",
      horizontalAlignment: isMobile && !userIsEnrolled ? "center" : "stretch"
    },
    /* @__PURE__ */ React43.createElement(StackLayout8, { spacing: "$one", orientation: "horizontal" }, /* @__PURE__ */ React43.createElement(Icon, { icon: "descriptiveCalendar", css: { minWidth: "$oneAndHalf" } }), isSoloChallenge ? /* @__PURE__ */ React43.createElement(UtilityText8, null, formatMessage({ id: "THIS_CHALLENGE_RUNS_YEAR_ROUND" })) : /* @__PURE__ */ React43.createElement(React43.Fragment, null, /* @__PURE__ */ React43.createElement(Responsive, { up: "laptop" }, /* @__PURE__ */ React43.createElement(StackLayout8, { spacing: "$half" }, /* @__PURE__ */ React43.createElement(UtilityText8, null, formatMessage(
      { id: "START_DAY_AT_TIME" },
      {
        day: formatDate(startDate, dateFormatOptions),
        endDate: formatDate(endDate, dateFormatOptions)
      }
    )), /* @__PURE__ */ React43.createElement(UtilityText8, null, formatMessage(
      { id: "END_DAY_AT_TIME" },
      {
        day: formatDate(endDate, dateFormatOptions)
      }
    )))), /* @__PURE__ */ React43.createElement(Responsive, { down: "laptop" }, /* @__PURE__ */ React43.createElement(UtilityText8, null, formatMessage(
      { id: "START_AND_END_DATES" },
      {
        startDate: formatDate(startDate, dateFormatOptions),
        endDate: formatDate(endDate, dateFormatOptions)
      }
    ))))),
    /* @__PURE__ */ React43.createElement(StackLayout8, { spacing: "$one", orientation: "horizontal" }, displayClockIcon ? /* @__PURE__ */ React43.createElement(Icon, { icon: "descriptiveClock", css: { minWidth: "$oneAndHalf" } }) : /* @__PURE__ */ React43.createElement(Responsive, { up: "laptop" }, /* @__PURE__ */ React43.createElement(Box15, { css: { width: "$oneAndHalf" } })), /* @__PURE__ */ React43.createElement(EnrollmentStatusInformation, null))
  );
};

// src/components/challenge-details-card-banner/challenge-details-card-banner.component.tsx
import React44 from "react";
import { useIntl as useIntl24 } from "@leagueplatform/locales";
import { SHORT_DATE_FORMAT as SHORT_DATE_FORMAT4 } from "@leagueplatform/web-common";
import {
  ProgramBanner,
  ProgramDetailCardFooter
} from "@leagueplatform/health-journey-common";
import { queryHelpers as queryHelpers2, useMediaQuery as useMediaQuery2 } from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset8 } from "@leagueplatform/asset-config";
var ChallengeDetailsCardBanner = () => {
  var _a, _b, _c;
  const { formatMessage, formatDate } = useIntl24();
  const { data: challengeData } = useGetChallengeByIdData();
  const { data: userData } = useGetUserProfile();
  const { default_timezone: defaultTimezone } = userData || {};
  const { challengeType, endDate, endEnroll, status } = challengeData.data;
  const isGroupChallenge = challengeType === "group";
  const isBelowLaptop = useMediaQuery2(queryHelpers2.down("laptop"));
  const userIsEnrolled = ((_c = (_b = (_a = challengeData.data) == null ? void 0 : _a.userChallenge) == null ? void 0 : _b.data) == null ? void 0 : _c.enrollmentStatus) === "enrolled";
  const isNowAfterSignUpPeriod = isAfterEnrollmentPeriod(
    endEnroll,
    defaultTimezone
  );
  const displaySignUpDatePassedBanner = isGroupChallenge && !userIsEnrolled && isNowAfterSignUpPeriod && status !== "closed";
  const completedIcon = handleStaticAsset8(
    "CHALLENGES_COMPLETED_CHALLENGE" /* CHALLENGES_COMPLETED_CHALLENGE */
  );
  const dateFormatOptions = __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT4), {
    timeZone: defaultTimezone
  });
  if (displaySignUpDatePassedBanner) {
    return isBelowLaptop ? /* @__PURE__ */ React44.createElement(
      ProgramBanner,
      {
        boldedText: formatMessage({ id: "SIGN_UP_PERIOD_PASSED" }),
        basicText: formatMessage({ id: "SIGN_UP_PERIOD_PASSED_DETAIL" }),
        css: {
          borderRadius: "$medium",
          backgroundColor: "$warningBackgroundSubdued",
          padding: "$one"
        }
      }
    ) : /* @__PURE__ */ React44.createElement(
      ProgramDetailCardFooter,
      {
        boldedText: formatMessage({ id: "SIGN_UP_PERIOD_PASSED" }),
        basicText: formatMessage({ id: "SIGN_UP_PERIOD_PASSED_DETAIL" })
      }
    );
  }
  if (status === "closed") {
    return isBelowLaptop ? /* @__PURE__ */ React44.createElement(
      ProgramBanner,
      {
        boldedText: formatMessage({ id: "THIS_CHALLENGE_HAS_ENDED" }),
        basicText: formatMessage(
          { id: "COMPLETED_ON_DATE" },
          {
            date: formatDate(endDate, dateFormatOptions)
          }
        ),
        css: {
          borderRadius: "$medium",
          backgroundColor: "$warningBackgroundSubdued",
          padding: "$one"
        },
        icon: completedIcon
      }
    ) : /* @__PURE__ */ React44.createElement(
      ProgramDetailCardFooter,
      {
        boldedText: formatMessage({ id: "THIS_CHALLENGE_HAS_ENDED" }),
        basicText: formatMessage(
          { id: "COMPLETED_ON_DATE" },
          {
            date: formatDate(endDate, dateFormatOptions)
          }
        ),
        icon: completedIcon
      }
    );
  }
  return null;
};

// src/pages/challenge-landing-page/components/challenge-heading/heading-settings-cog/heading-settings-cog.component.tsx
import React50, { useState as useState6 } from "react";
import { useParamsLegacy as useParams15 } from "@leagueplatform/routing";
import { useIntl as useIntl27 } from "@leagueplatform/locales";

// src/components/settings-cog/settings-cog.component.tsx
import React46 from "react";
import { useIntl as useIntl25 } from "@leagueplatform/locales";
import { useParamsLegacy as useParams13 } from "@leagueplatform/routing";
import { Box as Box17, genesisStyled as genesisStyled4, css as css3, Link as Link7 } from "@leagueplatform/genesis-commons";
import { EVENT_NAME as EVENT_NAME12, SCREEN_NAMES as SCREEN_NAMES4 } from "@leagueplatform/analytics";

// src/components/settings-dropdown/settings-dropdown.component.tsx
import React45, { useRef as useRef2 } from "react";
import { Box as Box16, genesisStyled as genesisStyled3 } from "@leagueplatform/genesis-commons";

// src/pages/challenge-landing-page/hooks/use-handle-dropdown-with-modal.hook.ts
import { useEffect as useEffect7 } from "react";
import { KEY } from "@leagueplatform/web-common";
var useHandleDropdownWithModal = ({
  isOpen,
  setIsOpen,
  ref,
  modalIsOpen
}) => {
  useEffect7(() => {
    const handleClickedOutside = (event) => {
      if (isOpen && ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleEsc = (event) => {
      if (event.key === KEY.ESC) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("click", handleClickedOutside);
      document.addEventListener("keydown", handleEsc);
    }
    if (modalIsOpen) {
      document.removeEventListener("click", handleClickedOutside);
      document.removeEventListener("keydown", handleEsc);
    }
    return () => {
      document.removeEventListener("click", handleClickedOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [isOpen, setIsOpen, modalIsOpen, ref]);
};

// src/components/settings-dropdown/settings-dropdown.component.tsx
var SETTINGS_DROPDOWN_FIXED_WIDTH = "260px";
var StyledDropdown = genesisStyled3(Box16)`
  & > li:last-child {
    border-bottom: 0px;
  }
`;
var SETTINGS_BUTTON_LABEL = "settings_button_label";
var SettingsDropdown = ({
  isOpen,
  setIsOpen,
  children,
  modalIsOpen
}) => {
  const dropdownRef = useRef2(null);
  useHandleDropdownWithModal({
    isOpen,
    setIsOpen,
    ref: dropdownRef,
    modalIsOpen
  });
  return /* @__PURE__ */ React45.createElement(
    StyledDropdown,
    {
      as: "ul",
      role: "menu",
      "aria-labelledby": SETTINGS_BUTTON_LABEL,
      backgroundColor: "surface.background.primary",
      borderRadius: "medium",
      boxShadow: "dropdown",
      paddingX: "one",
      paddingY: "half",
      position: "absolute",
      ref: dropdownRef,
      insetInlineEnd: "none",
      top: "four",
      width: SETTINGS_DROPDOWN_FIXED_WIDTH,
      zIndex: "1"
    },
    children
  );
};

// src/components/settings-cog/settings-cog.component.tsx
var ACTIVE_BUTTON_STYLES = {
  backgroundColor: "primary.background.pressed",
  color: "onSurface.text.reversed",
  textDecoration: "none"
};
var FOCUS_BUTTON_STYLES = {
  backgroundColor: "primary.background.hovered",
  color: "onSurface.text.reversed",
  textDecoration: "none"
};
var SettingsButton = genesisStyled4(Link7)(
  () => css3({
    "&:hover": FOCUS_BUTTON_STYLES,
    "&:focus": FOCUS_BUTTON_STYLES,
    "&:active": ACTIVE_BUTTON_STYLES
  })
);
var SettingsCog = ({
  children,
  modalIsOpen,
  isSettingsDropdownOpen,
  setIsSettingsDropdownOpen
}) => {
  const { formatMessage } = useIntl25();
  const { teamId } = useParams13();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME12.BUTTON_CLICKED, {
    screen_name: teamId ? "team details" /* TEAM_DETAILS */ : SCREEN_NAMES4.HEALTH_CAMPAIGN_DETAIL,
    detail
  });
  return /* @__PURE__ */ React46.createElement(Box17, { position: "relative" }, /* @__PURE__ */ React46.createElement(
    SettingsButton,
    __spreadValues({
      as: "button",
      id: SETTINGS_BUTTON_LABEL,
      alignItems: "center",
      "aria-expanded": isSettingsDropdownOpen,
      "aria-haspopup": "true",
      "aria-label": formatMessage({ id: "SETTINGS" }),
      border: "none",
      backgroundColor: "surface.background.primary",
      display: "flex",
      onClick: () => {
        setIsSettingsDropdownOpen(!isSettingsDropdownOpen);
        if (!isSettingsDropdownOpen) {
          handleAnalyticsClick("settings" /* SETTINGS */);
        }
      },
      paddingX: "one",
      paddingY: "threeQuarters"
    }, isSettingsDropdownOpen && ACTIVE_BUTTON_STYLES),
    /* @__PURE__ */ React46.createElement(ChallengeIcon, { iconType: "COG" /* COG */ }),
    /* @__PURE__ */ React46.createElement(
      Box17,
      {
        as: "span",
        display: { _: "none", tablet: "block" },
        marginInlineStart: "half"
      },
      formatMessage({ id: "SETTINGS" })
    )
  ), isSettingsDropdownOpen && /* @__PURE__ */ React46.createElement(
    SettingsDropdown,
    {
      isOpen: isSettingsDropdownOpen,
      setIsOpen: setIsSettingsDropdownOpen,
      modalIsOpen
    },
    children
  ));
};

// src/components/settings-dropdown/settings-dropdown-item.component.tsx
import React47 from "react";
import { LinkLegacy as Link8 } from "@leagueplatform/routing";
import {
  SubtitleOne,
  QuietButton,
  Box as Box18,
  Flex as Flex12,
  genesisStyled as genesisStyled5
} from "@leagueplatform/genesis-commons";
var DropdownButton = genesisStyled5(QuietButton)(
  ({ theme: { colors } }) => `
  &:hover, &:active, &:focus {
    background-color: ${colors.decorative.brand.primary.pastel}
  }
  `
);
var SettingsDropdownItem = ({
  onClick,
  children,
  to
}) => /* @__PURE__ */ React47.createElement(
  Box18,
  {
    as: "li",
    borderBottomColor: "interactive.border.disabled",
    borderBottomWidth: "thin",
    paddingX: "quarter",
    paddingY: "half",
    role: "none"
  },
  /* @__PURE__ */ React47.createElement(
    DropdownButton,
    __spreadProps(__spreadValues({}, to && {
      as: Link8,
      textDecoration: "none",
      to
    }), {
      justifyContent: "flex-start",
      onClick,
      paddingInlineStart: "half",
      role: "menuitem",
      width: "100%"
    }),
    /* @__PURE__ */ React47.createElement(Flex12, null, /* @__PURE__ */ React47.createElement(SubtitleOne, { as: "span", color: "secondary.text.default" }, children))
  )
);

// src/pages/challenge-landing-page/components/challenge-heading/heading-settings-cog/heading-settings-cog.component.tsx
import { EVENT_NAME as EVENT_NAME14, SCREEN_NAMES as SCREEN_NAMES5 } from "@leagueplatform/analytics";
import { JOURNEY_ROUTES as JOURNEY_ROUTES6 } from "@leagueplatform/health-journey-common";

// src/pages/challenge-landing-page/components/challenge-heading/leave-challenge-modal/leave-challenge-modal.component.tsx
import React49, { useEffect as useEffect8 } from "react";
import { useIntl as useIntl26 } from "@leagueplatform/locales";
import { DangerButton } from "@leagueplatform/genesis-commons";

// src/components/confirmation-modal/confirmation-modal.component.tsx
import React48 from "react";
import {
  HeadingText as HeadingText4,
  Modal as Modal3,
  StackLayout as StackLayout9,
  UtilityText as UtilityText9
} from "@leagueplatform/genesis-core";
var ConfirmationModal = ({
  heading,
  description,
  isSettingsDropdownOpen,
  onDismiss,
  onMountAnalytics,
  children
}) => {
  if (isSettingsDropdownOpen && onMountAnalytics) {
    onMountAnalytics();
  }
  return /* @__PURE__ */ React48.createElement(Modal3.Root, { open: isSettingsDropdownOpen, onOpenChange: onDismiss }, /* @__PURE__ */ React48.createElement(Modal3.Content, null, /* @__PURE__ */ React48.createElement(StackLayout9, { spacing: "$oneAndHalf" }, /* @__PURE__ */ React48.createElement(Modal3.Title, null, /* @__PURE__ */ React48.createElement(HeadingText4, { size: "xl", level: "2" }, heading)), /* @__PURE__ */ React48.createElement(StackLayout9, { spacing: "$four" }, /* @__PURE__ */ React48.createElement(Modal3.Description, null, /* @__PURE__ */ React48.createElement(UtilityText9, null, description)), /* @__PURE__ */ React48.createElement(
    StackLayout9,
    {
      orientation: "horizontal",
      horizontalAlignment: "end",
      css: { width: "100%" }
    },
    children
  )))));
};

// src/pages/challenge-landing-page/components/challenge-heading/leave-challenge-modal/leave-challenge-modal.component.tsx
import { EVENT_NAME as EVENT_NAME13 } from "@leagueplatform/analytics";

// src/pages/challenge-landing-page/components/challenge-heading/leave-challenge-modal/hooks/use-leave-challenge.hook.ts
import { useMutation as useMutation5, useQueryClient as useQueryClient4 } from "react-query";
import { useParamsLegacy as useParams14 } from "@leagueplatform/routing";
import { toastActions as toastActions4, TOAST_STATUS as TOAST_STATUS4 } from "@leagueplatform/toast-messages";
import {
  CHALLENGES_PATH as CHALLENGES_PATH2,
  deleteUserChallenge
} from "@leagueplatform/health-journey-api";
var useLeaveChallenge = () => {
  const { challengeId } = useParams14();
  const { data: challengeData } = useGetChallengeByIdData();
  const queryClient = useQueryClient4();
  const { id: userChallengeId } = challengeData.data.userChallenge.data;
  return useMutation5(() => deleteUserChallenge(userChallengeId), {
    onSuccess: () => {
      queryClient.invalidateQueries([CHALLENGES_PATH2, challengeId]);
      toastActions4.add({
        type: TOAST_STATUS4.SUCCESS,
        textId: "SUCCESSFULLY_LEFT_CHALLENGE"
      });
    },
    onError: () => {
      toastActions4.add({
        type: TOAST_STATUS4.ERROR,
        textId: "UNABLE_TO_LEAVE_CHALLENGE",
        shouldAutoClose: false
      });
    }
  });
};

// src/pages/challenge-landing-page/components/challenge-heading/leave-challenge-modal/leave-challenge-modal.component.tsx
var LeaveChallengeModal = ({
  isSettingsDropdownOpen,
  onDismiss
}) => {
  const { formatMessage } = useIntl26();
  const leaveChallengeMutation = useLeaveChallenge();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME13.BUTTON_CLICKED, {
    screen_name: "leave challenge" /* LEAVE_CHALLENGE */,
    detail,
    is_critical_event: true
  });
  useEffect8(() => onDismiss, []);
  return /* @__PURE__ */ React49.createElement(
    ConfirmationModal,
    {
      heading: formatMessage({ id: "LEAVE_CHALLENGE_QUESTION" }),
      description: formatMessage({
        id: "LEAVE_CHALLENGE_DETAIL"
      }),
      isSettingsDropdownOpen,
      onMountAnalytics: () => trackChallengesAnalyticsEvent(EVENT_NAME13.SCREEN_LOADED, {
        screen_name: "leave challenge" /* LEAVE_CHALLENGE */
      }),
      onDismiss: () => {
        onDismiss();
        trackChallengesAnalyticsEvent(EVENT_NAME13.BUTTON_CLICKED, {
          screen_name: "leave challenge" /* LEAVE_CHALLENGE */,
          detail: "exit" /* EXIT */
        });
      }
    },
    /* @__PURE__ */ React49.createElement(
      DangerButton,
      {
        onClick: () => {
          leaveChallengeMutation.mutate();
          handleAnalyticsClick("leave challenge" /* LEAVE_CHALLENGE */);
        },
        isLoading: leaveChallengeMutation.isLoading
      },
      formatMessage({ id: "LEAVE" })
    )
  );
};

// src/pages/challenge-landing-page/components/challenge-heading/heading-settings-cog/heading-settings-cog.component.tsx
var HeadingSettingsCog = ({
  status,
  isSoloChallenge
}) => {
  const { challengeId } = useParams15();
  const { formatMessage } = useIntl27();
  const [displayLeaveChallengeModal, setDisplayLeaveChallengeModal] = useState6(false);
  const [isSettingsDropdownOpen, setIsSettingsDropdownOpen] = useState6(false);
  const isChallengeLeavable = status === "upcoming" /* UPCOMING */ || status === "active" /* ACTIVE */;
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME14.BUTTON_CLICKED, {
    screen_name: SCREEN_NAMES5.HEALTH_CAMPAIGN_DETAIL,
    detail
  });
  return /* @__PURE__ */ React50.createElement(
    SettingsCog,
    {
      modalIsOpen: displayLeaveChallengeModal,
      isSettingsDropdownOpen,
      setIsSettingsDropdownOpen
    },
    !isSoloChallenge && /* @__PURE__ */ React50.createElement(
      SettingsDropdownItem,
      {
        to: JOURNEY_ROUTES6.getChallengeSettings(challengeId),
        onClick: () => handleAnalyticsClick("settings menu - privacy" /* SETTINGS_MENU_PRIVACY */)
      },
      formatMessage({ id: "PRIVACY" })
    ),
    isChallengeLeavable && /* @__PURE__ */ React50.createElement(React50.Fragment, null, /* @__PURE__ */ React50.createElement(
      SettingsDropdownItem,
      {
        onClick: () => {
          setDisplayLeaveChallengeModal(true);
          handleAnalyticsClick("settings menu - leave challenge" /* SETTINGS_MENU_LEAVE_CHALLENGE */);
        }
      },
      formatMessage({ id: "LEAVE_CHALLENGE" })
    ), /* @__PURE__ */ React50.createElement(
      LeaveChallengeModal,
      {
        isSettingsDropdownOpen: displayLeaveChallengeModal,
        onDismiss: () => {
          setDisplayLeaveChallengeModal(false);
        }
      }
    ))
  );
};

// src/pages/challenge-landing-page/components/challenge-heading/challenge-heading.component.tsx
var ChallengeHeading = ({
  bannerText,
  image,
  imageAltText,
  title,
  userIsEnrolled,
  status,
  challengeType
}) => {
  const { $tifelse } = useIntl28();
  const isMobile = useMediaQuery3(queryHelpers3.down("mobileLandscape"));
  const isChallengeLeavable = status === "upcoming" /* UPCOMING */ || status === "active" /* ACTIVE */;
  const isSoloChallenge = challengeType === "solo";
  const badgeProps = {
    css: {
      backgroundColor: "$warningBackgroundSubdued",
      borderRadius: "$small"
    },
    iconTextProps: {
      iconProps: {
        icon: isSoloChallenge ? "tinyStar" : "capabilityGroupChallenges",
        tint: "$warningBorderDefault"
      },
      text: /* @__PURE__ */ React51.createElement(UtilityText10, { size: "eyebrow", emphasis: "emphasized" }, $tifelse(isSoloChallenge, "SOLO_CHALLENGE", "GROUP_CHALLENGE"))
    }
  };
  const displaySettings = userIsEnrolled && isChallengeLeavable;
  return /* @__PURE__ */ React51.createElement(
    ProgramHeading,
    {
      bannerText,
      image,
      imageAltText,
      title,
      badge: challengeType && badgeProps,
      settingsComponent: displaySettings && /* @__PURE__ */ React51.createElement(
        HeadingSettingsCog,
        {
          status,
          isSoloChallenge
        }
      )
    },
    /* @__PURE__ */ React51.createElement(Box19, { css: { width: "100%" } }, /* @__PURE__ */ React51.createElement(Responsive2, { down: "laptop" }, /* @__PURE__ */ React51.createElement(
      StackLayout10,
      {
        spacing: "$oneAndHalf",
        horizontalAlignment: isMobile && !displaySettings ? "center" : "stretch"
      },
      /* @__PURE__ */ React51.createElement(ChallengeDetailsContents, null),
      /* @__PURE__ */ React51.createElement(ChallengeDetailsCardBanner, null),
      userIsEnrolled && /* @__PURE__ */ React51.createElement(ProgressTracker, null)
    )))
  );
};

// src/pages/challenge-landing-page/components/challenge-details/challenge-details.component.tsx
import React52 from "react";
import { css as css4, genesisStyled as genesisStyled6, BodyOne as BodyOne5 } from "@leagueplatform/genesis-commons";
import { StackLayout as StackLayout11, HeadingText as HeadingText5 } from "@leagueplatform/genesis-core";
import { HtmlToReact } from "@leagueplatform/web-common";
import { handleStaticAsset as handleStaticAsset9 } from "@leagueplatform/asset-config";
var StyledList = genesisStyled6(BodyOne5)(() => {
  const checkCircle2 = handleStaticAsset9(
    "CHALLENGES_CHECK_CIRCLE" /* CHALLENGES_CHECK_CIRCLE */
  );
  return css4({
    listStyle: "none",
    padding: 0,
    "& > li": {
      backgroundImage: `url(${checkCircle2})`,
      backgroundSize: 16,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "0 4px",
      paddingInlineStart: "oneAndHalf"
    }
  });
});
var StyledBodyOne = genesisStyled6(BodyOne5)(
  css4({
    overflowWrap: "anywhere"
  })
);
var ChallengeDetailsHtmlToReactOptions = {
  ul: {
    component: StyledList
  },
  p: {
    component: StyledBodyOne
  }
};
var ChallengeDetails = ({
  heading,
  content,
  children
}) => {
  if (!content && !children)
    return null;
  return /* @__PURE__ */ React52.createElement(StackLayout11, { spacing: "$half" }, /* @__PURE__ */ React52.createElement(HeadingText5, { size: "xl", level: "2" }, heading), children || /* @__PURE__ */ React52.createElement(
    HtmlToReact,
    {
      htmlString: content,
      options: ChallengeDetailsHtmlToReactOptions
    }
  ));
};

// src/pages/challenge-landing-page/components/leaderboard/leaderboard.component.tsx
import React59, { useState as useState7 } from "react";
import { Flex as Flex17, HeadingFour as HeadingFour4, Spinner as Spinner3 } from "@leagueplatform/genesis-commons";
import { ErrorState as ErrorState3 } from "@leagueplatform/web-common-components";
import { useIntl as useIntl33 } from "@leagueplatform/locales";
import {
  ParagraphText as ParagraphText2,
  Popover,
  StackLayout as StackLayout13
} from "@leagueplatform/genesis-core";

// src/components/leaderboard/leaderboard-table.component.tsx
import React55 from "react";
import {
  Box as Box21,
  Flex as Flex14,
  BodyTwoSecondary as BodyTwoSecondary2,
  SubtitleTwo as SubtitleTwo3,
  VisuallyHidden as VisuallyHidden7
} from "@leagueplatform/genesis-commons";
import { Badge } from "@leagueplatform/web-common-components";
import { useIntl as useIntl30 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME15, SCREEN_NAMES as SCREEN_NAMES6 } from "@leagueplatform/analytics";

// src/components/leaderboard/leaderboard-skeleton-loader.component.tsx
import React53 from "react";
import { Box as Box20, Flex as Flex13 } from "@leagueplatform/genesis-commons";
import { SkeletonBox as SkeletonBox2 } from "@leagueplatform/web-common-components";
var LeaderboardSkeletonLoader = () => {
  const leaderboardSkeleton = Array(5).fill(0);
  return /* @__PURE__ */ React53.createElement(Box20, null, leaderboardSkeleton.map(({ id }) => /* @__PURE__ */ React53.createElement(
    SkeletonBox2,
    {
      width: "100%",
      marginBottom: "quarter",
      key: id,
      role: "presentation"
    },
    /* @__PURE__ */ React53.createElement(
      Flex13,
      {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "start",
        paddingTop: "oneAndHalf",
        paddingBottom: "oneAndHalf"
      },
      /* @__PURE__ */ React53.createElement(
        SkeletonBox2,
        {
          width: "twoAndHalf",
          height: "twoAndHalf",
          marginInlineStart: "four",
          borderRadius: "circle",
          backgroundColor: "interactive.background.disabled"
        }
      ),
      /* @__PURE__ */ React53.createElement(
        SkeletonBox2,
        {
          marginInlineStart: "one",
          width: "40%",
          height: "oneAndHalf",
          backgroundColor: "interactive.background.disabled"
        }
      )
    )
  )));
};

// src/components/leaderboard/utils/is-team-rank.util.ts
var isTeamRank = (data) => data.teamName !== void 0;

// src/components/leaderboard/utils/get-displayed-rank-details.util.ts
var getDisplayedRankDetails = (leaderboardRank, userData, formatMessage) => {
  var _a, _b, _c;
  const { rank, id, avatarUrl, rankingUnit, score } = leaderboardRank;
  let isCurrentUser = false;
  let isCurrentTeam = false;
  let firstName = "";
  let lastName = "";
  let teamName = "";
  let user;
  if (isTeamRank(leaderboardRank)) {
    teamName = leaderboardRank.teamName;
    isCurrentTeam = !!((_b = (_a = leaderboardRank.challengeTeam) == null ? void 0 : _a.data) == null ? void 0 : _b.id);
  } else {
    firstName = leaderboardRank.firstName;
    lastName = leaderboardRank.lastName;
    user = leaderboardRank.user;
    isCurrentUser = ((_c = user == null ? void 0 : user.data) == null ? void 0 : _c.id) === (userData == null ? void 0 : userData.user_id);
  }
  const formattedName = (firstName == null ? void 0 : firstName.length) && (lastName == null ? void 0 : lastName.length) ? formatUserName({ firstName, lastName }) : teamName;
  const currentUserOrTeamName = isTeamRank(leaderboardRank) ? formatMessage({ id: "LEADERBOARD_CURRENT_TEAM_NAME" }, { team: teamName }) : formatMessage(
    { id: "LEADERBOARD_CURRENT_USER_NAME" },
    { user: formattedName }
  );
  const isHighlightedRank = isCurrentUser || isCurrentTeam;
  return {
    avatarUrl,
    currentUserOrTeamName,
    firstName,
    formattedName,
    id,
    isCurrentTeam,
    isCurrentUser,
    isHighlightedRank,
    lastName,
    rank,
    teamName,
    rankingUnit,
    score
  };
};

// src/components/leaderboard/challenge-unit-icon.component.tsx
import React54 from "react";
import { useIntl as useIntl29 } from "@leagueplatform/locales";
import {
  StackLayout as StackLayout12,
  UtilityText as UtilityText11,
  VisuallyHidden as VisuallyHidden6
} from "@leagueplatform/genesis-core";
var ChallengeUnitIcon = ({
  score = 0,
  rankingUnit,
  isOnPodium
}) => {
  const { formatNumber } = useIntl29();
  return /* @__PURE__ */ React54.createElement(
    StackLayout12,
    {
      orientation: "horizontal",
      spacing: "$half",
      verticalAlignment: "center"
    },
    /* @__PURE__ */ React54.createElement(
      UtilityText11,
      {
        css: {
          color: "inherit",
          fontWeight: "inherit",
          fontSize: "inherit"
        }
      },
      formatNumber(score),
      " ",
      !isOnPodium && rankingUnit,
      isOnPodium && /* @__PURE__ */ React54.createElement(VisuallyHidden6, null, " ", rankingUnit, " ")
    )
  );
};

// src/components/leaderboard/leaderboard-table.component.tsx
var LeaderboardTable = ({
  leaderboardData,
  displayViewMore,
  isFetchingNextPage,
  fetchNextPage,
  leaderboardView
}) => {
  const { formatMessage } = useIntl30();
  const { data: userData, isLoading: isUserLoading } = useGetUserProfile();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  if (isUserLoading)
    return /* @__PURE__ */ React55.createElement(LeaderboardSkeletonLoader, null);
  const handleAnalyticsClick = () => {
    trackChallengesAnalyticsEvent(EVENT_NAME15.BUTTON_CLICKED, {
      screen_name: SCREEN_NAMES6.HEALTH_CAMPAIGN_DETAIL,
      detail: "view more" /* VIEW_MORE */,
      tab_name: "leaderboard" /* LEADERBOARD */,
      challenge_leaderboard_type: leaderboardView === 0 ? "individual" : "team"
    });
  };
  return /* @__PURE__ */ React55.createElement(Flex14, { flexDirection: "column", alignItems: "center" }, /* @__PURE__ */ React55.createElement("table", { width: "100%" }, /* @__PURE__ */ React55.createElement(VisuallyHidden7, { as: "thead" }, /* @__PURE__ */ React55.createElement("tr", null, /* @__PURE__ */ React55.createElement("th", null, formatMessage({ id: "LEADERBOARD_RANKING" })), /* @__PURE__ */ React55.createElement("th", null, formatMessage({ id: "LEADERBOARD_USERNAME" })), /* @__PURE__ */ React55.createElement("th", null, leaderboardData[0].rankingUnit))), /* @__PURE__ */ React55.createElement(Box21, { as: "tbody" }, leaderboardData.map((leaderboardRank) => {
    const {
      avatarUrl,
      currentUserOrTeamName,
      firstName,
      formattedName,
      id,
      isHighlightedRank,
      lastName,
      rank,
      teamName,
      score,
      rankingUnit
    } = getDisplayedRankDetails(
      leaderboardRank,
      // TODO remove the "!" once we actually check the `isSuccess` of the query
      userData,
      formatMessage
    );
    return /* @__PURE__ */ React55.createElement(
      Flex14,
      {
        alignItems: "center",
        backgroundColor: isHighlightedRank ? "highlight.background.subdued" : "inherit",
        borderTopColor: "onSurface.border.subdued",
        borderTopWidth: "thin",
        key: id,
        padding: "one",
        as: "tr"
      },
      /* @__PURE__ */ React55.createElement(BodyTwoSecondary2, { minWidth: "twoAndHalf", as: "td" }, rank),
      /* @__PURE__ */ React55.createElement(
        Box21,
        {
          as: "td",
          marginX: "one",
          size: "twoAndHalf",
          minWidth: "twoAndHalf"
        },
        /* @__PURE__ */ React55.createElement(
          ChallengeProfilePicture,
          {
            profilePicture: avatarUrl,
            firstName: (firstName == null ? void 0 : firstName.length) ? firstName : teamName,
            lastName: (lastName == null ? void 0 : lastName.length) ? lastName : "",
            backgroundColor: "$decorativeBrandPrimaryDefault"
          }
        )
      ),
      /* @__PURE__ */ React55.createElement(Box21, { as: "td" }, /* @__PURE__ */ React55.createElement(SubtitleTwo3, { as: "p" }, isHighlightedRank ? currentUserOrTeamName : formattedName)),
      /* @__PURE__ */ React55.createElement(
        SubtitleTwo3,
        {
          as: "td",
          textAlign: "end",
          marginInlineStart: "auto",
          verticalAlign: "middle"
        },
        /* @__PURE__ */ React55.createElement(
          Badge,
          {
            css: {
              backgroundColor: isHighlightedRank ? "none" : "$surfaceBackgroundTertiary",
              color: "$onSurfaceTextPrimary",
              fontWeight: "$regular",
              fontSize: "$subtitleOne",
              "@mobile": { fontSize: "$overline" }
            }
          },
          /* @__PURE__ */ React55.createElement(
            ChallengeUnitIcon,
            {
              score,
              rankingUnit
            }
          )
        )
      )
    );
  }))), displayViewMore && /* @__PURE__ */ React55.createElement(
    LoadMoreCTA,
    {
      isFetchingNextPage,
      fetchNextPage,
      onClick: handleAnalyticsClick
    }
  ));
};

// src/pages/challenge-landing-page/components/leaderboard/components/global-leaderboard-toggle.component.tsx
import React56 from "react";
import { Box as Box22 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl31 } from "@leagueplatform/locales";
import {
  PillTabs,
  PillTabList,
  PillTab
} from "@leagueplatform/web-common-components";
var TogglePodiumContainer = ({
  teamsEnabled,
  isLoadingOrError,
  children
}) => {
  if (teamsEnabled || !isLoadingOrError) {
    return /* @__PURE__ */ React56.createElement(
      Box22,
      {
        backgroundColor: "surface.background.secondary",
        borderColor: "onSurface.border.subdued",
        borderRadius: "small",
        borderWidth: "thin",
        marginBottom: "two",
        padding: { _: "one", tablet: "two" },
        textAlign: "center"
      },
      children
    );
  }
  return /* @__PURE__ */ React56.createElement(Box22, null, children);
};
var GlobalLeaderboardToggle = ({
  teamsEnabled,
  leaderboardViews,
  setLeaderboardView,
  isLoadingOrError,
  children
}) => {
  const { formatMessage } = useIntl31();
  return /* @__PURE__ */ React56.createElement(
    TogglePodiumContainer,
    {
      teamsEnabled,
      isLoadingOrError
    },
    /* @__PURE__ */ React56.createElement(
      PillTabs,
      {
        defaultValue: leaderboardViews[0],
        onValueChange: (value) => {
          setLeaderboardView(leaderboardViews.indexOf(value));
        }
      },
      teamsEnabled && /* @__PURE__ */ React56.createElement(Box22, { width: "fit-content", marginX: "auto", marginBottom: "two" }, /* @__PURE__ */ React56.createElement(PillTabList, null, /* @__PURE__ */ React56.createElement(PillTab, { value: leaderboardViews[0] }, formatMessage({ id: "INDIVIDUAL_CAP" })), /* @__PURE__ */ React56.createElement(PillTab, { value: leaderboardViews[1] }, formatMessage({ id: "TEAMS" })))),
      children
    )
  );
};

// src/pages/challenge-landing-page/components/leaderboard/components/leaderboard-podium.component.tsx
import React58 from "react";
import { HeadingTwo as HeadingTwo3, Flex as Flex16, SubtitleTwo as SubtitleTwo4 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl32 } from "@leagueplatform/locales";

// src/pages/challenge-landing-page/components/leaderboard/components/podium-medalist.component.tsx
import React57 from "react";
import { Box as Box23, Flex as Flex15, Image as Image5, SubtitleOne as SubtitleOne2 } from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset10 } from "@leagueplatform/asset-config";
import { Badge as Badge2 } from "@leagueplatform/web-common-components";

// src/pages/challenge-landing-page/components/leaderboard/utils/get-rank-colors.util.ts
var getRankColors = (rank) => {
  switch (rank) {
    case 1:
      return {
        backgroundColor: "decorative.brand.secondary.darkest",
        backgroundColorCore: "$decorativeBrandSecondaryDarkest"
      };
    case 2:
      return {
        backgroundColor: "decorative.brand.primary.default",
        backgroundColorCore: "$decorativeBrandPrimaryDefault"
      };
    case 3:
      return {
        backgroundColor: "decorative.brand.primary.darkest",
        backgroundColorCore: "$decorativeBrandPrimaryDarkest"
      };
    default:
      return {
        backgroundColor: "primary.background.default",
        backgroundColorCore: "$primaryBackgroundDefault"
      };
  }
};

// src/pages/challenge-landing-page/components/leaderboard/components/podium-medalist.component.tsx
var FIRST_PLACE_SIZE = { _: 90, phone: 120 };
var NON_FIRST_PLACE_SIZE = { _: 75, phone: 95 };
var PodiumMedalist = ({ user, order }) => {
  let teamName = "";
  let firstName = "";
  let lastName = "";
  const { rank, avatarUrl, score, rankingUnit } = user;
  if (isTeamRank(user)) {
    teamName = user.teamName;
  } else {
    firstName = user.firstName;
    lastName = user.lastName;
  }
  const { backgroundColor, backgroundColorCore } = getRankColors(rank);
  const formattedName = (firstName == null ? void 0 : firstName.length) ? formatUserName({ firstName, lastName }) : teamName;
  const isFirst = rank === 1;
  const crown2 = handleStaticAsset10(
    "CHALLENGES_CROWN" /* CHALLENGES_CROWN */
  );
  return /* @__PURE__ */ React57.createElement(
    Flex15,
    {
      as: "li",
      width: "33%",
      marginTop: rank > 1 ? "53px" : "none",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      marginX: { _: "quarter", phone: "half", tablet: "oneAndHalf" },
      order
    },
    isFirst && /* @__PURE__ */ React57.createElement(Image5, { src: crown2, alt: "", marginBottom: "quarter", width: "three" }),
    /* @__PURE__ */ React57.createElement(
      Box23,
      {
        borderRadius: "circle",
        position: "relative",
        size: isFirst ? FIRST_PLACE_SIZE : NON_FIRST_PLACE_SIZE,
        marginBottom: { _: "one", phone: "oneAndHalf" }
      },
      /* @__PURE__ */ React57.createElement(
        ChallengeProfilePicture,
        {
          profilePicture: avatarUrl,
          firstName: (firstName == null ? void 0 : firstName.length) ? firstName : teamName,
          lastName: (lastName == null ? void 0 : lastName.length) ? lastName : "",
          isOnPodium: true,
          backgroundColor: backgroundColorCore
        }
      ),
      /* @__PURE__ */ React57.createElement(
        SubtitleOne2,
        {
          as: "span",
          alignItems: "center",
          backgroundColor,
          borderColor: "onSurface.border.subdued",
          borderWidth: "thick",
          borderRadius: "circle",
          bottom: "minusOne",
          color: "onSurface.text.reversed",
          display: "flex",
          fontSize: { _: "subtitle2", phone: "subtitle1" },
          justifyContent: "center",
          insetInlineStart: "50%",
          position: "absolute",
          size: { _: "oneAndHalf", phone: "two" },
          transform: "translateX(-50%)"
        },
        rank
      )
    ),
    /* @__PURE__ */ React57.createElement(
      Badge2,
      {
        css: {
          backgroundColor: backgroundColorCore,
          color: "$onSurfaceTextReversed",
          fontWeight: "$regular",
          fontSize: "$subtitleOne",
          "@mobile": { fontSize: "$overline" }
        }
      },
      /* @__PURE__ */ React57.createElement(ChallengeUnitIcon, { score, rankingUnit, isOnPodium: true })
    ),
    /* @__PURE__ */ React57.createElement(
      SubtitleOne2,
      {
        as: "p",
        fontSize: { _: "overline", phone: "subtitle1" },
        marginTop: { _: "half", phone: "threeQuarters" }
      },
      formattedName
    )
  );
};

// src/pages/challenge-landing-page/components/leaderboard/components/leaderboard-podium.component.tsx
var LeaderboardPodium = ({
  leaderboardData,
  headerText
}) => {
  const { formatMessage } = useIntl32();
  return /* @__PURE__ */ React58.createElement(React58.Fragment, null, /* @__PURE__ */ React58.createElement(HeadingTwo3, { as: "h2" }, formatMessage({ id: "TOP_RANKED" })), headerText && /* @__PURE__ */ React58.createElement(SubtitleTwo4, { as: "span" }, headerText), /* @__PURE__ */ React58.createElement(
    Flex16,
    {
      as: "ol",
      justifyContent: "center",
      alignItems: "flex-start",
      marginTop: "oneAndHalf"
    },
    leaderboardData[0] && /* @__PURE__ */ React58.createElement(PodiumMedalist, { user: leaderboardData[0], order: 2 }),
    leaderboardData[1] && /* @__PURE__ */ React58.createElement(PodiumMedalist, { user: leaderboardData[1], order: 1 }),
    leaderboardData[2] && /* @__PURE__ */ React58.createElement(PodiumMedalist, { user: leaderboardData[2], order: 3 })
  ));
};

// src/hooks/use-get-user-challenge-ranks.hook.ts
import { useInfiniteQuery as useInfiniteQuery2 } from "react-query";
import { useParamsLegacy as useParams16 } from "@leagueplatform/routing";
import {
  getUserChallengeRanks
} from "@leagueplatform/health-journey-api";
var USER_CHALLENGE_RANKS_QUERY_KEY = "getUserChallengeRanksData";
var useGetUserChallengeRanks = () => {
  const { challengeId } = useParams16();
  return useInfiniteQuery2(
    [USER_CHALLENGE_RANKS_QUERY_KEY, challengeId],
    ({ pageParam }) => getUserChallengeRanks(challengeId, pageParam),
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage.links.next || !lastPage.data.length) {
          return void 0;
        }
        const { next } = lastPage.links;
        return next.slice(next.indexOf("/v2/"));
      }
    }
  );
};

// src/pages/challenge-landing-page/hooks/use-get-team-challenge-ranks.hook.ts
import { useInfiniteQuery as useInfiniteQuery3 } from "react-query";
import { useParamsLegacy as useParams17 } from "@leagueplatform/routing";
import {
  getTeamChallengeRanks
} from "@leagueplatform/health-journey-api";
var TEAM_CHALLENGE_RANKS_QUERY_KEY = "getTeamChallengeRanks";
var useGetTeamChallengeRanks = (teamsEnabled) => {
  const { challengeId } = useParams17();
  return useInfiniteQuery3(
    [TEAM_CHALLENGE_RANKS_QUERY_KEY, challengeId],
    ({ pageParam }) => getTeamChallengeRanks(challengeId, pageParam),
    {
      enabled: teamsEnabled,
      getNextPageParam: (lastPage) => {
        if (!lastPage.links.next || !lastPage.data.length) {
          return void 0;
        }
        const { next } = lastPage.links;
        return next.slice(next.indexOf("/v2/"));
      }
    }
  );
};

// src/pages/challenge-landing-page/components/leaderboard/hooks/use-get-leaderboard-data.hook.ts
var useGetLeaderboardData = (leaderboardView, teamsEnabled) => {
  const individualLeaderboardData = useGetUserChallengeRanks();
  const teamLeaderboardData = useGetTeamChallengeRanks(teamsEnabled);
  if (leaderboardView === 0) {
    return individualLeaderboardData;
  }
  return teamLeaderboardData;
};

// src/pages/challenge-landing-page/components/leaderboard/leaderboard.component.tsx
var LeaderboardViews = ["individual", "team"];
var Leaderboard = ({
  teamsEnabled
}) => {
  var _a;
  const { formatMessage } = useIntl33();
  const [leaderboardView, setLeaderboardView] = useState7(0);
  const {
    isLoading,
    error,
    data: leaderboardData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useGetLeaderboardData(leaderboardView, teamsEnabled);
  const { isLoading: isUserLoading } = useGetUserProfile();
  const pages = leaderboardData == null ? void 0 : leaderboardData.pages;
  let flattenedLeaderboardData = [];
  if (pages) {
    flattenedLeaderboardData = pages.reduce((acc, page) => [...acc, ...page.data], []);
  }
  if (isLoading || isUserLoading)
    return /* @__PURE__ */ React59.createElement(
      GlobalLeaderboardToggle,
      {
        teamsEnabled,
        leaderboardViews: LeaderboardViews,
        setLeaderboardView,
        isLoadingOrError: isLoading || !!error
      },
      /* @__PURE__ */ React59.createElement(
        Flex17,
        {
          height: LEADERBOARD_SPINNER_FIXED_HEIGHT,
          justifyContent: "center",
          color: "decorative.brand.primary.default"
        },
        /* @__PURE__ */ React59.createElement(Spinner3, { isLoading: true })
      )
    );
  if (error || !flattenedLeaderboardData || (flattenedLeaderboardData == null ? void 0 : flattenedLeaderboardData.length) === 0)
    return /* @__PURE__ */ React59.createElement(
      GlobalLeaderboardToggle,
      {
        teamsEnabled,
        leaderboardViews: LeaderboardViews,
        setLeaderboardView,
        isLoadingOrError: isLoading || !!error
      },
      /* @__PURE__ */ React59.createElement(Flex17, { justifyContent: "center", marginY: "five" }, /* @__PURE__ */ React59.createElement(ErrorState3, { error }))
    );
  const { tooltipText, headerText } = (_a = leaderboardData == null ? void 0 : leaderboardData.pages[0].meta) != null ? _a : {};
  return /* @__PURE__ */ React59.createElement(React59.Fragment, null, /* @__PURE__ */ React59.createElement(
    GlobalLeaderboardToggle,
    {
      teamsEnabled,
      leaderboardViews: LeaderboardViews,
      setLeaderboardView,
      isLoadingOrError: isLoading || !!error
    },
    /* @__PURE__ */ React59.createElement(
      LeaderboardPodium,
      {
        leaderboardData: flattenedLeaderboardData,
        headerText: headerText != null ? headerText : ""
      }
    )
  ), /* @__PURE__ */ React59.createElement(
    StackLayout13,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      verticalAlignment: "center",
      css: { padding: "$half" }
    },
    /* @__PURE__ */ React59.createElement(HeadingFour4, { as: "h2" }, formatMessage({ id: "LEADERBOARD_ALL_TIME_RANKING" })),
    /* @__PURE__ */ React59.createElement(Popover.Root, null, /* @__PURE__ */ React59.createElement(
      Popover.Trigger,
      {
        label: formatMessage({ id: "TOOLTIP_ACTION_DESCRIPTION" }),
        priority: "tertiary",
        size: "small",
        quiet: true,
        hideLabel: true,
        icon: "interfaceQuestionCircle",
        css: {
          "&:hover": {
            backgroundColor: "$onSurfaceBackgroundPrimary",
            color: "$onSurfaceIconPrimary"
          }
        }
      }
    ), /* @__PURE__ */ React59.createElement(Popover.Content, { align: "end", side: "top", css: { width: "250px" } }, /* @__PURE__ */ React59.createElement(ParagraphText2, { size: "sm" }, tooltipText)))
  ), /* @__PURE__ */ React59.createElement(
    LeaderboardTable,
    {
      leaderboardData: flattenedLeaderboardData,
      displayViewMore: hasNextPage,
      isFetchingNextPage,
      fetchNextPage,
      leaderboardView
    }
  ));
};

// src/pages/challenge-landing-page/components/clp-skeleton-loader/clp-skeleton-loader.component.tsx
import React60 from "react";
import { Flex as Flex18 } from "@leagueplatform/genesis-commons";
import {
  BackButtonArrow as BackButtonArrow5,
  SkeletonBox as SkeletonBox3
} from "@leagueplatform/web-common-components";
import { LinkLegacy as Link9 } from "@leagueplatform/routing";
import { JOURNEY_ROUTES as JOURNEY_ROUTES7 } from "@leagueplatform/health-journey-common";

// src/pages/challenge-landing-page/constants/challenge-landing-page.constants.ts
var CONFIRMATION_MODAL_MIN_HEIGHT = "calc(60vh - 96px)";
var CLP_CONTAINER_MAX_WIDTH = "778px";

// src/pages/challenge-landing-page/components/clp-skeleton-loader/clp-skeleton-loader.component.tsx
var CLPSkeletonLoader = () => /* @__PURE__ */ React60.createElement(
  Flex18,
  {
    as: "section",
    flexDirection: { _: "column", laptop: "row" },
    alignItems: { _: "center", laptop: "initial" },
    padding: { _: "oneAndHalf", phone: "twoAndHalf" },
    justifyContent: "center"
  },
  /* @__PURE__ */ React60.createElement(
    Flex18,
    {
      flexDirection: { _: "column", laptop: "row" },
      paddingInlineEnd: { laptop: "four" },
      marginBottom: "twoAndHalf",
      width: "100%",
      maxWidth: CLP_CONTAINER_MAX_WIDTH
    },
    /* @__PURE__ */ React60.createElement(
      BackButtonArrow5,
      {
        as: Link9,
        justifyContent: "initial",
        marginInlineEnd: "quarter",
        marginY: "half",
        onClick: noopFunction,
        to: JOURNEY_ROUTES7.programsHome,
        size: "three"
      }
    ),
    /* @__PURE__ */ React60.createElement(Flex18, { flexDirection: "column", width: "100%" }, /* @__PURE__ */ React60.createElement(
      SkeletonBox3,
      {
        width: "100%",
        maxWidth: CLP_CONTAINER_MAX_WIDTH,
        height: "444px",
        backgroundColor: "interactive.background.disabled",
        role: "presentation"
      }
    ), /* @__PURE__ */ React60.createElement(
      SkeletonBox3,
      {
        backgroundColor: "interactive.background.disabled",
        marginTop: "three",
        role: "presentation"
      }
    ), /* @__PURE__ */ React60.createElement(
      SkeletonBox3,
      {
        backgroundColor: "interactive.background.disabled",
        height: "222px",
        role: "presentation"
      }
    ))
  ),
  /* @__PURE__ */ React60.createElement(Flex18, { flexDirection: "column", width: { _: "100%", laptop: "30%" } }, /* @__PURE__ */ React60.createElement(
    SkeletonBox3,
    {
      width: "100%",
      maxWidth: { CLP_CONTAINER_MAX_WIDTH },
      height: "444px",
      backgroundColor: "interactive.background.disabled",
      alignSelf: "center",
      marginBottom: "oneAndHalf",
      role: "presentation"
    }
  ), /* @__PURE__ */ React60.createElement(
    SkeletonBox3,
    {
      width: "100%",
      maxWidth: { CLP_CONTAINER_MAX_WIDTH },
      alignSelf: "center",
      height: "444px",
      backgroundColor: "interactive.background.disabled",
      role: "presentation"
    }
  ))
);

// src/pages/challenge-landing-page/components/sidebar/sidebar.component.tsx
import React63 from "react";
import { useParamsLegacy as useParams19 } from "@leagueplatform/routing";
import { useIntl as useIntl36 } from "@leagueplatform/locales";
import { StackLayout as StackLayout15 } from "@leagueplatform/genesis-core";
import {
  JOURNEY_ROUTES as JOURNEY_ROUTES9,
  ProgramDetailCard as ProgramDetailCard2
} from "@leagueplatform/health-journey-common";

// src/pages/challenge-landing-page/components/sidebar/components/join-team/join-team.component.tsx
import React61 from "react";
import {
  LinkLegacy as Link10,
  useParamsLegacy as useParams18
} from "@leagueplatform/routing";
import {
  BodyOne as BodyOne6,
  HeadingFour as HeadingFour5,
  Box as Box24,
  PrimaryButton as PrimaryButton4
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl34 } from "@leagueplatform/locales";
import { JOURNEY_ROUTES as JOURNEY_ROUTES8 } from "@leagueplatform/health-journey-common";
import { EVENT_NAME as EVENT_NAME16, SCREEN_NAMES as SCREEN_NAMES7 } from "@leagueplatform/analytics";
var JoinTeam2 = () => {
  const { formatMessage } = useIntl34();
  const { challengeId } = useParams18();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME16.BUTTON_CLICKED, {
    screen_name: SCREEN_NAMES7.HEALTH_CAMPAIGN_DETAIL,
    detail
  });
  return /* @__PURE__ */ React61.createElement(
    Box24,
    {
      backgroundColor: "decorative.brand.primary.pastel",
      borderColor: "onSurface.border.subdued",
      borderRadius: "medium",
      borderWidth: "thin",
      boxShadow: "card",
      padding: "oneAndHalf"
    },
    /* @__PURE__ */ React61.createElement(HeadingFour5, { as: "h2" }, formatMessage({ id: "UP_YOUR_GAME" })),
    /* @__PURE__ */ React61.createElement(BodyOne6, { marginTop: "half", marginBottom: "oneAndHalf" }, formatMessage({ id: "UP_YOUR_GAME_DESCRIPTION" })),
    /* @__PURE__ */ React61.createElement(
      PrimaryButton4,
      {
        as: Link10,
        width: "100%",
        textDecoration: "none",
        to: JOURNEY_ROUTES8.getChallengeJoinTeam(challengeId),
        onClick: () => handleAnalyticsClick("join or create a team" /* JOIN_CREATE_TEAM */)
      },
      formatMessage({ id: "JOIN_OR_CREATE_TEAM" })
    )
  );
};

// src/pages/challenge-landing-page/components/sign-up-button/sign-up-button.component.tsx
import { EVENT_NAME as EVENT_NAME17, SCREEN_NAMES as SCREEN_NAMES8 } from "@leagueplatform/analytics";
import { Button as Button3, Responsive as Responsive3, StackLayout as StackLayout14 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl35 } from "@leagueplatform/locales";
import React62 from "react";
var SignUpButton = ({ setDisplaySignUpModal }) => {
  const { formatMessage } = useIntl35();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME17.BUTTON_CLICKED, {
    screen_name: SCREEN_NAMES8.HEALTH_CAMPAIGN_DETAIL,
    detail,
    is_critical_event: true
  });
  return /* @__PURE__ */ React62.createElement(
    Button3,
    {
      onClick: () => {
        setDisplaySignUpModal(true);
        handleAnalyticsClick("sign up" /* SIGN_UP */);
      },
      width: "fillContainer",
      css: {
        maxWidth: BUTTON_CONTAINER_MAX_WIDTH
      }
    },
    formatMessage({ id: "SIGN_UP_FOR_CHALLENGE" })
  );
};
var MobileResponsiveSignUpButton = ({
  setDisplaySignUpModal
}) => /* @__PURE__ */ React62.createElement(Responsive3, { down: "laptop" }, /* @__PURE__ */ React62.createElement(
  StackLayout14,
  {
    css: {
      position: "fixed",
      bottom: 0,
      insetInlineStart: 0,
      width: "100%",
      backgroundColor: "$surfaceBackgroundPrimary",
      height: "$five",
      padding: "$one",
      zIndex: "1"
    },
    horizontalAlignment: "center",
    verticalAlignment: "center"
  },
  /* @__PURE__ */ React62.createElement(SignUpButton, { setDisplaySignUpModal })
));

// src/pages/challenge-landing-page/components/sidebar/sidebar.component.tsx
var Sidebar = ({
  userIsEnrolled,
  teamsEnabled,
  userIsOnTeam,
  userCanJoinTeam,
  teamId,
  teamName,
  setDisplaySignUpModal,
  displaySignUpButton
}) => {
  const { formatMessage } = useIntl36();
  const { challengeId } = useParams19();
  return /* @__PURE__ */ React63.createElement(StackLayout15, { spacing: "$oneAndHalf", horizontalAlignment: "stretch" }, userIsEnrolled && /* @__PURE__ */ React63.createElement(ProgressTracker, null), /* @__PURE__ */ React63.createElement(
    ProgramDetailCard2,
    {
      heading: formatMessage({ id: "CHALLENGE_DETAILS" }),
      footer: /* @__PURE__ */ React63.createElement(ChallengeDetailsCardBanner, null)
    },
    /* @__PURE__ */ React63.createElement(ChallengeDetailsContents, null)
  ), displaySignUpButton && /* @__PURE__ */ React63.createElement(SignUpButton, { setDisplaySignUpModal }), teamsEnabled && userIsOnTeam && teamId && teamName && /* @__PURE__ */ React63.createElement(
    ChallengeLink,
    {
      to: JOURNEY_ROUTES9.getChallengeTeamDetails(challengeId, teamId),
      title: formatMessage({ id: "YOUR_TEAM" }),
      description: teamName
    }
  ), userCanJoinTeam && /* @__PURE__ */ React63.createElement(JoinTeam2, null));
};

// src/pages/challenge-landing-page/components/challenge-legal-disclaimer/challenge-legal-disclaimer.component.tsx
import React64 from "react";
import { useIntl as useIntl37 } from "@leagueplatform/locales";
import {
  ParagraphText as ParagraphText3,
  StatusBanner,
  HeadingText as HeadingText6
} from "@leagueplatform/genesis-core";
var LegalDisclaimer = () => {
  const { formatMessage } = useIntl37();
  const disclaimerText = formatMessage({
    id: "CHALLENGES_LEGAL_DISCLAIMER"
  });
  if (disclaimerText === " ") {
    return null;
  }
  return /* @__PURE__ */ React64.createElement(
    StatusBanner,
    {
      title: /* @__PURE__ */ React64.createElement(HeadingText6, { level: "2", size: "sm" }, formatMessage({ id: "DISCLAIMER" })),
      status: "neutral"
    },
    /* @__PURE__ */ React64.createElement(ParagraphText3, null, disclaimerText)
  );
};

// src/pages/challenge-landing-page/components/challenge-activities/challenge-activities.component.tsx
import * as React71 from "react";
import { StackLayout as StackLayout20 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl44 } from "@leagueplatform/locales";
import { useParamsLegacy as useParams20 } from "@leagueplatform/routing";
import { JOURNEY_ROUTES as JOURNEY_ROUTES11 } from "@leagueplatform/health-journey-common";
import { ErrorState as ErrorState4, SkeletonBox as SkeletonBox4 } from "@leagueplatform/web-common-components";

// src/hooks/use-activities-by-activity-status-and-campaign.hook.ts
import { useQuery as useQuery7 } from "react-query";
import {
  getUserHealthActivities,
  GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE
} from "@leagueplatform/health-journey-api";
import camelcaseKeys from "camelcase-keys";
var WS_ENDPOINT_VERSION_NUMBER = 3;
function useActivitiesByActivityStatusAndCampaign({
  activityStatuses,
  campaignId
}) {
  return useQuery7(
    [GET_USER_HEALTH_ACTIVITIES_MESSAGE_TYPE, activityStatuses, campaignId],
    () => getUserHealthActivities({
      activityStatuses,
      campaignId,
      version: WS_ENDPOINT_VERSION_NUMBER
    }),
    {
      enabled: !!activityStatuses.length && !!campaignId,
      select: (data) => camelcaseKeys(data, { deep: true })
    }
  );
}

// src/pages/challenge-landing-page/components/challenge-activities/components/challenge-activity-section-header.tsx
import * as React65 from "react";
import {
  HeadingText as HeadingText7,
  StackLayout as StackLayout16,
  TextAction as TextAction2
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl38 } from "@leagueplatform/locales";
function ChallengeActivitySectionHeader({
  heading,
  href
}) {
  const { formatMessage } = useIntl38();
  return /* @__PURE__ */ React65.createElement(
    StackLayout16,
    {
      horizontalAlignment: "spaceBetween",
      orientation: "horizontal",
      verticalAlignment: "center",
      css: { width: "100%" }
    },
    /* @__PURE__ */ React65.createElement(HeadingText7, { level: "2", size: "lg" }, heading),
    href ? /* @__PURE__ */ React65.createElement(TextAction2, { size: "medium", href }, formatMessage({ id: "VIEW_ALL" })) : null
  );
}

// src/pages/challenge-landing-page/components/challenge-activities/components/challenge-activity-list.tsx
import * as React68 from "react";
import { UtilityText as UtilityText13 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl42 } from "@leagueplatform/locales";
import { DATE_FORMAT } from "@leagueplatform/web-common";

// src/pages/challenge-landing-page/components/challenge-activities/utils/activity-date.ts
import compareAsc from "date-fns/compareAsc";
import compareDesc from "date-fns/compareDesc";
import parseISO2 from "date-fns/parseISO";
var activityDateSelectorByStatusMap = {
  active: (activity) => activity.startDate,
  upcoming: (activity) => activity.startDate,
  removed: (activity) => activity.dateRemoved,
  expired: (activity) => activity.endDate,
  completed: (activity) => activity.completedDate
};
function getActivityDate(activity) {
  const dateSelector = activityDateSelectorByStatusMap[activity.status];
  return dateSelector(activity);
}
function sortActivitiesInReverseChronologicalOrder(activities) {
  const sortedActivities = activities.sort(
    (activityA, activityB) => compareDesc(
      parseISO2(getActivityDate(activityA)),
      parseISO2(getActivityDate(activityB))
    )
  );
  return sortedActivities;
}

// src/pages/challenge-landing-page/components/challenge-activities/components/challenge-activity-card.tsx
import * as React67 from "react";
import { useIntl as useIntl41 } from "@leagueplatform/locales";
import {
  ComposableActivityCard,
  JOURNEY_ROUTES as JOURNEY_ROUTES10
} from "@leagueplatform/health-journey-common";

// src/pages/challenge-landing-page/components/challenge-activities/utils/activity-status-predicates.ts
var isActiveActivity = (activity) => activity.status === "active";
var isUpcomingActivity = (activity) => activity.status === "upcoming";
var isCompletedActivity = (activity) => activity.status === "completed";
var isMissedActivity = (activity) => activity.status === "expired" || activity.status === "removed";

// src/pages/challenge-landing-page/components/challenge-activities/components/verifiable-activity-progress.tsx
import * as React66 from "react";
import { useIntl as useIntl40 } from "@leagueplatform/locales";
import {
  ParagraphText as ParagraphText4,
  StackItem,
  StackLayout as StackLayout17,
  UtilityText as UtilityText12
} from "@leagueplatform/genesis-core";

// src/types/activity-details-props.types.ts
var metricUnits = [
  "count",
  "s",
  "m",
  "min",
  "cal",
  "kcal",
  "bmp",
  "km",
  "mg/dl"
];

// src/pages/challenge-landing-page/components/challenge-activities/components/verifiable-activity-progress.tsx
import { ProgressBar as ProgressBar2 } from "@leagueplatform/web-common-components";

// src/hooks/use-metric-unit-translation.ts
import { useIntl as useIntl39 } from "@leagueplatform/locales";
var useMetricUnitTranslator = () => useIntl39().$tmap({
  count: "COUNT",
  s: "S",
  m: "M",
  min: "MIN",
  cal: "CAL",
  kcal: "KCAL",
  bmp: "BMP",
  km: "KM",
  "mg/dl": "MG/DL"
});

// src/pages/challenge-landing-page/components/challenge-activities/components/verifiable-activity-progress.tsx
var digits = {
  distance: 1,
  steps: 0,
  active_duration: 0,
  mindful_duration: 0,
  floors_climbed: 0,
  energy_burned: 0
};
var styledText = (msg) => /* @__PURE__ */ React66.createElement(
  UtilityText12,
  {
    emphasis: "emphasized",
    css: {
      color: "$onSurfaceTextSuccess"
    }
  },
  msg
);
function useLocaleUnitFormatter() {
  const { $tmap } = useIntl40();
  const getMetricUnitTranlsation = useMetricUnitTranslator();
  const getUnit = $tmap({
    steps: "INSIGHT_CARD_UNIT_STEPS",
    floors_climbed: "INSIGHT_CARD_UNIT_FLOORS_CLIMBED"
  });
  const formatUnit = (type, unit, value = 0) => {
    if (type === "steps" || type === "floors_climbed") {
      return getUnit(type, { count: value });
    }
    if (metricUnits.includes(unit)) {
      return getMetricUnitTranlsation(unit, { count: value });
    }
    return `${value} ${unit}`;
  };
  return { formatUnit };
}
function useLocaleMetricValueFormatter() {
  const { formatNumber } = useIntl40();
  function formatMetricValue(value, type) {
    const maximumFractionDigits = digits[type];
    if (value === null) {
      return null;
    }
    return formatNumber(value, { maximumFractionDigits });
  }
  return { formatMetricValue };
}
function VerifiableActivityProgress({
  progress,
  goal,
  unit,
  type
}) {
  const { formatMessage } = useIntl40();
  const { formatMetricValue } = useLocaleMetricValueFormatter();
  const { formatUnit } = useLocaleUnitFormatter();
  if (!isActiveActivity) {
    return null;
  }
  return /* @__PURE__ */ React66.createElement(StackLayout17, { spacing: "$none" }, /* @__PURE__ */ React66.createElement(ParagraphText4, { as: "span", emphasis: "subtle" }, formatMessage(
    { id: "X_OF_Y_COMPLETED_WITH_UNIT" },
    {
      progress: formatMetricValue(progress, type),
      goal: formatMetricValue(goal, type),
      unit: formatUnit(type, unit, progress),
      span: styledText
    }
  )), /* @__PURE__ */ React66.createElement(
    StackLayout17,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      verticalAlignment: "center",
      css: {
        width: "100%"
      }
    },
    /* @__PURE__ */ React66.createElement(StackItem, { growFactor: 1 }, /* @__PURE__ */ React66.createElement(
      ProgressBar2,
      {
        current: progress,
        total: goal,
        customBarBackgroundColor: "interactive.border.disabled",
        customBarFillColor: "success.border.default"
      }
    ))
  ));
}

// src/pages/challenge-landing-page/components/challenge-activities/components/challenge-activity-card.tsx
function cleanUpFix(data) {
  if (data.currentProgress !== void 0 && data.currentProgress !== null && // @ts-ignore
  data.currentProgress !== "" && data.goalTotal !== void 0 && data.goalTotal !== null && // @ts-ignore
  data.goalTotal !== "" && data.dataType !== void 0 && data.dataType !== null && // @ts-ignore
  data.dataType !== "" && data.unit !== void 0 && data.unit !== null && // @ts-ignore
  data.unit !== "") {
    return true;
  }
  return false;
}
function ChallengeActivityCard({
  activity,
  level
}) {
  const { formatMessage } = useIntl41();
  const { activityProgressData } = activity;
  return /* @__PURE__ */ React67.createElement(
    ComposableActivityCard,
    {
      cta: JOURNEY_ROUTES10.getToolboxActivityDetails(activity.id),
      icon: isCompletedActivity(activity) ? {
        icon: "statusSuccessStatusFilled",
        tint: "$successIcon",
        label: formatMessage({ id: "COMPLETED" })
      } : void 0,
      title: {
        text: activity.name,
        level,
        textEmphasis: isMissedActivity(activity) ? "subtle" : "base"
      },
      body: activityProgressData && activityProgressData.filter(cleanUpFix).map((data) => /* @__PURE__ */ React67.createElement(
        VerifiableActivityProgress,
        {
          progress: data.currentProgress,
          goal: data.goalTotal,
          type: data.dataType,
          unit: data.unit
        }
      ))
    }
  );
}

// src/pages/challenge-landing-page/components/challenge-activities/components/challenge-activity-list.tsx
function ChallengeActivityList({
  activities,
  level
}) {
  const { formatDate } = useIntl42();
  const { data: userData } = useGetUserProfile();
  const { default_timezone: defaultTimezone } = userData || {};
  return /* @__PURE__ */ React68.createElement(React68.Fragment, null, activities.map((activity) => /* @__PURE__ */ React68.createElement(React68.Fragment, { key: activity.id }, /* @__PURE__ */ React68.createElement(UtilityText13, { size: "eyebrow" }, formatDate(getActivityDate(activity), __spreadProps(__spreadValues({}, DATE_FORMAT), {
    timeZone: defaultTimezone
  }))), /* @__PURE__ */ React68.createElement(ChallengeActivityCard, { activity, level }))));
}

// src/pages/challenge-landing-page/components/challenge-activities/components/challenge-activity-section.tsx
import * as React69 from "react";
import { StackItem as StackItem2, StackLayout as StackLayout18 } from "@leagueplatform/genesis-core";
function ChallengeActivitySection({
  children
}) {
  return /* @__PURE__ */ React69.createElement(StackItem2, { css: { width: "100%" } }, /* @__PURE__ */ React69.createElement(StackLayout18, { spacing: "$one", css: { width: "100%" } }, children));
}

// src/pages/challenge-landing-page/components/challenge-activities/components/challenge-activities-empty-state-card.tsx
import * as React70 from "react";
import { Card, StackLayout as StackLayout19, UtilityText as UtilityText14 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl43 } from "@leagueplatform/locales";
function ChallengeActivitiesEmptyStateCard({
  title,
  message
}) {
  return /* @__PURE__ */ React70.createElement(Card.Flat, { css: { width: "100%" } }, /* @__PURE__ */ React70.createElement(Card.Section, { padding: "$two" }, /* @__PURE__ */ React70.createElement(
    StackLayout19,
    {
      horizontalAlignment: "center",
      verticalAlignment: "center",
      spacing: "$none"
    },
    /* @__PURE__ */ React70.createElement(UtilityText14, { emphasis: "subtle", css: { fontWeight: 800 } }, title),
    /* @__PURE__ */ React70.createElement(UtilityText14, { emphasis: "subtle", size: "sm" }, message)
  )));
}
function ChallengePendingStateCard({
  message
}) {
  const { formatMessage } = useIntl43();
  return /* @__PURE__ */ React70.createElement(
    ChallengeActivitiesEmptyStateCard,
    {
      title: formatMessage({ id: "CHALLENGE_ACTIVITY_EMPTY_STATE_HEADER" }),
      message
    }
  );
}
function ChallengeCompletedCard() {
  const { formatMessage } = useIntl43();
  return /* @__PURE__ */ React70.createElement(
    ChallengeActivitiesEmptyStateCard,
    {
      title: formatMessage({ id: "CHALLENGE_COMPLETED_TITLE" }),
      message: formatMessage({ id: "CHALLENGE_COMPLETED_BODY" })
    }
  );
}
function ChallengeUpNextActivitiesPendingStateCard() {
  const { formatMessage } = useIntl43();
  return /* @__PURE__ */ React70.createElement(
    ChallengePendingStateCard,
    {
      message: formatMessage({
        id: "CHALLENGE_ACTIVITY_UP_NEXT_EMPTY_STATE"
      })
    }
  );
}
function ChallengeCompletedActivitiesPendingStateCard() {
  const { formatMessage } = useIntl43();
  return /* @__PURE__ */ React70.createElement(
    ChallengePendingStateCard,
    {
      message: formatMessage({
        id: "CHALLENGE_ACTIVITY_COMPLETED_EMPTY_STATE"
      })
    }
  );
}
function ChallengeMissedActivitiesPendingStateCard() {
  const { formatMessage } = useIntl43();
  return /* @__PURE__ */ React70.createElement(
    ChallengePendingStateCard,
    {
      message: formatMessage({
        id: "CHALLENGE_ACTIVITY_MISSED_EMPTY_STATE"
      })
    }
  );
}

// src/pages/challenge-landing-page/components/challenge-activities/challenge-activities.component.tsx
var NUM_VISIBLE_ACTIVITIES = 3;
function UpNextSectionContent({
  isChallengePending,
  isChallengeCompleted,
  firstUpNextActivity
}) {
  if (isChallengePending) {
    return /* @__PURE__ */ React71.createElement(ChallengeUpNextActivitiesPendingStateCard, null);
  }
  if (isChallengeCompleted) {
    return /* @__PURE__ */ React71.createElement(ChallengeCompletedCard, null);
  }
  if (firstUpNextActivity) {
    return /* @__PURE__ */ React71.createElement(ChallengeActivityCard, { activity: firstUpNextActivity, level: "3" });
  }
  return null;
}
function UpNextActivities({
  challengeStatus,
  activities
}) {
  const activeActivities = activities.filter(isActiveActivity);
  const upcomingActivities = activities.filter(isUpcomingActivity);
  const upNextActivities = activeActivities.length > 0 ? activeActivities : upcomingActivities;
  const hasUserExhaustedActivities = upNextActivities.length === 0;
  const isChallengePending = challengeStatus === "upcoming" /* UPCOMING */;
  const isChallengeActive = challengeStatus === "active" /* ACTIVE */;
  const isChallengeClosed = challengeStatus === "closed" /* CLOSED */;
  const isChallengeCompleted = hasUserExhaustedActivities && isChallengeActive || isChallengeClosed;
  const firstUpNextActivity = upNextActivities[0];
  const { formatMessage } = useIntl44();
  return /* @__PURE__ */ React71.createElement(ChallengeActivitySection, null, /* @__PURE__ */ React71.createElement(
    ChallengeActivitySectionHeader,
    {
      heading: formatMessage({ id: "CHALLENGE_ACTIVITY_UP_NEXT" })
    }
  ), /* @__PURE__ */ React71.createElement(
    UpNextSectionContent,
    {
      isChallengeCompleted,
      isChallengePending,
      firstUpNextActivity
    }
  ));
}
function CompletedActivities({
  activities,
  challengeId
}) {
  const { formatMessage } = useIntl44();
  const hasActivities = activities.length > 0;
  return /* @__PURE__ */ React71.createElement(ChallengeActivitySection, null, /* @__PURE__ */ React71.createElement(
    ChallengeActivitySectionHeader,
    {
      heading: formatMessage({ id: "CHALLENGE_ACTIVITY_COMPLETED" }),
      href: hasActivities ? JOURNEY_ROUTES11.getChallengeCompletedActivities(challengeId) : void 0
    }
  ), hasActivities ? /* @__PURE__ */ React71.createElement(
    ChallengeActivityList,
    {
      activities: sortActivitiesInReverseChronologicalOrder(
        activities
      ).slice(0, NUM_VISIBLE_ACTIVITIES),
      level: "3"
    }
  ) : /* @__PURE__ */ React71.createElement(ChallengeCompletedActivitiesPendingStateCard, null));
}
function MissedActivities({ activities, challengeId }) {
  const { formatMessage } = useIntl44();
  const hasActivities = activities.length > 0;
  return /* @__PURE__ */ React71.createElement(ChallengeActivitySection, null, /* @__PURE__ */ React71.createElement(
    ChallengeActivitySectionHeader,
    {
      heading: formatMessage({ id: "CHALLENGE_ACTIVITY_MISSED" }),
      href: hasActivities ? JOURNEY_ROUTES11.getChallengeMissedActivities(challengeId) : void 0
    }
  ), hasActivities ? /* @__PURE__ */ React71.createElement(
    ChallengeActivityList,
    {
      activities: sortActivitiesInReverseChronologicalOrder(
        activities
      ).slice(0, NUM_VISIBLE_ACTIVITIES),
      level: "4"
    }
  ) : /* @__PURE__ */ React71.createElement(
    ChallengePendingStateCard,
    {
      message: formatMessage({
        id: "CHALLENGE_ACTIVITY_MISSED_EMPTY_STATE"
      })
    }
  ));
}
function ChallengeActivities({
  challengeStatus,
  userChallengeId
}) {
  var _a;
  const { challengeId } = useParams20();
  const {
    data: activities,
    isLoading,
    isError,
    error
  } = useActivitiesByActivityStatusAndCampaign({
    activityStatuses: ["active", "upcoming", "completed", "expired", "removed"],
    campaignId: userChallengeId
  });
  if (isLoading) {
    return /* @__PURE__ */ React71.createElement(
      SkeletonBox4,
      {
        backgroundColor: "interactive.background.disabled",
        height: "200px",
        marginBottom: "one"
      }
    );
  }
  if (isError) {
    return /* @__PURE__ */ React71.createElement(ErrorState4, { error });
  }
  const allActivities = (_a = activities == null ? void 0 : activities.userHealthActivities) != null ? _a : [];
  const completedActivities = allActivities.filter(isCompletedActivity);
  const missedActivities = allActivities.filter(isMissedActivity);
  return /* @__PURE__ */ React71.createElement(StackLayout20, { spacing: "$twoAndHalf", css: { width: "100%" } }, /* @__PURE__ */ React71.createElement(
    UpNextActivities,
    {
      challengeStatus,
      activities: allActivities
    }
  ), /* @__PURE__ */ React71.createElement(
    CompletedActivities,
    {
      activities: completedActivities,
      challengeId
    }
  ), /* @__PURE__ */ React71.createElement(
    MissedActivities,
    {
      activities: missedActivities,
      challengeId
    }
  ));
}

// src/pages/challenge-landing-page/components/sign-up-modal/sign-up-modal.component.tsx
import React80, { useState as useState10 } from "react";
import { useIntl as useIntl51 } from "@leagueplatform/locales";
import { VisuallyHidden as VisuallyHidden8 } from "@leagueplatform/genesis-commons";
import { Button as Button6, Modal as Modal4, Box as Box31, HeadingText as HeadingText10 } from "@leagueplatform/genesis-core";

// src/pages/challenge-landing-page/components/sign-up-modal/components/sign-up-modal-content/sign-up-modal-content.component.tsx
import React79, { useState as useState9, useEffect as useEffect10 } from "react";
import { USER_CONNECTED_DEVICE_CAMPAIGN_MODES as USER_CONNECTED_DEVICE_CAMPAIGN_MODES2 } from "@leagueplatform/health-journey-api";

// src/pages/challenge-landing-page/components/sign-up-modal/components/accept-privacy-policy/accept-privacy-policy.component.tsx
import React72, { useEffect as useEffect9 } from "react";
import { EVENT_NAME as EVENT_NAME18 } from "@leagueplatform/analytics";
import {
  Checkbox,
  BodyOne as BodyOne7,
  Link as Link11,
  HeadingOne as HeadingOne3,
  PrimaryButton as PrimaryButton5,
  genesisStyled as genesisStyled7,
  Label as Label4,
  ErrorMessage as ErrorMessage3,
  Box as Box25
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl45 } from "@leagueplatform/locales";
import { Formik as Formik3, Field as Field3, Form as Form3 } from "formik";
import { handleStaticAsset as handleStaticAsset11 } from "@leagueplatform/asset-config";

// src/pages/challenge-landing-page/components/sign-up-modal/constants/sign-up-modal.constants.ts
var SIGN_UP_MODAL_PAGES = /* @__PURE__ */ ((SIGN_UP_MODAL_PAGES2) => {
  SIGN_UP_MODAL_PAGES2["ACCEPT_PRIVACY_POLICY"] = "ACCEPT_PRIVACY_POLICY";
  SIGN_UP_MODAL_PAGES2["WEARABLES_CONNECTION"] = "WEARABLES_CONNECTION";
  SIGN_UP_MODAL_PAGES2["SIGN_UP_SUCCESS"] = "SIGN_UP_SUCCESS";
  SIGN_UP_MODAL_PAGES2["EXIT"] = "EXIT";
  SIGN_UP_MODAL_PAGES2["WEARABLES_MANUAL_TRACK_CONFIRMATION"] = "WEARABLES_MANUAL_TRACK_CONFIRMATION";
  return SIGN_UP_MODAL_PAGES2;
})(SIGN_UP_MODAL_PAGES || {});

// src/pages/challenge-landing-page/components/sign-up-modal/utils/privacy-url.util.ts
import { isFrench, isSpanish, DEFAULT_LOCALE } from "@leagueplatform/locales";
var PRIVACY_POLICY_URL = "https://league.com/ca/privacy-policy";
var PRIVACY_POLICY_FR_URL = "https://league.com/ca/privacy-policy-fr";
var PRIVACY_POLICY_ES_URL = "https://league.com/privacy-policy-es/";
var getPrivacyPolicyUrl = () => {
  if (isFrench(DEFAULT_LOCALE))
    return PRIVACY_POLICY_FR_URL;
  if (isSpanish(DEFAULT_LOCALE))
    return PRIVACY_POLICY_ES_URL;
  return PRIVACY_POLICY_URL;
};

// src/pages/challenge-landing-page/components/sign-up-modal/hooks/use-sign-up-for-challenge.hook.ts
import { useMutation as useMutation6, useQueryClient as useQueryClient5 } from "react-query";
import { useParamsLegacy as useParams21 } from "@leagueplatform/routing";
import { toastActions as toastActions5, TOAST_STATUS as TOAST_STATUS5 } from "@leagueplatform/toast-messages";
import {
  CHALLENGE_HIGHLIGHTS_PATH as CHALLENGE_HIGHLIGHTS_PATH4,
  postUserChallenge,
  CHALLENGES_PATH as CHALLENGES_PATH3
} from "@leagueplatform/health-journey-api";
var useSignUpForChallenge = (challengeTrackingMode, setNextModalNavigationStep) => {
  const { challengeId } = useParams21();
  const queryClient = useQueryClient5();
  return useMutation6(
    () => postUserChallenge(challengeTrackingMode, challengeId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([CHALLENGES_PATH3, challengeId]);
        queryClient.invalidateQueries([CHALLENGE_HIGHLIGHTS_PATH4]);
        setNextModalNavigationStep("SIGN_UP_SUCCESS" /* SIGN_UP_SUCCESS */);
      },
      onError: () => {
        toastActions5.add({
          type: TOAST_STATUS5.ERROR,
          textId: "UNABLE_TO_JOIN_CHALLENGE"
        });
      }
    }
  );
};

// src/pages/challenge-landing-page/components/sign-up-modal/components/accept-privacy-policy/accept-privacy-policy.component.tsx
var { ACCEPT_PRIVACY_POLICY } = SIGN_UP_ANALYTICS_SCREEN_NAMES;
var { CONTINUE } = SIGN_UP_ANALYTICS_DETAILS;
var StyledUL = genesisStyled7.ul`
  list-style: unset;
  padding-inline-start: 40px;
`;
var PrivacyPolicyLink = (text) => {
  const linkout = handleStaticAsset11("CHALLENGES_LINKOUT" /* CHALLENGES_LINKOUT */, {
    isComponent: true
  });
  return /* @__PURE__ */ React72.createElement(
    Link11,
    {
      href: getPrivacyPolicyUrl(),
      target: "_blank",
      display: "inline-flex",
      justifyContents: "center",
      alignItems: "center"
    },
    /* @__PURE__ */ React72.createElement(Box25, { as: "span", marginInlineEnd: "quarter" }, text),
    linkout
  );
};
var AcceptPrivacyPolicy = ({
  trackingType,
  setNextModalNavigationStep
}) => {
  const { formatMessage } = useIntl45();
  const { data: challengeData } = useGetChallengeByIdData();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const signUpForChallengeMutation = useSignUpForChallenge(
    trackingType,
    setNextModalNavigationStep
  );
  useEffect9(
    () => trackChallengesAnalyticsEvent(EVENT_NAME18.SCREEN_LOADED, {
      screen_name: ACCEPT_PRIVACY_POLICY,
      is_critical_event: true
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const handleSubmitAnalytics = (error) => trackChallengesAnalyticsEvent(EVENT_NAME18.BUTTON_CLICKED, {
    screen_name: ACCEPT_PRIVACY_POLICY,
    detail: CONTINUE,
    is_critical_event: true,
    is_validation_error: error
  });
  const { challengeType, dataFields } = challengeData.data;
  const isSoloChallenge = challengeType === "solo";
  const showWearablesConnection = dataFields && dataFields.length > 0;
  const handleSignUpLogic = () => {
    if (!showWearablesConnection) {
      signUpForChallengeMutation.mutate();
    } else {
      setNextModalNavigationStep("WEARABLES_CONNECTION" /* WEARABLES_CONNECTION */);
    }
  };
  return /* @__PURE__ */ React72.createElement(React72.Fragment, null, /* @__PURE__ */ React72.createElement(Box25, { maxWidth: PRIVACY_POLICY_MAX_WIDTH, margin: "0 auto" }, /* @__PURE__ */ React72.createElement(HeadingOne3, { as: "h3", "aria-hidden": "true" }, formatMessage({ id: "SIGN_UP_FOR_THE_CHALLENGE" })), /* @__PURE__ */ React72.createElement(
    BodyOne7,
    {
      paddingTop: { _: "one", tablet: "oneAndHalf" },
      paddingBottom: { _: "one", tablet: "oneAndHalf" }
    },
    formatMessage({ id: "CHALLENGE_SENSITIVE_DATA" })
  ), /* @__PURE__ */ React72.createElement(BodyOne7, { paddingBottom: "threeQuarters" }, formatMessage({
    id: "CHALLENGE_USING_DATA_TO"
  })), /* @__PURE__ */ React72.createElement(StyledUL, null, /* @__PURE__ */ React72.createElement(BodyOne7, { as: "li" }, formatMessage({
    id: "COMPLETE_ACTIVITIES_SHORT"
  })), isSoloChallenge ? /* @__PURE__ */ React72.createElement(BodyOne7, { as: "li" }, formatMessage({
    id: "SHARE_CHALLENGE_PROGRESS_WITH_EMPLOYER"
  })) : /* @__PURE__ */ React72.createElement(React72.Fragment, null, /* @__PURE__ */ React72.createElement(BodyOne7, { as: "li" }, formatMessage({
    id: "SHARE_CHALLENGE_PROGRESS"
  })), /* @__PURE__ */ React72.createElement(BodyOne7, { as: "li" }, formatMessage({
    id: "RANK_SCORE"
  })), /* @__PURE__ */ React72.createElement(BodyOne7, { as: "li" }, formatMessage({
    id: "DETERMINE_CHALLENGE_WINNERS"
  })))), /* @__PURE__ */ React72.createElement(
    Formik3,
    {
      initialValues: {
        confirmedPrivacyPolicy: false
      },
      onSubmit: () => {
        handleSubmitAnalytics(false);
        handleSignUpLogic();
      },
      validate: (values) => {
        const errors = {};
        if (values.confirmedPrivacyPolicy === false) {
          errors.confirmedPrivacyPolicy = formatMessage({
            id: "ACCEPT_BEFORE_CONTINUE"
          });
          handleSubmitAnalytics(true);
        }
        return errors;
      },
      validateOnBlur: false,
      validateOnChange: false
    },
    ({ errors }) => /* @__PURE__ */ React72.createElement(Form3, null, /* @__PURE__ */ React72.createElement(
      Label4,
      {
        display: "flex",
        marginTop: { _: "two", tablet: "two" },
        marginBottom: { _: "two", tablet: "two" }
      },
      /* @__PURE__ */ React72.createElement(
        Field3,
        {
          as: Checkbox,
          type: "checkbox",
          name: "confirmedPrivacyPolicy",
          marginInlineEnd: "one",
          error: errors.confirmedPrivacyPolicy
        }
      ),
      /* @__PURE__ */ React72.createElement("span", null, formatMessage(
        {
          id: "CHECK_TO_CONFIRM_PRIVACY_POLICY"
        },
        {
          a: PrivacyPolicyLink
        }
      ))
    ), errors.confirmedPrivacyPolicy && /* @__PURE__ */ React72.createElement(
      ErrorMessage3,
      {
        display: "flex",
        alignItems: "center",
        marginBottom: "two"
      },
      /* @__PURE__ */ React72.createElement(ChallengeIcon, { iconType: "ALERT" /* ALERT */ }),
      /* @__PURE__ */ React72.createElement(ErrorMessage3, { as: "span", marginInlineStart: "one" }, errors.confirmedPrivacyPolicy)
    ), /* @__PURE__ */ React72.createElement(
      PrimaryButton5,
      {
        type: "submit",
        width: "100%",
        isLoading: signUpForChallengeMutation.isLoading
      },
      formatMessage({ id: "CONTINUE" })
    ))
  ), /* @__PURE__ */ React72.createElement(BodyOne7, { as: "p", marginTop: "oneAndHalf" }, formatMessage(
    {
      id: "LEARN_MORE_ABOUT_PRIVACY_POLICY"
    },
    {
      a: PrivacyPolicyLink
    }
  ))));
};

// src/pages/challenge-landing-page/components/sign-up-modal/components/wearables-connection/wearables-connection.component.tsx
import React76 from "react";
import { Box as Box28, Spinner as Spinner4 } from "@leagueplatform/genesis-core";
import {
  doesUserHaveSufficientWearablePermissions,
  findGrantedWearablePermissions,
  useGetWearablesConsentForDataPoints,
  USER_CONNECTED_DEVICE_CAMPAIGN_MODES
} from "@leagueplatform/health-journey-api";

// src/pages/challenge-landing-page/components/sign-up-modal/components/wearables-connection/manual-tracking-confirmation-modal/manual-tracking-confirmation-modal.component.tsx
import React73 from "react";
import { useIntl as useIntl46 } from "@leagueplatform/locales";
import {
  Box as Box26,
  Button as Button4,
  HeadingText as HeadingText8,
  ParagraphText as ParagraphText5
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset12 } from "@leagueplatform/asset-config";
var MANUAL_TRACKING_CONFIRMATION_MODAL_LABEL_ID = "manualTrackingConfirmationModalLabel";
var ManualTrackingConfirmationModal = ({
  isLoading: signUpForChallengeMutationisLoading,
  onConfirm
}) => {
  const { formatMessage } = useIntl46();
  const trackHealthData2 = handleStaticAsset12(
    "CHALLENGES_TRACK_HEALTH_DATA" /* CHALLENGES_TRACK_HEALTH_DATA */
  );
  return /* @__PURE__ */ React73.createElement(
    Box26,
    {
      css: {
        alignItems: "center",
        justifyContent: "center",
        minHeight: CONFIRMATION_MODAL_MIN_HEIGHT
      }
    },
    /* @__PURE__ */ React73.createElement(
      ModalContentWithImage,
      {
        image: {
          src: trackHealthData2,
          alt: formatMessage({ id: "TRACK_HEALTH_DATA_ALT" })
        }
      },
      /* @__PURE__ */ React73.createElement(
        HeadingText8,
        {
          id: MANUAL_TRACKING_CONFIRMATION_MODAL_LABEL_ID,
          level: "3",
          size: "lg",
          css: { marginBottom: "$threeQuarters" }
        },
        formatMessage({ id: "TRACK_MANUALLY_CONFIRM_TITLE" })
      ),
      /* @__PURE__ */ React73.createElement(ParagraphText5, null, formatMessage({
        id: "TRACK_MANUALLY_CONFIRM_CONNECT_LATER_DESCRIPTION"
      })),
      /* @__PURE__ */ React73.createElement(Box26, { css: { marginTop: "$four", flexWrap: "wrap" } }, /* @__PURE__ */ React73.createElement(
        Button4,
        {
          onClick: () => {
            onConfirm();
          },
          loading: signUpForChallengeMutationisLoading,
          width: "fillContainer",
          css: {
            "@laptop": { maxWidth: MODAL_CTA_MAX_WIDTH },
            "@mobile": { maxWidth: "none" }
          }
        },
        formatMessage({ id: "CONFIRM" })
      ))
    )
  );
};

// src/pages/challenge-landing-page/components/sign-up-modal/components/wearables-connection/device-connected-modal-content.component.tsx
import React74, { useState as useState8 } from "react";
import { EVENT_NAME as EVENT_NAME19, PRODUCT_AREA as PRODUCT_AREA3 } from "@leagueplatform/analytics";
import { useIntl as useIntl47 } from "@leagueplatform/locales";
import {
  HeadingTwo as HeadingTwo4,
  BodyOne as BodyOne8,
  PrimaryButton as PrimaryButton6,
  SecondaryButton,
  Box as Box27
} from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset13 } from "@leagueplatform/asset-config";
var { WEARABLES_CONNECTION } = SIGN_UP_ANALYTICS_SCREEN_NAMES;
var { TRACK_AUTOMATICALLY, TRACK_MANUALLY } = SIGN_UP_ANALYTICS_DETAILS;
var dataPoints = ["steps"];
var DeviceConnectedModalContent = ({
  setDisplayManualTrackingConfirmationModal,
  onConfirm,
  isLoading
}) => {
  const { formatMessage, $tmap, formatList } = useIntl47();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const [isPrimaryButtonPressed, setPrimaryButtonPressed] = useState8(false);
  const [isSecondaryButtonPressed, setSecondaryButtonPressed] = useState8(false);
  const handleAnalyticsClick = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME19.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA3.APPS_AND_DEVICES,
    screen_name: WEARABLES_CONNECTION,
    is_data_available: true,
    detail
  });
  const trackWearables2 = handleStaticAsset13(
    "CHALLENGES_TRACK_WEARABLES" /* CHALLENGES_TRACK_WEARABLES */
  );
  const getDataPointMessageForDataPoint = $tmap({
    steps: "STEPS"
  });
  return /* @__PURE__ */ React74.createElement(
    ModalContentWithImage,
    {
      image: {
        src: trackWearables2,
        alt: formatMessage({ id: "TRACK_WEARABLES_ALT_TEXT" })
      }
    },
    /* @__PURE__ */ React74.createElement(HeadingTwo4, { as: "h3", marginBottom: "threeQuarters" }, formatMessage({ id: "DEVICES_CONNECTED_TITLE" })),
    /* @__PURE__ */ React74.createElement(BodyOne8, { marginBottom: "two" }, formatMessage(
      {
        id: "DEVICES_CONNECTED_DESCRIPTION"
      },
      {
        dataPoint: formatList(
          dataPoints.map(
            (dataPoint) => getDataPointMessageForDataPoint(dataPoint)
          )
        )
      }
    )),
    /* @__PURE__ */ React74.createElement(Box27, { maxWidth: BUTTON_CONTAINER_MAX_WIDTH }, /* @__PURE__ */ React74.createElement(
      PrimaryButton6,
      {
        marginBottom: "oneAndHalf",
        onClick: () => {
          handleAnalyticsClick(TRACK_AUTOMATICALLY);
          onConfirm();
          setPrimaryButtonPressed(true);
        },
        isLoading: isLoading && !isSecondaryButtonPressed,
        width: "100%",
        disabled: isLoading || isSecondaryButtonPressed
      },
      formatMessage({ id: "TRACK_CHALLENGE_AUTOMATICALLY" })
    ), /* @__PURE__ */ React74.createElement(
      SecondaryButton,
      {
        onClick: () => {
          handleAnalyticsClick(TRACK_MANUALLY);
          setDisplayManualTrackingConfirmationModal();
          setSecondaryButtonPressed(true);
        },
        width: "100%",
        isLoading: isLoading && isSecondaryButtonPressed,
        disabled: isLoading || isPrimaryButtonPressed
      },
      formatMessage({ id: "TRACK_CHALLENGE_MANUALLY" })
    ))
  );
};

// src/pages/challenge-landing-page/components/sign-up-modal/components/wearables-connection/device-unconnected-modal-content.component.tsx
import React75 from "react";
import { EVENT_NAME as EVENT_NAME20, PRODUCT_AREA as PRODUCT_AREA4 } from "@leagueplatform/analytics";
import { useIntl as useIntl48 } from "@leagueplatform/locales";
import {
  HeadingTwo as HeadingTwo5,
  HeadingThree as HeadingThree3,
  BodyOne as BodyOne9,
  PrimaryButton as PrimaryButton7,
  SecondaryButton as SecondaryButton2,
  Link as Link12
} from "@leagueplatform/genesis-commons";
import { useHelpCenterLinks as useHelpCenterLinks2 } from "@leagueplatform/health-journey-common";
import { handleStaticAsset as handleStaticAsset14 } from "@leagueplatform/asset-config";

// src/hooks/use-set-consent-and-check-validic-user.hook.ts
import { useMutation as useMutation7 } from "react-query";
import {
  getValidicUser,
  setWearablesConsent
} from "@leagueplatform/health-journey-api";
import { JOURNEY_EXPERIENCE_TEAM } from "@leagueplatform/health-journey-common";
import { toastActions as toastActions6, TOAST_STATUS as TOAST_STATUS6 } from "@leagueplatform/toast-messages";
import { captureError } from "@leagueplatform/observability";
var useGetValidicUser = () => useMutation7(
  () => getValidicUser({
    context: {
      AdditionalNotes: {
        reason: "User unable to sign up to automatically track Challenge data because no validic user could be found or created. As a result, data cannot be tracked automatically."
      }
    },
    ownershipTeam: JOURNEY_EXPERIENCE_TEAM
  }),
  {
    onSuccess: (data, { checkValidicUserOnSuccess }) => {
      if (!(data == null ? void 0 : data.validic_user_id)) {
        const validicError = new Error(
          "User unable to sign up to automatically track Challenge data because no validic user id was returned from the Validic API. As a result, we cannot confirm a validic user was created and data cannot be tracked automatically."
        );
        captureError(validicError, {
          ownershipTeam: JOURNEY_EXPERIENCE_TEAM
        });
        throw validicError;
      }
      checkValidicUserOnSuccess();
    },
    onError: () => {
      toastActions6.add({
        type: TOAST_STATUS6.ERROR,
        textId: "UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG"
      });
    }
  }
);
var useSetConsentAndCheckValidicUser = () => {
  const { isLoading: isMutationLoading, mutate: validicUserMutation } = useGetValidicUser();
  const checkValidicUser = useMutation7(
    () => setWearablesConsent({
      context: {
        AdditionalNotes: {
          reason: "User unable to sign up to automatically track Challenge data because wearables consent could not be set. As a result, data cannot be tracked automatically."
        }
      },
      ownershipTeam: JOURNEY_EXPERIENCE_TEAM
    }),
    {
      // underscore indicates to the compiler that _data is an unused variable that we
      // are ok with ignoring. Needed here for accessing the second args to onSuccess, the mutate variables
      onSuccess: (_data, { checkValidicUserOnSuccess }) => {
        validicUserMutation({ checkValidicUserOnSuccess });
      },
      onError: () => {
        toastActions6.add({
          type: TOAST_STATUS6.ERROR,
          textId: "UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG"
        });
      }
    }
  );
  return __spreadValues({
    isMutationLoading
  }, checkValidicUser);
};

// src/pages/challenge-landing-page/components/sign-up-modal/components/wearables-connection/device-unconnected-modal-content.component.tsx
var { WEARABLES_CONNECTION: WEARABLES_CONNECTION2 } = SIGN_UP_ANALYTICS_SCREEN_NAMES;
var { TRACK_AUTOMATICALLY: TRACK_AUTOMATICALLY2, TRACK_MANUALLY: TRACK_MANUALLY2 } = SIGN_UP_ANALYTICS_DETAILS;
var DeviceUnconnectedModalContent = ({
  setDisplayManualTrackingConfirmationModal,
  isLoading: isSignUpMutationLoading,
  onConfirm
}) => {
  const { formatMessage } = useIntl48();
  const { whatDevicesCanConnectLink, healthProgramsManualTrackingLink } = useHelpCenterLinks2(CHALLENGES_UTM_SOURCE);
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME20.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA4.APPS_AND_DEVICES,
    screen_name: WEARABLES_CONNECTION2,
    is_data_available: false,
    detail
  });
  const checkValidicUserOnSuccess = () => {
    onConfirm();
  };
  const { isMutationLoading, mutate: checkValidicUser } = useSetConsentAndCheckValidicUser();
  const trackWearables2 = handleStaticAsset14(
    "CHALLENGES_TRACK_WEARABLES" /* CHALLENGES_TRACK_WEARABLES */
  );
  return /* @__PURE__ */ React75.createElement(
    ModalContentWithImage,
    {
      image: {
        src: trackWearables2,
        alt: formatMessage({ id: "TRACK_WEARABLES_ALT_TEXT" })
      }
    },
    /* @__PURE__ */ React75.createElement(HeadingTwo5, { as: "h3", marginBottom: "threeQuarters" }, formatMessage({ id: "DEVICES_UNCONNECTED_TITLE" })),
    /* @__PURE__ */ React75.createElement(BodyOne9, { marginBottom: "three" }, formatMessage({
      id: "DEVICES_UNCONNECTED_DESCRIPTION"
    })),
    /* @__PURE__ */ React75.createElement(HeadingThree3, { marginBottom: "one" }, formatMessage({
      id: "DEVICES_UNCONNECTED_TRACK_AUTOMATICALLY_SUBTITLE"
    })),
    /* @__PURE__ */ React75.createElement(BodyOne9, { marginBottom: "oneAndHalf" }, formatMessage(
      {
        id: "TRACK_CHALLENGE_AUTOMATICALLY_DESCRIPTION"
      },
      {
        instructionsLink: /* @__PURE__ */ React75.createElement(
          Link12,
          {
            href: whatDevicesCanConnectLink,
            target: "_blank",
            rel: "noopener noreferrer"
          },
          formatMessage({
            id: "TRACK_CHALLENGE_AUTOMATICALLY_INSTRUCTION"
          })
        )
      }
    )),
    /* @__PURE__ */ React75.createElement(
      PrimaryButton7,
      {
        marginBottom: "three",
        onClick: () => {
          handleAnalyticsClick(TRACK_AUTOMATICALLY2);
          checkValidicUser({ checkValidicUserOnSuccess });
        },
        maxWidth: BUTTON_CONTAINER_MAX_WIDTH,
        isLoading: isMutationLoading || isSignUpMutationLoading
      },
      formatMessage({ id: "TRACK_CHALLENGE_AUTOMATICALLY" })
    ),
    /* @__PURE__ */ React75.createElement(HeadingThree3, { marginBottom: "one" }, formatMessage({ id: "DEVICES_UNCONNECTED_TRACK_MANUALLY_SUBTITLE" })),
    /* @__PURE__ */ React75.createElement(BodyOne9, { marginBottom: "oneAndHalf" }, formatMessage(
      {
        id: "TRACK_CHALLENGE_MANUALLY_CHANGE_LATER"
      },
      {
        learnMoreLink: /* @__PURE__ */ React75.createElement(
          Link12,
          {
            href: healthProgramsManualTrackingLink,
            target: "_blank",
            rel: "noopener noreferrer"
          },
          formatMessage({ id: "TRACK_CHALLENGE_MANUALLY_LEARN_MORE" })
        )
      }
    )),
    /* @__PURE__ */ React75.createElement(
      SecondaryButton2,
      {
        onClick: () => {
          handleAnalyticsClick(TRACK_MANUALLY2);
          setDisplayManualTrackingConfirmationModal();
        },
        maxWidth: BUTTON_CONTAINER_MAX_WIDTH,
        disabled: isMutationLoading || isSignUpMutationLoading
      },
      formatMessage({ id: "TRACK_CHALLENGE_MANUALLY" })
    )
  );
};

// src/pages/challenge-landing-page/components/sign-up-modal/components/wearables-connection/wearables-connection.component.tsx
var WearablesConnection = ({
  trackingType,
  setTrackingType,
  setNextModalNavigationStep,
  currentStep
}) => {
  var _a;
  const { data: challengeData } = useGetChallengeByIdData();
  const dataFields = (_a = challengeData == null ? void 0 : challengeData.data) == null ? void 0 : _a.dataFields;
  const {
    data: wearablesData,
    isLoading
    // If fetching wearables data fails, do not display an error toast
    // Instead, treat user as if they do not have a device connected
  } = useGetWearablesConsentForDataPoints(dataFields);
  const signUpForChallengeMutation = useSignUpForChallenge(
    trackingType,
    setNextModalNavigationStep
  );
  let deviceConnected = false;
  if (isLoading) {
    return /* @__PURE__ */ React76.createElement(Box28, { css: { color: "$decorativeBrandPrimaryDefault" } }, /* @__PURE__ */ React76.createElement(Spinner4, { loading: true }));
  }
  if (dataFields && wearablesData) {
    const { receiving_data_v2: devicesObj } = wearablesData;
    const grantedPermissions = findGrantedWearablePermissions(devicesObj);
    deviceConnected = doesUserHaveSufficientWearablePermissions(
      dataFields,
      grantedPermissions
    );
  }
  if (currentStep === "WEARABLES_MANUAL_TRACK_CONFIRMATION" /* WEARABLES_MANUAL_TRACK_CONFIRMATION */) {
    return /* @__PURE__ */ React76.createElement(
      ManualTrackingConfirmationModal,
      {
        isLoading: signUpForChallengeMutation.isLoading,
        onConfirm: () => {
          setTrackingType(USER_CONNECTED_DEVICE_CAMPAIGN_MODES.MANUAL);
          signUpForChallengeMutation.mutate();
        }
      }
    );
  }
  return deviceConnected ? /* @__PURE__ */ React76.createElement(
    DeviceConnectedModalContent,
    {
      setDisplayManualTrackingConfirmationModal: () => {
        setNextModalNavigationStep(
          "WEARABLES_MANUAL_TRACK_CONFIRMATION" /* WEARABLES_MANUAL_TRACK_CONFIRMATION */
        );
      },
      isLoading: signUpForChallengeMutation.isLoading,
      onConfirm: () => {
        setTrackingType(USER_CONNECTED_DEVICE_CAMPAIGN_MODES.AUTOMATIC);
        signUpForChallengeMutation.mutate();
      }
    }
  ) : /* @__PURE__ */ React76.createElement(
    DeviceUnconnectedModalContent,
    {
      setDisplayManualTrackingConfirmationModal: () => {
        setNextModalNavigationStep(
          "WEARABLES_MANUAL_TRACK_CONFIRMATION" /* WEARABLES_MANUAL_TRACK_CONFIRMATION */
        );
      },
      isLoading: signUpForChallengeMutation.isLoading,
      onConfirm: () => {
        setTrackingType(USER_CONNECTED_DEVICE_CAMPAIGN_MODES.AUTOMATIC);
        signUpForChallengeMutation.mutate();
      }
    }
  );
};

// src/pages/challenge-landing-page/components/sign-up-modal/components/sign-up-success/sign-up-success.component.tsx
import React77 from "react";
import { EVENT_NAME as EVENT_NAME21 } from "@leagueplatform/analytics";
import {
  BodyOne as BodyOne10,
  Box as Box29,
  HeadingTwo as HeadingTwo6,
  PrimaryButton as PrimaryButton8,
  SecondaryButton as SecondaryButton3
} from "@leagueplatform/genesis-commons";
import {
  LinkLegacy as Link13,
  useParamsLegacy as useParams22
} from "@leagueplatform/routing";
import { useIntl as useIntl49 } from "@leagueplatform/locales";

// src/hooks/use-get-get-user-profile-photo-url.hook.ts
import { getContentUrl } from "@leagueplatform/league-content-api";
var useGetUserProfilePhotoUrl = () => {
  var _a, _b;
  let userPhotoUrl;
  const { data: userData } = useGetUserProfile();
  if ((_b = (_a = userData == null ? void 0 : userData.user_profile) == null ? void 0 : _a.avatar) == null ? void 0 : _b.image_id) {
    userPhotoUrl = getContentUrl(userData.user_profile.avatar.image_id);
  }
  return userPhotoUrl;
};

// src/pages/challenge-landing-page/components/sign-up-modal/components/sign-up-success/sign-up-success.component.tsx
import { JOURNEY_ROUTES as JOURNEY_ROUTES12 } from "@leagueplatform/health-journey-common";
import { handleStaticAsset as handleStaticAsset15 } from "@leagueplatform/asset-config";
var { SIGN_UP_SUCCESS } = SIGN_UP_ANALYTICS_SCREEN_NAMES;
var { JOIN_TEAM, VIEW_DETAILS, NOT_NOW, GO_TO_JOURNEY } = SIGN_UP_ANALYTICS_DETAILS;
var SignUpSuccess = ({
  onClose,
  userCanJoinTeam
}) => {
  const { formatMessage, $tifelse } = useIntl49();
  const { challengeId } = useParams22();
  const userPhotoUrl = useGetUserProfilePhotoUrl();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const highFive3 = handleStaticAsset15(
    "CHALLENGES_HIGH_FIVE" /* CHALLENGES_HIGH_FIVE */
  );
  const handleAnalyticsClick = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME21.BUTTON_CLICKED, {
    screen_name: SIGN_UP_SUCCESS,
    detail,
    is_critical_event: true
  });
  return /* @__PURE__ */ React77.createElement(
    ModalContentWithImage,
    {
      image: {
        src: userPhotoUrl != null ? userPhotoUrl : highFive3,
        alt: ""
      },
      isSuccessScreen: true
    },
    /* @__PURE__ */ React77.createElement(Box29, { textAlign: { _: "center", tablet: "start" } }, /* @__PURE__ */ React77.createElement(HeadingTwo6, { as: "h3" }, formatMessage({
      id: "YOURE_GOOD_TO_GO"
    })), /* @__PURE__ */ React77.createElement(
      BodyOne10,
      {
        paddingTop: { _: "one", tablet: "oneAndHalf" },
        paddingBottom: { _: "one", tablet: "oneAndHalf" }
      },
      $tifelse(
        userCanJoinTeam,
        "CHALLENGE_LETS_START_TEAMS_ENABLED",
        "CHECK_CHALLENGE_DETAILS"
      )
    ), /* @__PURE__ */ React77.createElement(
      PrimaryButton8,
      __spreadProps(__spreadValues({
        onClick: () => {
          handleAnalyticsClick(userCanJoinTeam ? JOIN_TEAM : VIEW_DETAILS);
          onClose();
        }
      }, userCanJoinTeam && {
        as: Link13,
        to: JOURNEY_ROUTES12.getChallengeJoinTeam(challengeId)
      }), {
        alignSelf: "flex-start",
        width: "100%",
        maxWidth: BUTTON_CONTAINER_MAX_WIDTH,
        marginTop: "one",
        textDecoration: "none"
      }),
      $tifelse(
        userCanJoinTeam,
        "JOIN_OR_CREATE_TEAM",
        "VIEW_CHALLENGE_DETAILS"
      )
    ), /* @__PURE__ */ React77.createElement(
      SecondaryButton3,
      __spreadProps(__spreadValues({
        onClick: () => {
          handleAnalyticsClick(userCanJoinTeam ? NOT_NOW : GO_TO_JOURNEY);
          onClose();
        }
      }, !userCanJoinTeam && {
        as: Link13,
        to: JOURNEY_ROUTES12.journeyHome(),
        textDecoration: "none"
      }), {
        marginTop: "oneAndHalf",
        width: "100%",
        maxWidth: BUTTON_CONTAINER_MAX_WIDTH
      }),
      $tifelse(userCanJoinTeam, "NOT_NOW", "GO_TO_JOURNEY")
    ))
  );
};

// src/pages/challenge-landing-page/components/sign-up-modal/components/sign-up-exit/sign-up-exit.component.tsx
import * as React78 from "react";
import {
  Box as Box30,
  Button as Button5,
  HeadingText as HeadingText9,
  ParagraphText as ParagraphText6
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl50 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset16 } from "@leagueplatform/asset-config";
import { EVENT_NAME as EVENT_NAME22 } from "@leagueplatform/analytics";
var { QUIT_SIGN_UP } = SIGN_UP_ANALYTICS_SCREEN_NAMES;
var { EXIT } = SIGN_UP_ANALYTICS_DETAILS;
var CLOSE_CONFIRMATION_MODAL_LABEL_ID = "closeConfirmationModalLabel";
var SignUpExit = ({ onClose }) => {
  const { formatMessage } = useIntl50();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleClickAnalytics = (detail) => trackChallengesAnalyticsEvent(EVENT_NAME22.BUTTON_CLICKED, {
    screen_name: QUIT_SIGN_UP,
    detail
  });
  const mindfulMan2 = handleStaticAsset16(
    "CHALLENGES_MINDFUL_MAN" /* CHALLENGES_MINDFUL_MAN */
  );
  return /* @__PURE__ */ React78.createElement(
    Box30,
    {
      css: {
        alignItems: "center",
        justifyContent: "center",
        minHeight: CONFIRMATION_MODAL_MIN_HEIGHT
      }
    },
    /* @__PURE__ */ React78.createElement(
      ModalContentWithImage,
      {
        image: {
          src: mindfulMan2,
          alt: ""
        }
      },
      /* @__PURE__ */ React78.createElement(
        HeadingText9,
        {
          level: "3",
          size: "lg",
          id: CLOSE_CONFIRMATION_MODAL_LABEL_ID,
          css: { marginBottom: "$threeQuarters" }
        },
        formatMessage({ id: "EXIT_CHALLENGE_SIGN_UP_CONFIRM_TITLE" })
      ),
      /* @__PURE__ */ React78.createElement(ParagraphText6, null, formatMessage({
        id: "EXIT_CHALLENGE_SIGN_UP_CONFIRM_DESCRIPTION"
      })),
      /* @__PURE__ */ React78.createElement(Box30, { css: { marginTop: "$four", flexWrap: "wrap" } }, /* @__PURE__ */ React78.createElement(
        Button5,
        {
          onClick: () => {
            handleClickAnalytics(EXIT);
            onClose();
          },
          width: "fillContainer",
          css: {
            "@laptop": { maxWidth: MODAL_CTA_MAX_WIDTH },
            "@mobile": { maxWidth: "none" }
          }
        },
        formatMessage({ id: "EXIT" })
      ))
    )
  );
};

// src/pages/challenge-landing-page/components/sign-up-modal/components/sign-up-modal-content/sign-up-modal-content.component.tsx
var SignUpModalContent = ({
  currentStep,
  setNextModalNavigationStep,
  onClose,
  reset,
  userCanJoinTeam
}) => {
  const [trackingType, setTrackingType] = useState9(USER_CONNECTED_DEVICE_CAMPAIGN_MODES2.MANUAL);
  const {
    ACCEPT_PRIVACY_POLICY: ACCEPT_PRIVACY_POLICY2,
    WEARABLES_CONNECTION: WEARABLES_CONNECTION3,
    SIGN_UP_SUCCESS: SIGN_UP_SUCCESS2,
    EXIT: EXIT2,
    WEARABLES_MANUAL_TRACK_CONFIRMATION
  } = SIGN_UP_MODAL_PAGES;
  useEffect10(() => reset(), []);
  switch (currentStep) {
    case ACCEPT_PRIVACY_POLICY2:
      return /* @__PURE__ */ React79.createElement(
        AcceptPrivacyPolicy,
        {
          trackingType,
          setNextModalNavigationStep
        }
      );
    case WEARABLES_CONNECTION3:
    case WEARABLES_MANUAL_TRACK_CONFIRMATION:
      return /* @__PURE__ */ React79.createElement(
        WearablesConnection,
        {
          setNextModalNavigationStep,
          trackingType,
          setTrackingType,
          currentStep
        }
      );
    case SIGN_UP_SUCCESS2:
      return /* @__PURE__ */ React79.createElement(SignUpSuccess, { onClose, userCanJoinTeam });
    case EXIT2:
      return /* @__PURE__ */ React79.createElement(SignUpExit, { onClose });
    default:
      return /* @__PURE__ */ React79.createElement(
        AcceptPrivacyPolicy,
        {
          trackingType,
          setNextModalNavigationStep
        }
      );
  }
};

// src/pages/challenge-landing-page/components/sign-up-modal/utils/is-back-button-showable.util.ts
var isBackButtonShowable = (currentStep) => currentStep !== "ACCEPT_PRIVACY_POLICY" /* ACCEPT_PRIVACY_POLICY */ && currentStep !== "WEARABLES_CONNECTION" /* WEARABLES_CONNECTION */ && currentStep !== "SIGN_UP_SUCCESS" /* SIGN_UP_SUCCESS */;

// src/pages/challenge-landing-page/components/sign-up-modal/sign-up-modal.component.tsx
var SIGN_UP_MODAL_LABEL_ID = "signUpModalLabel";
var SignUpModal = ({
  isOpen,
  onClose,
  userCanJoinTeam
}) => {
  const { formatMessage } = useIntl51();
  const modalRef = React80.useRef(null);
  const [signUpFlowHistory, setSignUpFlowHistory] = useState10(["ACCEPT_PRIVACY_POLICY" /* ACCEPT_PRIVACY_POLICY */]);
  const setNextModalNavigationStep = (next) => setSignUpFlowHistory([...signUpFlowHistory, next]);
  const currentStep = signUpFlowHistory[signUpFlowHistory.length - 1];
  const showBackButton = isBackButtonShowable(currentStep);
  React80.useEffect(() => {
    var _a;
    if (modalRef) {
      (_a = modalRef == null ? void 0 : modalRef.current) == null ? void 0 : _a.focus();
    }
  }, [currentStep]);
  const SignUpFlowExitPages = [
    "EXIT" /* EXIT */,
    "SIGN_UP_SUCCESS" /* SIGN_UP_SUCCESS */
  ];
  const onBackClick = () => {
    setSignUpFlowHistory([...signUpFlowHistory.slice(0, -1)]);
  };
  return /* @__PURE__ */ React80.createElement(
    Modal4.Root,
    {
      open: isOpen,
      onOpenChange: () => {
        if (SignUpFlowExitPages.includes(currentStep)) {
          onClose();
        }
        setNextModalNavigationStep("EXIT" /* EXIT */);
      }
    },
    /* @__PURE__ */ React80.createElement(
      Modal4.Content,
      {
        width: "100%",
        layout: "fullscreen",
        css: {
          ".GDS-modal": {
            top: 0,
            insetInlineStart: 0,
            height: "100%",
            borderRadius: 0,
            display: "flex",
            flexDirection: "column"
          },
          ".GDS-modal-content": {
            display: "flex",
            alignItems: "center",
            "@mobile": { alignItems: "flex-start" },
            height: "100%",
            padding: "$twoAndHalf",
            overflow: "auto"
          }
        },
        ref: modalRef
      },
      /* @__PURE__ */ React80.createElement(Modal4.Title, null, /* @__PURE__ */ React80.createElement(VisuallyHidden8, null, /* @__PURE__ */ React80.createElement(HeadingText10, { id: SIGN_UP_MODAL_LABEL_ID, level: "2", size: "xl" }, formatMessage({ id: "SIGN_UP_FOR_THE_CHALLENGE" })))),
      /* @__PURE__ */ React80.createElement(Box31, { as: "section", "aria-live": "polite", css: { width: "100%" } }, /* @__PURE__ */ React80.createElement(
        SignUpModalContent,
        {
          currentStep,
          setNextModalNavigationStep,
          reset: () => setSignUpFlowHistory(["ACCEPT_PRIVACY_POLICY" /* ACCEPT_PRIVACY_POLICY */]),
          onClose: () => {
            setSignUpFlowHistory(["ACCEPT_PRIVACY_POLICY" /* ACCEPT_PRIVACY_POLICY */]);
            onClose();
          },
          userCanJoinTeam
        }
      ), showBackButton && /* @__PURE__ */ React80.createElement(
        Button6,
        {
          "data-testingid": "backButton",
          onClick: () => onBackClick(),
          css: {
            top: "$threeQuarters",
            "@mobile": { top: "$one" },
            "@desktop": { top: "calc(50% - 26px)" },
            padding: "$one",
            borderRadius: "$circle",
            backgroundColor: "$decorativeBrandPrimaryPastel",
            color: "$onSurfaceTextSubdued",
            position: "absolute",
            "@tablet": { insetInlineStart: "10%" },
            insetInlineStart: "$oneAndHalf",
            "&:focus": {
              backgroundColor: "$decorativeBrandPrimaryPastel"
            },
            "&:hover": {
              backgroundColor: "$decorativeBrandPrimaryBrightest"
            },
            svg: {
              display: "block"
            }
          }
        },
        /* @__PURE__ */ React80.createElement(ChallengeIcon, { "aria-hidden": "true", iconType: "ARROW" /* ARROW */ }),
        /* @__PURE__ */ React80.createElement(VisuallyHidden8, null, formatMessage({ id: "BACK" }))
      ))
    )
  );
};

// src/pages/challenge-landing-page/challenge-landing-page.page.tsx
var ChallengeLandingPage = () => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const { formatMessage } = useIntl52();
  const [displaySignUpModal, setDisplaySignUpModal] = useState11(false);
  const { challengeId } = useParams23();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const { data: userData } = useGetUserProfile();
  const { default_timezone: defaultTimezone } = userData || {};
  const { data: isChallengeActivitiesTabEnabled } = useFeatureFlagQuery(
    ENABLE_CHALLENGE_ACTIVITIES_TAB
  );
  const { data: isFAQEnabled } = useFeatureFlagQuery(ENABLE_CHALLENGES_FAQ);
  const { isLoading, error, data: challengeData } = useGetChallengeByIdData();
  if (isLoading)
    return /* @__PURE__ */ React81.createElement(CLPSkeletonLoader, null);
  if (error || !(challengeData == null ? void 0 : challengeData.data))
    return /* @__PURE__ */ React81.createElement(FullPageError4, { error, route: JOURNEY_ROUTES13.programsHome() });
  const {
    challengeType,
    detailsRichText,
    endEnroll,
    headerImageUrl,
    headerImageAltText,
    maxTeamSize,
    prizeRichText,
    status,
    startEnroll,
    rulesRichText,
    title,
    bannerText,
    achievementImage
  } = challengeData.data;
  const isSoloChallenge = challengeType === "solo";
  const enrollmentOpen = isEnrollmentOpen(
    startEnroll,
    endEnroll,
    defaultTimezone
  );
  const userIsEnrolled = ((_c = (_b = (_a = challengeData.data) == null ? void 0 : _a.userChallenge) == null ? void 0 : _b.data) == null ? void 0 : _c.enrollmentStatus) === "enrolled";
  const userChallengeId = (_e = (_d = challengeData.data) == null ? void 0 : _d.userChallenge) == null ? void 0 : _e.data.id;
  const teamsEnabled = maxTeamSize > 0;
  const userIsOnTeam = !!((_f = challengeData.data.challengeTeam) == null ? void 0 : _f.data.id);
  const userCanJoinTeam = userIsEnrolled && teamsEnabled && !userIsOnTeam && enrollmentOpen;
  const teamId = (_g = challengeData.data.challengeTeam) == null ? void 0 : _g.data.id;
  const teamName = (_h = challengeData.data.challengeTeam) == null ? void 0 : _h.data.name;
  const showActivitiesTab = userIsEnrolled && isChallengeActivitiesTabEnabled;
  const handleTabsChange = (tabName) => {
    trackChallengesAnalyticsEvent(EVENT_NAME23.NAVIGATION_TAB_CLICKED, {
      screen_name: SCREEN_NAMES9.HEALTH_CAMPAIGN_DETAIL,
      detail: tabName
    });
  };
  const displaySignUpButton = challengeType === "solo" ? !userIsEnrolled : enrollmentOpen && !userIsEnrolled;
  return /* @__PURE__ */ React81.createElement(
    ProgramLayout2,
    {
      header: /* @__PURE__ */ React81.createElement(
        ChallengeHeading,
        {
          bannerText,
          image: headerImageUrl,
          imageAltText: headerImageAltText,
          status,
          title,
          userIsEnrolled,
          challengeType
        }
      ),
      content: /* @__PURE__ */ React81.createElement(StackLayout21, { horizontalAlignment: "stretch", css: { width: "100%" } }, /* @__PURE__ */ React81.createElement(
        Tabs.Root,
        {
          onValueChange: handleTabsChange,
          defaultValue: "overview" /* OVERVIEW */
        },
        /* @__PURE__ */ React81.createElement(
          Tabs.TabList,
          {
            divider: true,
            tabDistribution: "hugContents",
            css: { marginBottom: "$oneAndHalf" }
          },
          /* @__PURE__ */ React81.createElement(Tabs.Tab, { value: "overview" /* OVERVIEW */ }, formatMessage({
            id: "OVERVIEW"
          })),
          showActivitiesTab && /* @__PURE__ */ React81.createElement(Tabs.Tab, { value: "activities" /* ACTIVITIES */ }, formatMessage({
            id: "ACTIVITIES"
          })),
          !isSoloChallenge && /* @__PURE__ */ React81.createElement(React81.Fragment, null, /* @__PURE__ */ React81.createElement(Tabs.Tab, { value: "highlights" /* HIGHLIGHTS */ }, formatMessage({ id: "HIGHLIGHTS" })), /* @__PURE__ */ React81.createElement(Tabs.Tab, { value: "leaderboard" /* LEADERBOARD */ }, formatMessage({ id: "LEADERBOARD" })))
        ),
        /* @__PURE__ */ React81.createElement(Tabs.TabPanel, { value: "overview" /* OVERVIEW */ }, /* @__PURE__ */ React81.createElement(StackLayout21, { horizontalAlignment: "stretch", spacing: "$twoAndHalf" }, prizeRichText && /* @__PURE__ */ React81.createElement(
          ChallengeDetails,
          {
            heading: formatMessage({ id: "PRIZE" }),
            content: prizeRichText
          }
        ), detailsRichText && /* @__PURE__ */ React81.createElement(
          ChallengeDetails,
          {
            heading: formatMessage({ id: "DETAILS" }),
            content: detailsRichText
          }
        ), rulesRichText && /* @__PURE__ */ React81.createElement(
          ChallengeDetails,
          {
            heading: formatMessage({ id: "RULES" }),
            content: rulesRichText
          }
        ), achievementImage && /* @__PURE__ */ React81.createElement(
          AchievementCalloutBanner,
          {
            image: achievementImage,
            text: formatMessage({
              id: "EARN_ACHIEVEMENT_COMPLETING_ACTIVITIES_CHALLENGE"
            })
          }
        ), /* @__PURE__ */ React81.createElement(Responsive4, { down: "laptop" }, teamsEnabled && userIsOnTeam && teamId && teamName && /* @__PURE__ */ React81.createElement(
          ChallengeLink,
          {
            to: JOURNEY_ROUTES13.getChallengeTeamDetails(
              challengeId,
              teamId
            ),
            title: formatMessage({ id: "YOUR_TEAM" }),
            description: teamName
          }
        ), userCanJoinTeam && /* @__PURE__ */ React81.createElement(
          StackLayout21,
          {
            css: { marginBottom: "$one" },
            horizontalAlignment: "stretch"
          },
          /* @__PURE__ */ React81.createElement(JoinTeam2, null)
        )), isFAQEnabled && /* @__PURE__ */ React81.createElement(ChallengeFAQ, null), /* @__PURE__ */ React81.createElement(LegalDisclaimer, null))),
        showActivitiesTab && /* @__PURE__ */ React81.createElement(Tabs.TabPanel, { value: "activities" /* ACTIVITIES */ }, /* @__PURE__ */ React81.createElement(
          ChallengeActivities,
          {
            challengeStatus: status,
            userChallengeId
          }
        )),
        !isSoloChallenge && /* @__PURE__ */ React81.createElement(React81.Fragment, null, /* @__PURE__ */ React81.createElement(Tabs.TabPanel, { value: "highlights" /* HIGHLIGHTS */ }, /* @__PURE__ */ React81.createElement(
          HighlightFeed,
          {
            feedType: CHALLENGE_HIGHLIGHT_FEED_TYPES2.CHALLENGE,
            challengeOrTeamId: challengeId,
            challengeTitle: title,
            userChallengeId: (_k = (_j = (_i = challengeData.data) == null ? void 0 : _i.userChallenge) == null ? void 0 : _j.data) == null ? void 0 : _k.id
          }
        )), /* @__PURE__ */ React81.createElement(Tabs.TabPanel, { value: "leaderboard" /* LEADERBOARD */ }, status === "upcoming" /* UPCOMING */ ? /* @__PURE__ */ React81.createElement(
          EmptyActivityState,
          {
            activityDescription: formatMessage({
              id: "NO_LEADERBOARD_ACTIVITY_DESCRIPTION"
            })
          }
        ) : /* @__PURE__ */ React81.createElement(Leaderboard, { teamsEnabled })))
      ), displaySignUpButton && /* @__PURE__ */ React81.createElement(
        MobileResponsiveSignUpButton,
        {
          setDisplaySignUpModal
        }
      ), /* @__PURE__ */ React81.createElement(
        SignUpModal,
        {
          isOpen: displaySignUpModal,
          onClose: () => {
            setDisplaySignUpModal(false);
          },
          userCanJoinTeam: teamsEnabled && !userIsOnTeam
        }
      )),
      sidebar: /* @__PURE__ */ React81.createElement(
        Sidebar,
        {
          userIsEnrolled,
          teamsEnabled,
          userIsOnTeam,
          userCanJoinTeam,
          teamId,
          teamName,
          setDisplaySignUpModal,
          displaySignUpButton
        }
      )
    }
  );
};

// src/pages/team-landing-page/team-landing-page.page.tsx
import React96, { useEffect as useEffect11 } from "react";
import {
  LinkLegacy as Link16,
  useParamsLegacy as useParams34
} from "@leagueplatform/routing";
import { Box as Box42, Flex as Flex22 } from "@leagueplatform/genesis-commons";
import { JOURNEY_ROUTES as JOURNEY_ROUTES18 } from "@leagueplatform/health-journey-common";
import {
  BackButtonArrow as BackButtonArrow7,
  FullPageError as FullPageError5
} from "@leagueplatform/web-common-components";
import { EVENT_NAME as EVENT_NAME29 } from "@leagueplatform/analytics";

// src/pages/team-landing-page/components/tlp-heading/tlp-heading.component.tsx
import React88, { useState as useState13 } from "react";
import { useIntl as useIntl58 } from "@leagueplatform/locales";
import {
  BodyOneSecondary as BodyOneSecondary3,
  Flex as Flex19,
  HeadingOne as HeadingOne4,
  Box as Box35,
  PrimaryButton as PrimaryButton10
} from "@leagueplatform/genesis-commons";
import {
  StatusBadge as StatusBadge2,
  STATUS_OPTIONS
} from "@leagueplatform/web-common-components";

// src/hooks/use-join-or-leave-team.hook.ts
import { useMutation as useMutation8, useQueryClient as useQueryClient6 } from "react-query";
import { useParamsLegacy as useParams25 } from "@leagueplatform/routing";
import { EVENT_NAME as EVENT_NAME24 } from "@leagueplatform/analytics";
import {
  patchChallengeTeam,
  CHALLENGE_PATCH_OPERATIONS as CHALLENGE_PATCH_OPERATIONS2,
  CHALLENGE_HIGHLIGHTS_PATH as CHALLENGE_HIGHLIGHTS_PATH5,
  CHALLENGES_PATH as CHALLENGES_PATH4
} from "@leagueplatform/health-journey-api";
import { toastActions as toastActions7, TOAST_STATUS as TOAST_STATUS7 } from "@leagueplatform/toast-messages";

// src/pages/team-landing-page/hooks/use-get-team-data-by-id.hook.ts
import { useParamsLegacy as useParams24 } from "@leagueplatform/routing";
import { useQuery as useQuery8 } from "react-query";
import { getTeamDataById } from "@leagueplatform/health-journey-api";
var TEAM_BY_ID_QUERY_KEY = "teamById";
var useGetTeamDataById = () => {
  const { teamId } = useParams24();
  return useQuery8(
    [TEAM_BY_ID_QUERY_KEY, teamId],
    () => getTeamDataById(teamId),
    {
      enabled: !!teamId
    }
  );
};

// src/hooks/use-join-or-leave-team.hook.ts
var useJoinOrLeaveTeam = (teamName, operationType, setDisplayJoinTeamSuccessModal, setDisplayCantJoinTeamModal) => {
  const queryClient = useQueryClient6();
  const { challengeId } = useParams25();
  const { teamId } = useParams25();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = () => trackChallengesAnalyticsEvent(EVENT_NAME24.BUTTON_CLICKED, {
    screen_name: "team details" /* TEAM_DETAILS */,
    detail: "join team" /* JOIN_TEAM */,
    team_name: teamName,
    team_id: teamId
  });
  return useMutation8(
    () => patchChallengeTeam(teamId, challengeId, operationType),
    {
      onSuccess: () => {
        if (operationType === CHALLENGE_PATCH_OPERATIONS2.ADD) {
          setDisplayJoinTeamSuccessModal(true);
          handleAnalyticsClick();
        } else {
          toastActions7.add({
            type: TOAST_STATUS7.SUCCESS,
            textId: "SUCCESSFULLY_LEFT_TEAM",
            shouldAutoClose: true,
            values: {
              teamName
            }
          });
        }
        queryClient.invalidateQueries([CHALLENGE_HIGHLIGHTS_PATH5]);
        queryClient.invalidateQueries([TEAM_BY_ID_QUERY_KEY]);
        queryClient.invalidateQueries([CHALLENGES_PATH4, challengeId]);
      },
      onError: () => {
        if (operationType === CHALLENGE_PATCH_OPERATIONS2.ADD) {
          setDisplayCantJoinTeamModal(true);
        } else {
          toastActions7.add({
            type: TOAST_STATUS7.ERROR,
            textId: "LEAVE_TEAM_FAILURE",
            shouldAutoClose: false
          });
        }
      }
    }
  );
};

// src/pages/team-landing-page/components/tlp-heading/tlp-heading.component.tsx
import { CHALLENGE_PATCH_OPERATIONS as CHALLENGE_PATCH_OPERATIONS4 } from "@leagueplatform/health-journey-api";

// src/pages/team-landing-page/components/tlp-heading/tlp-settings-cog-with-content/tlp-settings-cog-with-content.component.tsx
import React84, { useState as useState12 } from "react";
import { useParamsLegacy as useParams27 } from "@leagueplatform/routing";
import { useIntl as useIntl55 } from "@leagueplatform/locales";
import { Box as Box33 } from "@leagueplatform/genesis-commons";
import { EVENT_NAME as EVENT_NAME26 } from "@leagueplatform/analytics";
import { JOURNEY_ROUTES as JOURNEY_ROUTES14 } from "@leagueplatform/health-journey-common";
import { CHALLENGE_PATCH_OPERATIONS as CHALLENGE_PATCH_OPERATIONS3 } from "@leagueplatform/health-journey-api";

// src/pages/team-landing-page/components/tlp-heading/leave-team-modal/leave-team-modal.component.tsx
import React82 from "react";
import { useIntl as useIntl53 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME25 } from "@leagueplatform/analytics";
import { DangerButton as DangerButton2 } from "@leagueplatform/genesis-commons";
import { useParamsLegacy as useParams26 } from "@leagueplatform/routing";
var LeaveTeamModal = ({
  teamName,
  isSettingsDropdownOpen,
  setIsSettingsDropdownOpen,
  onDismiss,
  leaveChallengeTeam,
  isLoading
}) => {
  const { formatMessage } = useIntl53();
  const { teamId } = useParams26();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = () => trackChallengesAnalyticsEvent(EVENT_NAME25.BUTTON_CLICKED, {
    screen_name: "leave team" /* LEAVE_TEAM */,
    detail: "leave team" /* LEAVE_TEAM */,
    team_name: teamName,
    team_id: teamId
  });
  const onClick = () => {
    leaveChallengeTeam();
    setIsSettingsDropdownOpen(!isSettingsDropdownOpen);
    handleAnalyticsClick();
  };
  return /* @__PURE__ */ React82.createElement(
    ConfirmationModal,
    {
      heading: formatMessage({ id: "LEAVE_TEAM_QUESTION" }, { teamName }),
      description: formatMessage(
        { id: "LEAVE_TEAM_DESCRIPTION" },
        { teamName }
      ),
      isSettingsDropdownOpen,
      onDismiss,
      onMountAnalytics: () => trackChallengesAnalyticsEvent(EVENT_NAME25.SCREEN_LOADED, {
        screen_name: "leave team" /* LEAVE_TEAM */,
        team_name: teamName,
        team_id: teamId
      })
    },
    /* @__PURE__ */ React82.createElement(DangerButton2, { onClick, isLoading }, formatMessage({ id: "LEAVE" }))
  );
};

// src/pages/team-landing-page/components/team-invite-link-modal/team-invite-link-modal.component.tsx
import React83 from "react";
import { useIntl as useIntl54 } from "@leagueplatform/locales";
import {
  Box as Box32,
  HeadingText as HeadingText11,
  ImageMessage,
  Modal as Modal5,
  StackLayout as StackLayout22,
  UtilityText as UtilityText15
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset17 } from "@leagueplatform/asset-config";
var TeamInviteLinkModal = ({
  isOpen,
  onDismiss
}) => {
  const { formatMessage } = useIntl54();
  const teamLink2 = handleStaticAsset17(
    "CHALLENGES_TEAM_LINK" /* CHALLENGES_TEAM_LINK */
  );
  return /* @__PURE__ */ React83.createElement(Modal5.Root, { open: isOpen, onOpenChange: onDismiss }, /* @__PURE__ */ React83.createElement(
    Modal5.Content,
    {
      css: {
        ".GDS-modal": {
          "@initial": { width: "66vw" },
          "@laptop": { width: "50vw" },
          "@desktop": { width: "45vw" }
        }
      }
    },
    /* @__PURE__ */ React83.createElement(
      StackLayout22,
      {
        orientation: {
          "@initial": "horizontal",
          "@mobile": "vertical",
          "@mobileLandscape": "vertical"
        },
        verticalAlignment: "center",
        horizontalAlignment: "center",
        spacing: "$one"
      },
      /* @__PURE__ */ React83.createElement(ImageMessage, { image: teamLink2, imageHeight: MODAL_IMAGE_HEIGHT }),
      /* @__PURE__ */ React83.createElement(StackLayout22, { orientation: "vertical", spacing: "$oneAndHalf" }, /* @__PURE__ */ React83.createElement(Modal5.Title, null, /* @__PURE__ */ React83.createElement(HeadingText11, { size: "xl", level: "2" }, formatMessage({ id: "TEAM_INVITE_HEADING" }))), /* @__PURE__ */ React83.createElement(Modal5.Description, null, /* @__PURE__ */ React83.createElement(UtilityText15, null, formatMessage({
        id: "TEAM_INVITE_LINK_DESCRIPTION"
      }))), /* @__PURE__ */ React83.createElement(Box32, { css: { width: "100%" } }, /* @__PURE__ */ React83.createElement(CopyLink, null)))
    )
  ));
};

// src/pages/team-landing-page/components/tlp-heading/tlp-settings-cog-with-content/tlp-settings-cog-with-content.component.tsx
var TLPSettingsCogWithContent = ({
  teamName,
  enrollmentOpen,
  userIsOnCurrentTeam,
  spotsAvailable,
  setDisplayJoinTeamSuccessModal,
  setDisplayCantJoinTeamModal
}) => {
  const { challengeId } = useParams27();
  const { teamId } = useParams27();
  const { formatMessage } = useIntl55();
  const [displayLeaveTeamModal, setDisplayLeaveTeamModal] = useState12(false);
  const [displayTeamInviteLinkModal, setDisplayTeamInviteLinkModal] = useState12(false);
  const [isSettingsDropdownOpen, setIsSettingsDropdownOpen] = useState12(false);
  const modalIsOpen = displayTeamInviteLinkModal || displayLeaveTeamModal;
  const canInviteFriends = spotsAvailable > 0 && enrollmentOpen;
  const userCanLeaveTeam = enrollmentOpen && userIsOnCurrentTeam;
  const { mutate: leaveChallengeTeam, isLoading } = useJoinOrLeaveTeam(
    teamName,
    CHALLENGE_PATCH_OPERATIONS3.REMOVE,
    setDisplayJoinTeamSuccessModal,
    setDisplayCantJoinTeamModal
  );
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleAnalyticsClick = (detail) => {
    trackChallengesAnalyticsEvent(EVENT_NAME26.BUTTON_CLICKED, {
      screen_name: "team details" /* TEAM_DETAILS */,
      detail,
      team_name: teamName,
      team_id: teamId
    });
  };
  return /* @__PURE__ */ React84.createElement(Box33, { position: "absolute", top: "0", insetInlineEnd: "0" }, /* @__PURE__ */ React84.createElement(
    SettingsCog,
    {
      modalIsOpen,
      isSettingsDropdownOpen,
      setIsSettingsDropdownOpen
    },
    canInviteFriends && /* @__PURE__ */ React84.createElement(React84.Fragment, null, /* @__PURE__ */ React84.createElement(
      SettingsDropdownItem,
      {
        onClick: () => {
          setDisplayTeamInviteLinkModal(true);
          handleAnalyticsClick("settings menu - invite friends" /* SETTINGS_MENU_INVITE */);
        }
      },
      formatMessage({ id: "INVITE_FRIENDS" })
    ), /* @__PURE__ */ React84.createElement(
      TeamInviteLinkModal,
      {
        isOpen: displayTeamInviteLinkModal,
        onDismiss: () => setDisplayTeamInviteLinkModal(false)
      }
    )),
    /* @__PURE__ */ React84.createElement(
      SettingsDropdownItem,
      {
        to: JOURNEY_ROUTES14.getChallengeSettings(challengeId),
        onClick: () => {
          handleAnalyticsClick("settings menu - privacy" /* SETTINGS_MENU_PRIVACY */);
        }
      },
      formatMessage({ id: "PRIVACY" })
    ),
    userCanLeaveTeam && /* @__PURE__ */ React84.createElement(React84.Fragment, null, /* @__PURE__ */ React84.createElement(
      SettingsDropdownItem,
      {
        onClick: () => {
          setDisplayLeaveTeamModal(true);
          handleAnalyticsClick("settings menu - leave team" /* SETTINGS_MENU_LEAVE_TEAM */);
        }
      },
      formatMessage({ id: "LEAVE_TEAM" })
    ), /* @__PURE__ */ React84.createElement(
      LeaveTeamModal,
      {
        teamName,
        isSettingsDropdownOpen: displayLeaveTeamModal,
        setIsSettingsDropdownOpen,
        onDismiss: () => {
          setDisplayLeaveTeamModal(false);
          trackChallengesAnalyticsEvent(EVENT_NAME26.BUTTON_CLICKED, {
            screen_name: "leave team" /* LEAVE_TEAM */,
            detail: "exit" /* EXIT */,
            team_name: teamName,
            team_id: teamId
          });
        },
        leaveChallengeTeam,
        isLoading
      }
    ))
  ));
};

// src/pages/team-landing-page/components/tlp-heading/cant-join-team-modal/cant-join-team-modal.component.tsx
import React85 from "react";
import {
  LinkLegacy as Link14,
  useParamsLegacy as useParams28
} from "@leagueplatform/routing";
import { useIntl as useIntl56 } from "@leagueplatform/locales";
import { PrimaryButton as PrimaryButton9 } from "@leagueplatform/genesis-commons";
import { JOURNEY_ROUTES as JOURNEY_ROUTES15 } from "@leagueplatform/health-journey-common";
var CantJoinTeamModal = ({
  userIsEnrolled,
  teamName,
  isSettingsDropdownOpen,
  onDismiss
}) => {
  const { formatMessage } = useIntl56();
  const { challengeId } = useParams28();
  return /* @__PURE__ */ React85.createElement(
    ConfirmationModal,
    {
      heading: formatMessage({ id: "CANT_JOIN_TEAM_TITLE" }, { teamName }),
      description: userIsEnrolled ? formatMessage({ id: "CANT_JOIN_TEAM_DETAIL" }, { teamName }) : formatMessage(
        { id: "CANT_JOIN_TEAM_JOIN_CHALLENGE_DETAIL" },
        { teamName }
      ),
      isSettingsDropdownOpen,
      onDismiss
    },
    !userIsEnrolled && /* @__PURE__ */ React85.createElement(
      PrimaryButton9,
      {
        as: Link14,
        to: JOURNEY_ROUTES15.getChallengeDetails(challengeId),
        textAlign: "center",
        textDecoration: "none"
      },
      formatMessage({ id: "VIEW_CHALLENGE_DETAILS" })
    )
  );
};

// src/pages/team-landing-page/components/tlp-card/tlp-card.component.tsx
import React86 from "react";
import { Box as Box34 } from "@leagueplatform/genesis-commons";
var TLPCard = ({ children }) => /* @__PURE__ */ React86.createElement(
  Box34,
  {
    backgroundColor: "surface.background.primary",
    borderColor: "onSurface.border.subdued",
    borderRadius: "medium",
    borderWidth: "thin",
    padding: "oneAndHalf"
  },
  children
);

// src/pages/team-landing-page/components/tlp-heading/join-team-success-modal/join-team-success-modal.component.tsx
import React87 from "react";
import { useIntl as useIntl57 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset18 } from "@leagueplatform/asset-config";
import {
  Modal as Modal6,
  StackLayout as StackLayout23,
  ImageMessage as ImageMessage2,
  Button as Button7,
  HeadingText as HeadingText12,
  UtilityText as UtilityText16
} from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME27 } from "@leagueplatform/analytics";
var JoinTeamSuccessModal = ({
  isOpen,
  onDismiss
}) => {
  const { formatMessage } = useIntl57();
  const highFive3 = handleStaticAsset18(
    "CHALLENGES_HIGH_FIVE" /* CHALLENGES_HIGH_FIVE */
  );
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const handleOnClick = () => {
    onDismiss();
    trackChallengesAnalyticsEvent(EVENT_NAME27.BUTTON_CLICKED, {
      screen_name: "join team success" /* JOIN_TEAM_SUCCESS */,
      detail: "go to team details" /* TEAM_DETAILS */
    });
  };
  return /* @__PURE__ */ React87.createElement(Modal6.Root, { open: isOpen, onOpenChange: onDismiss }, /* @__PURE__ */ React87.createElement(
    Modal6.Content,
    {
      css: {
        ".GDS-modal": {
          "@laptop": { width: "50vw" },
          "@desktop": { width: "50vw" }
        }
      }
    },
    /* @__PURE__ */ React87.createElement(
      StackLayout23,
      {
        orientation: {
          "@initial": "horizontal",
          "@mobile": "vertical",
          "@mobileLandscape": "vertical"
        },
        verticalAlignment: "center",
        horizontalAlignment: "center",
        spacing: "$oneAndHalf"
      },
      /* @__PURE__ */ React87.createElement(
        ImageMessage2,
        {
          image: highFive3,
          imageGap: "$oneAndHalf",
          imageHeight: MODAL_IMAGE_HEIGHT
        }
      ),
      /* @__PURE__ */ React87.createElement(
        StackLayout23,
        {
          orientation: "vertical",
          horizontalAlignment: {
            "@initial": "start",
            "@mobile": "center",
            "@mobileLandscape": "center"
          },
          css: {
            flex: "unset",
            "@mobile": {
              textAlign: "center"
            }
          }
        },
        /* @__PURE__ */ React87.createElement(Modal6.Title, null, /* @__PURE__ */ React87.createElement(HeadingText12, { size: "lg", emphasis: "base", level: "2" }, formatMessage({ id: "JOIN_TEAM_SUCCESS_TITLE" }))),
        /* @__PURE__ */ React87.createElement(Modal6.Description, null, /* @__PURE__ */ React87.createElement(UtilityText16, { css: { marginBottom: "$threeQuarters" } }, formatMessage({ id: "JOIN_TEAM_SUCCESS_DETAIL" }))),
        /* @__PURE__ */ React87.createElement(Button7, { onClick: handleOnClick, width: "fillContainer" }, formatMessage({ id: "JOIN_TEAM_SUCCESS_BUTTON" }))
      )
    )
  ));
};

// src/pages/team-landing-page/components/tlp-heading/tlp-heading.component.tsx
var TEAM_HEADING_FIXED_HEIGHT = 164;
var HEADING_BUTTON_MAX_WIDTH = { _: 180, phone: 264 };
var TLPHeading = ({
  teamIcon,
  teamName,
  memberTotal,
  spotsAvailable,
  displayJoinTeamBtn,
  userCanJoinTeam,
  userIsOnCurrentTeam,
  userIsEnrolled,
  enrollmentOpen
}) => {
  const { formatMessage } = useIntl58();
  const [displayCantJoinTeamModal, setDisplayCantJoinTeamModal] = useState13(false);
  const [displayJoinTeamSuccessModal, setDisplayJoinTeamSuccessModal] = useState13(false);
  const { mutate: joinChallengeTeam, isLoading } = useJoinOrLeaveTeam(
    teamName,
    CHALLENGE_PATCH_OPERATIONS4.ADD,
    setDisplayJoinTeamSuccessModal,
    setDisplayCantJoinTeamModal
  );
  const onJoinClick = () => {
    if (userCanJoinTeam) {
      joinChallengeTeam();
    }
    if (!userCanJoinTeam) {
      setDisplayCantJoinTeamModal(true);
    }
  };
  return /* @__PURE__ */ React88.createElement(Box35, { marginBottom: "one", width: "100%" }, /* @__PURE__ */ React88.createElement(TLPCard, null, /* @__PURE__ */ React88.createElement(Flex19, { position: "relative" }, /* @__PURE__ */ React88.createElement(
    Flex19,
    {
      alignItems: "center",
      flexDirection: { _: "column", tablet: "row" },
      justifyContent: "space-between",
      marginTop: { _: "two", tablet: "none" },
      width: "100%"
    },
    /* @__PURE__ */ React88.createElement(
      Flex19,
      {
        alignItems: { _: "center", tablet: "flex-start" },
        flexDirection: { _: "column", tablet: "row" },
        marginInlineEnd: { tablet: "one" },
        textAlign: { _: "center", tablet: "start" }
      },
      /* @__PURE__ */ React88.createElement(
        Box35,
        {
          marginInlineEnd: { _: "none", tablet: "twoAndHalf" },
          minWidth: TEAM_HEADING_FIXED_HEIGHT,
          size: TEAM_HEADING_FIXED_HEIGHT
        },
        /* @__PURE__ */ React88.createElement(
          ChallengeProfilePicture,
          {
            profilePicture: teamIcon,
            firstName: teamName,
            lastName: ""
          }
        )
      ),
      /* @__PURE__ */ React88.createElement(Box35, null, /* @__PURE__ */ React88.createElement(HeadingOne4, { marginBottom: "half", marginTop: "one" }, teamName), userIsOnCurrentTeam && /* @__PURE__ */ React88.createElement(Box35, { marginBottom: "one" }, /* @__PURE__ */ React88.createElement(
        StatusBadge2,
        {
          status: STATUS_OPTIONS.SUCCESS,
          label: formatMessage({ id: "JOINED" }),
          displayIcon: true
        }
      )), /* @__PURE__ */ React88.createElement(BodyOneSecondary3, null, formatMessage({ id: "X_TEAM_MEMBERS" }, { memberTotal })), /* @__PURE__ */ React88.createElement(BodyOneSecondary3, null, formatMessage(
        { id: "X_SPOTS_AVAILABLE" },
        { spotsAvailable }
      )))
    ),
    displayJoinTeamBtn && /* @__PURE__ */ React88.createElement(React88.Fragment, null, /* @__PURE__ */ React88.createElement(
      PrimaryButton10,
      {
        alignSelf: { tablet: "flex-end" },
        marginTop: { _: "oneAndHalf", tablet: "none" },
        maxWidth: HEADING_BUTTON_MAX_WIDTH,
        onClick: onJoinClick,
        width: "100%",
        isLoading
      },
      formatMessage({ id: "JOIN_TEAM" })
    ), /* @__PURE__ */ React88.createElement(
      CantJoinTeamModal,
      {
        userIsEnrolled,
        teamName,
        isSettingsDropdownOpen: displayCantJoinTeamModal,
        onDismiss: () => setDisplayCantJoinTeamModal(false)
      }
    )),
    /* @__PURE__ */ React88.createElement(
      JoinTeamSuccessModal,
      {
        isOpen: displayJoinTeamSuccessModal,
        onDismiss: () => setDisplayJoinTeamSuccessModal(false)
      }
    )
  ), userIsOnCurrentTeam && /* @__PURE__ */ React88.createElement(
    TLPSettingsCogWithContent,
    {
      teamName,
      enrollmentOpen,
      userIsOnCurrentTeam,
      spotsAvailable,
      setDisplayJoinTeamSuccessModal,
      setDisplayCantJoinTeamModal
    }
  ))));
};

// src/pages/team-landing-page/components/tlp-sidebar/tlp-sidebar.component.tsx
import React93 from "react";
import { useParamsLegacy as useParams32 } from "@leagueplatform/routing";
import { useIntl as useIntl61 } from "@leagueplatform/locales";
import { Box as Box39, HeadingThree as HeadingThree5 } from "@leagueplatform/genesis-commons";
import { JOURNEY_ROUTES as JOURNEY_ROUTES16 } from "@leagueplatform/health-journey-common";

// src/pages/team-landing-page/components/tlp-sidebar/tlp-progress/tlp-progress.component.tsx
import React90 from "react";
import { useIntl as useIntl59 } from "@leagueplatform/locales";
import {
  Box as Box37,
  Flex as Flex20,
  HeadingThree as HeadingThree4,
  SubtitleOne as SubtitleOne3,
  Spinner as Spinner5
} from "@leagueplatform/genesis-commons";
import { ErrorState as ErrorState5 } from "@leagueplatform/web-common-components";

// src/pages/team-landing-page/hooks/use-get-individual-team-rank.hook.ts
import { useQuery as useQuery9 } from "react-query";
import { useParamsLegacy as useParams29 } from "@leagueplatform/routing";
import { getTeamChallengeRanks as getTeamChallengeRanks2 } from "@leagueplatform/health-journey-api";
var INDIVIDUAL_TEAM_RANK_QUERY_KEY = "getIndividualTeamRank";
var useGetIndividualTeamRank = () => {
  const { challengeId, teamId } = useParams29();
  return useQuery9(
    [INDIVIDUAL_TEAM_RANK_QUERY_KEY, challengeId, teamId],
    () => getTeamChallengeRanks2(challengeId, teamId)
  );
};

// src/pages/team-landing-page/components/tlp-sidebar/tlp-progress/progress-box.component.tsx
import React89 from "react";
import { Box as Box36, Overline as Overline2 } from "@leagueplatform/genesis-commons";
var ProgressBox = ({ title, children }) => /* @__PURE__ */ React89.createElement(
  Box36,
  {
    backgroundColor: "surface.card.primary",
    borderRadius: "medium",
    padding: "half",
    width: "48%"
  },
  /* @__PURE__ */ React89.createElement(Overline2, { as: "p", color: "onSurface.text.subdued", marginBottom: "quarter" }, title),
  /* @__PURE__ */ React89.createElement(Box36, { as: "span", display: "inline-flex", alignItems: "center" }, children)
);

// src/pages/team-landing-page/components/tlp-sidebar/tlp-progress/tlp-progress.component.tsx
var TLPProgressContainer = ({ children }) => {
  const { formatMessage } = useIntl59();
  return /* @__PURE__ */ React90.createElement(Box37, { marginBottom: "one" }, /* @__PURE__ */ React90.createElement(TLPCard, null, /* @__PURE__ */ React90.createElement(HeadingThree4, { as: "h2", marginBottom: "oneAndHalf" }, formatMessage({ id: "PROGRESS" })), children));
};
var TLPProgress = () => {
  var _a;
  const { formatMessage, formatNumber } = useIntl59();
  const { isLoading, error, data: teamRankData } = useGetIndividualTeamRank();
  if (isLoading)
    return /* @__PURE__ */ React90.createElement(TLPProgressContainer, null, /* @__PURE__ */ React90.createElement(Flex20, { height: "three", justifyContent: "center" }, /* @__PURE__ */ React90.createElement(Spinner5, { isLoading: true })));
  if (error || !(teamRankData == null ? void 0 : teamRankData.data) || ((_a = teamRankData == null ? void 0 : teamRankData.data) == null ? void 0 : _a.length) === 0)
    return /* @__PURE__ */ React90.createElement(TLPProgressContainer, null, /* @__PURE__ */ React90.createElement(ErrorState5, { error }));
  const { rank, score, rankingUnit } = teamRankData.data[0];
  return /* @__PURE__ */ React90.createElement(Box37, { marginBottom: "one" }, /* @__PURE__ */ React90.createElement(TLPCard, null, /* @__PURE__ */ React90.createElement(HeadingThree4, { as: "h2", marginBottom: "oneAndHalf" }, formatMessage({ id: "PROGRESS" })), /* @__PURE__ */ React90.createElement(Flex20, { justifyContent: "space-between", width: "100%", textAlign: "center" }, /* @__PURE__ */ React90.createElement(ProgressBox, { title: formatMessage({ id: "CURRENT_RANK" }) }, /* @__PURE__ */ React90.createElement(SubtitleOne3, { as: "p" }, formatMessage({ id: "XTH_PLACE" }, { currentRank: rank }))), /* @__PURE__ */ React90.createElement(ProgressBox, { title: formatMessage({ id: "TEAM_AVERAGE" }) }, /* @__PURE__ */ React90.createElement(SubtitleOne3, { as: "p" }, formatNumber(score), " ", rankingUnit)))));
};

// src/pages/team-landing-page/components/tlp-sidebar/invite-friends-cta/invite-friends-cta.component.tsx
import React91, { useState as useState14 } from "react";
import { useIntl as useIntl60 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME28 } from "@leagueplatform/analytics";
import { useParamsLegacy as useParams30 } from "@leagueplatform/routing";
import {
  Box as Box38,
  HeadingFour as HeadingFour6,
  BodyOne as BodyOne11,
  PrimaryButton as PrimaryButton11
} from "@leagueplatform/genesis-commons";
var InviteFriendsCTA = ({ teamName }) => {
  const { formatMessage } = useIntl60();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const { teamId } = useParams30();
  const handleAnalyticsClick = () => trackChallengesAnalyticsEvent(EVENT_NAME28.BUTTON_CLICKED, {
    screen_name: "team details" /* TEAM_DETAILS */,
    detail: "invite" /* INVITE */,
    team_name: teamName,
    team_id: teamId
  });
  const [displayTeamInviteLinkModal, setDisplayTeamInviteLinkModal] = useState14(false);
  return /* @__PURE__ */ React91.createElement(React91.Fragment, null, /* @__PURE__ */ React91.createElement(
    Box38,
    {
      backgroundColor: "decorative.brand.primary.pastel",
      borderColor: "onSurface.border.subdued",
      borderRadius: "medium",
      borderWidth: "thin",
      boxShadow: "card",
      padding: "oneAndHalf"
    },
    /* @__PURE__ */ React91.createElement(HeadingFour6, { as: "h2" }, formatMessage({ id: "TEAM_INVITE_HEADING" })),
    /* @__PURE__ */ React91.createElement(BodyOne11, { marginTop: "half", marginBottom: "oneAndHalf" }, formatMessage({ id: "TEAM_INVITE_DESCRIPTION" })),
    /* @__PURE__ */ React91.createElement(
      PrimaryButton11,
      {
        width: "100%",
        onClick: () => {
          setDisplayTeamInviteLinkModal(true);
          handleAnalyticsClick();
        }
      },
      formatMessage({ id: "INVITE" })
    )
  ), /* @__PURE__ */ React91.createElement(
    TeamInviteLinkModal,
    {
      isOpen: displayTeamInviteLinkModal,
      onDismiss: () => setDisplayTeamInviteLinkModal(false)
    }
  ));
};

// src/pages/team-landing-page/components/tlp-sidebar/team-leaderboard.component.tsx
import React92 from "react";
import { ErrorState as ErrorState6 } from "@leagueplatform/web-common-components";

// src/pages/team-landing-page/hooks/use-get-team-user-challenge-ranks.hook.ts
import { useInfiniteQuery as useInfiniteQuery4 } from "react-query";
import { useParamsLegacy as useParams31 } from "@leagueplatform/routing";
import {
  getUserChallengeRanks as getUserChallengeRanks2
} from "@leagueplatform/health-journey-api";
var TEAM_USER_CHALLENGE_RANKS_QUERY_KEY = "getTeamUserChallengeRanksData";
var useGetTeamUserChallengeRanks = () => {
  const { challengeId, teamId } = useParams31();
  return useInfiniteQuery4(
    [TEAM_USER_CHALLENGE_RANKS_QUERY_KEY, challengeId, teamId],
    ({ pageParam }) => getUserChallengeRanks2(challengeId, teamId, pageParam),
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage.links.next || !lastPage.data.length) {
          return void 0;
        }
        const { next } = lastPage.links;
        return next.slice(next.indexOf("/v1/"));
      }
    }
  );
};

// src/pages/team-landing-page/components/tlp-sidebar/team-leaderboard.component.tsx
var TeamLeaderboard = () => {
  const {
    isLoading: isTeamLeaderboardLoading,
    error: teamLeaderboardError,
    data: teamLeaderboardData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useGetTeamUserChallengeRanks();
  let flattenedTeamLeaderboardData;
  if (teamLeaderboardData == null ? void 0 : teamLeaderboardData.pages) {
    flattenedTeamLeaderboardData = teamLeaderboardData.pages.reduce(
      (acc, page) => acc.concat(page.data),
      []
    );
  }
  if (isTeamLeaderboardLoading) {
    return /* @__PURE__ */ React92.createElement(LeaderboardSkeletonLoader, null);
  }
  if (teamLeaderboardError || !flattenedTeamLeaderboardData) {
    return /* @__PURE__ */ React92.createElement(ErrorState6, { error: teamLeaderboardError });
  }
  return /* @__PURE__ */ React92.createElement(
    LeaderboardTable,
    {
      leaderboardData: flattenedTeamLeaderboardData,
      displayViewMore: !!hasNextPage,
      isFetchingNextPage,
      fetchNextPage
    }
  );
};

// src/pages/team-landing-page/components/tlp-sidebar/tlp-sidebar.component.tsx
var TLPSidebar = ({
  challengeName,
  teamName,
  challengeStatus,
  enrollmentOpen,
  spotsAvailable,
  userIsOnCurrentTeam
}) => {
  const { formatMessage } = useIntl61();
  const { challengeId } = useParams32();
  const canInviteFriends = userIsOnCurrentTeam && spotsAvailable > 0 && enrollmentOpen;
  return /* @__PURE__ */ React93.createElement(Box39, { width: { _: "100%", tablet: "50%", laptop: "40%" } }, /* @__PURE__ */ React93.createElement(
    ChallengeLink,
    {
      to: JOURNEY_ROUTES16.getChallengeDetails(challengeId),
      title: formatMessage({ id: "CHALLENGE" }),
      description: challengeName
    }
  ), /* @__PURE__ */ React93.createElement(TLPProgress, null), /* @__PURE__ */ React93.createElement(Box39, { marginBottom: "one" }, /* @__PURE__ */ React93.createElement(TLPCard, null, /* @__PURE__ */ React93.createElement(HeadingThree5, { as: "h2", marginBottom: "oneAndHalf" }, formatMessage({ id: "LEADERBOARD" })), challengeStatus === "upcoming" /* UPCOMING */ ? /* @__PURE__ */ React93.createElement(
    EmptyActivityState,
    {
      activityDescription: formatMessage({
        id: "NO_LEADERBOARD_ACTIVITY_DESCRIPTION"
      })
    }
  ) : /* @__PURE__ */ React93.createElement(TeamLeaderboard, null))), canInviteFriends && /* @__PURE__ */ React93.createElement(InviteFriendsCTA, { teamName }));
};

// src/pages/team-landing-page/components/tlp-highlights/tlp-highlights.component.tsx
import React94 from "react";
import { useIntl as useIntl62 } from "@leagueplatform/locales";
import { Box as Box40, HeadingThree as HeadingThree6 } from "@leagueplatform/genesis-commons";
import { CHALLENGE_HIGHLIGHT_FEED_TYPES as CHALLENGE_HIGHLIGHT_FEED_TYPES3 } from "@leagueplatform/health-journey-api";
var TLPHighlights = ({
  challengeTitle,
  teamId,
  userChallengeId
}) => {
  const { formatMessage } = useIntl62();
  return /* @__PURE__ */ React94.createElement(
    Box40,
    {
      width: { _: "100%", tablet: "66%" },
      marginTop: { _: "one", tablet: "none" },
      marginInlineEnd: "oneAndHalf"
    },
    /* @__PURE__ */ React94.createElement(TLPCard, null, /* @__PURE__ */ React94.createElement(HeadingThree6, { as: "h2", marginBottom: "oneAndHalf" }, formatMessage({ id: "HIGHLIGHTS" })), /* @__PURE__ */ React94.createElement(
      HighlightFeed,
      {
        feedType: CHALLENGE_HIGHLIGHT_FEED_TYPES3.TEAM,
        challengeOrTeamId: teamId,
        challengeTitle,
        userChallengeId
      }
    ))
  );
};

// src/pages/team-landing-page/components/tlp-skeleton-loader/tlp-skeleton-loader.component.tsx
import React95 from "react";
import { Box as Box41, Flex as Flex21 } from "@leagueplatform/genesis-commons";
import {
  BackButtonArrow as BackButtonArrow6,
  SkeletonBox as SkeletonBox5
} from "@leagueplatform/web-common-components";
import {
  LinkLegacy as Link15,
  useParamsLegacy as useParams33
} from "@leagueplatform/routing";
import { JOURNEY_ROUTES as JOURNEY_ROUTES17 } from "@leagueplatform/health-journey-common";

// src/pages/team-landing-page/constants/team-landing-page.constants.tsx
var TLP_MAX_WIDTH = 1200;

// src/pages/team-landing-page/components/tlp-skeleton-loader/tlp-skeleton-loader.component.tsx
var TLPSkeletonLoader = () => {
  const { challengeId } = useParams33();
  return /* @__PURE__ */ React95.createElement(
    Box41,
    {
      padding: { _: "oneAndHalf", phone: "twoAndHalf" },
      marginX: "auto",
      maxWidth: TLP_MAX_WIDTH
    },
    /* @__PURE__ */ React95.createElement(
      BackButtonArrow6,
      {
        as: Link15,
        justifyContent: "initial",
        marginInlineEnd: "quarter",
        marginY: "half",
        onClick: noopFunction,
        to: JOURNEY_ROUTES17.getChallengeDetails(challengeId),
        size: "three"
      }
    ),
    /* @__PURE__ */ React95.createElement(
      SkeletonBox5,
      {
        backgroundColor: "interactive.background.disabled",
        height: { _: "400px", laptop: "200px" },
        role: "presentation",
        marginBottom: "one"
      }
    ),
    /* @__PURE__ */ React95.createElement(
      Flex21,
      {
        flexDirection: { _: "column-reverse", laptop: "row" },
        alignItems: { _: "center", laptop: "initial" }
      },
      /* @__PURE__ */ React95.createElement(
        Box41,
        {
          paddingInlineEnd: { laptop: "two" },
          marginBottom: "twoAndHalf",
          width: "100%"
        },
        /* @__PURE__ */ React95.createElement(
          SkeletonBox5,
          {
            width: "100%",
            height: "632px",
            backgroundColor: "interactive.background.disabled",
            role: "presentation"
          }
        )
      ),
      /* @__PURE__ */ React95.createElement(Box41, { flexDirection: "column", width: { _: "100%", laptop: "60%" } }, /* @__PURE__ */ React95.createElement(
        SkeletonBox5,
        {
          height: "100px",
          backgroundColor: "interactive.background.disabled",
          marginBottom: "one",
          role: "presentation"
        }
      ), /* @__PURE__ */ React95.createElement(
        SkeletonBox5,
        {
          marginBottom: "one",
          height: "200px",
          backgroundColor: "interactive.background.disabled",
          role: "presentation"
        }
      ), /* @__PURE__ */ React95.createElement(
        SkeletonBox5,
        {
          height: "300px",
          backgroundColor: "interactive.background.disabled",
          role: "presentation",
          marginBottom: "two"
        }
      ))
    )
  );
};

// src/pages/team-landing-page/team-landing-page.page.tsx
var TeamLandingPage = () => {
  var _a, _b, _c;
  const { isLoading, error, data: teamData } = useGetTeamDataById();
  const { challengeId } = useParams34();
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const { data: userData } = useGetUserProfile();
  const { default_timezone: defaultTimezone } = userData || {};
  useEffect11(() => {
    var _a2, _b2;
    if (teamData) {
      trackChallengesAnalyticsEvent(EVENT_NAME29.SCREEN_LOADED, {
        screen_name: "team details" /* TEAM_DETAILS */,
        team_name: (_a2 = teamData.data) == null ? void 0 : _a2.name,
        team_id: (_b2 = teamData.data) == null ? void 0 : _b2.id
      });
    }
  }, [teamData]);
  if (isLoading)
    return /* @__PURE__ */ React96.createElement(TLPSkeletonLoader, null);
  if (error || !(teamData == null ? void 0 : teamData.data))
    return /* @__PURE__ */ React96.createElement(FullPageError5, { error, route: JOURNEY_ROUTES18.programsHome() });
  const {
    id: teamId,
    name,
    avatarUrl,
    maxMembers,
    memberCount,
    challenge
  } = teamData.data;
  const spotsAvailable = maxMembers - memberCount;
  const { endEnroll, maxTeamSize, startEnroll, status, title } = challenge.data;
  const enrollmentOpen = isEnrollmentOpen(
    startEnroll,
    endEnroll,
    defaultTimezone
  );
  const userIsEnrolled = !!((_a = teamData.data.userChallenge) == null ? void 0 : _a.data.id);
  const teamsEnabled = maxTeamSize > 0;
  const userIsOnCurrentTeam = !!((_b = teamData.data.user) == null ? void 0 : _b.data.id);
  const userCanJoinTeam = userIsEnrolled && teamsEnabled && // TODO: userIsOnCurrentTeam should be switched to a userIsOnTeam (any team) value
  !userIsOnCurrentTeam && enrollmentOpen && spotsAvailable > 0;
  const displayJoinTeamBtn = !userIsOnCurrentTeam && enrollmentOpen && spotsAvailable > 0;
  if (!teamsEnabled)
    return /* @__PURE__ */ React96.createElement(FullPageError5, { error: null, route: JOURNEY_ROUTES18.programsHome() });
  return /* @__PURE__ */ React96.createElement(Box42, { backgroundColor: "surface.background.secondary", height: "100%" }, /* @__PURE__ */ React96.createElement(
    Box42,
    {
      as: "section",
      marginX: "auto",
      maxWidth: TLP_MAX_WIDTH,
      paddingY: "twoAndHalf",
      paddingX: { _: "one", phone: "oneAndHalf", tablet: "twoAndHalf" }
    },
    /* @__PURE__ */ React96.createElement(
      BackButtonArrow7,
      {
        as: Link16,
        justifyContent: "initial",
        marginInlineEnd: "quarter",
        marginY: "half",
        onClick: noopFunction,
        to: JOURNEY_ROUTES18.getChallengeDetails(challengeId),
        size: "three"
      }
    ),
    /* @__PURE__ */ React96.createElement(
      TLPHeading,
      {
        memberTotal: memberCount,
        spotsAvailable,
        teamIcon: avatarUrl,
        teamName: name,
        displayJoinTeamBtn,
        userCanJoinTeam,
        userIsOnCurrentTeam,
        userIsEnrolled,
        enrollmentOpen
      }
    ),
    /* @__PURE__ */ React96.createElement(
      Flex22,
      {
        flexDirection: { _: "column-reverse", tablet: "row" },
        justifyContent: "space-between"
      },
      /* @__PURE__ */ React96.createElement(
        TLPHighlights,
        {
          challengeTitle: title,
          teamId,
          userChallengeId: (_c = teamData.data.user) == null ? void 0 : _c.data.id
        }
      ),
      /* @__PURE__ */ React96.createElement(
        TLPSidebar,
        {
          challengeName: title,
          teamName: name,
          challengeStatus: status,
          enrollmentOpen,
          spotsAvailable,
          userIsOnCurrentTeam
        }
      )
    )
  ));
};

// src/pages/challenge-activities-history-page/challenge-activities-history-page.tsx
import * as React97 from "react";
import { useIntl as useIntl63 } from "@leagueplatform/locales";
import { useNavigateLegacy as useNavigate } from "@leagueplatform/routing";
import { Flex as Flex23 } from "@leagueplatform/genesis-commons";
import { CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH } from "@leagueplatform/health-journey-common";
import {
  BackButtonArrow as BackButtonArrow8,
  FullPageError as FullPageError6,
  SkeletonBox as SkeletonBox6
} from "@leagueplatform/web-common-components";
import {
  HeadingText as HeadingText13,
  SkeletonText,
  StackLayout as StackLayout24
} from "@leagueplatform/genesis-core";

// src/utils/get-activity-statuses-array.util.ts
var getActivityStatusesArray = (statusType) => {
  switch (statusType) {
    case "active":
      return ["active"];
    case "completed":
      return ["completed"];
    case "missed":
      return ["expired", "removed"];
    default:
      return [];
  }
};

// src/pages/challenge-activities-history-page/challenge-activities-history-page.tsx
function ChallengeActivitiesHistoryPageLayout({
  children,
  title
}) {
  const navigate = useNavigate();
  return /* @__PURE__ */ React97.createElement(
    Flex23,
    {
      width: "100%",
      maxWidth: CONFIGURABLE_JOURNEY_PAGE_MAX_WIDTH,
      margin: "auto",
      paddingX: "one",
      paddingTop: { _: "two", laptop: "four" },
      paddingBottom: "one"
    },
    /* @__PURE__ */ React97.createElement(BackButtonArrow8, { marginInlineEnd: "one", onClick: () => navigate(-1) }),
    /* @__PURE__ */ React97.createElement(StackLayout24, { spacing: "$oneAndHalf", css: { width: "100%" } }, /* @__PURE__ */ React97.createElement(HeadingText13, { level: "1", size: "xl", css: { width: "100%" } }, title), /* @__PURE__ */ React97.createElement(ChallengeActivitySection, null, children))
  );
}
var pageViewEmptyStateMap = {
  missed: /* @__PURE__ */ React97.createElement(ChallengeMissedActivitiesPendingStateCard, null),
  completed: /* @__PURE__ */ React97.createElement(ChallengeCompletedActivitiesPendingStateCard, null)
};
function ChallengeActivitiesHistoryPage({
  activityStatus
}) {
  var _a, _b, _c, _d;
  const { $tmap } = useIntl63();
  const activityStatuses = getActivityStatusesArray(activityStatus);
  const useGetChallengeByIdDataQuery = useGetChallengeByIdData();
  const challenge = (_a = useGetChallengeByIdDataQuery == null ? void 0 : useGetChallengeByIdDataQuery.data) == null ? void 0 : _a.data;
  const useActivitiesByActivityStatusQuery = useActivitiesByActivityStatusAndCampaign({
    activityStatuses,
    campaignId: (_c = (_b = challenge == null ? void 0 : challenge.userChallenge) == null ? void 0 : _b.data) == null ? void 0 : _c.id
  });
  const activities = (_d = useActivitiesByActivityStatusQuery.data) == null ? void 0 : _d.userHealthActivities;
  const hasActivities = !!(activities == null ? void 0 : activities.length);
  const isError = useActivitiesByActivityStatusQuery.isError || useGetChallengeByIdDataQuery.isError || // If there is no challenge data and loading is done something went wrong.
  !challenge && !useGetChallengeByIdDataQuery.isLoading;
  const isLoading = useActivitiesByActivityStatusQuery.isLoading || useGetChallengeByIdDataQuery.isLoading;
  const errors = [
    useActivitiesByActivityStatusQuery.error,
    useGetChallengeByIdDataQuery.error
  ];
  if (isError) {
    return /* @__PURE__ */ React97.createElement(FullPageError6, { error: errors });
  }
  let children = null;
  if (isLoading) {
    children = /* @__PURE__ */ React97.createElement(React97.Fragment, null, /* @__PURE__ */ React97.createElement(SkeletonText, { width: "20%" }), /* @__PURE__ */ React97.createElement(
      SkeletonBox6,
      {
        backgroundColor: "interactive.background.disabled",
        height: 72
      }
    ));
  } else if (hasActivities) {
    children = /* @__PURE__ */ React97.createElement(
      ChallengeActivityList,
      {
        activities: sortActivitiesInReverseChronologicalOrder(activities),
        level: "3"
      }
    );
  } else {
    children = pageViewEmptyStateMap[activityStatus];
  }
  const headingTextMessage = $tmap({
    missed: "MISSED_ACTIVITIES",
    completed: "COMPLETED_ACTIVITIES"
  })(activityStatus);
  return /* @__PURE__ */ React97.createElement(
    ChallengeActivitiesHistoryPageLayout,
    {
      title: isLoading ? /* @__PURE__ */ React97.createElement(SkeletonText, { header: true, width: "50%" }) : challenge == null ? void 0 : challenge.title
    },
    /* @__PURE__ */ React97.createElement(HeadingText13, { level: "2", size: "lg" }, headingTextMessage),
    children
  );
}

// src/challenge.routes.tsx
var ChallengeRoutes = () => /* @__PURE__ */ React98.createElement(Routes, null, /* @__PURE__ */ React98.createElement(Route, { path: ":challengeId", element: /* @__PURE__ */ React98.createElement(ChallengeLandingPage, null) }), /* @__PURE__ */ React98.createElement(Route, { path: ":challengeId/settings/*", element: /* @__PURE__ */ React98.createElement(SettingsPage, null) }), /* @__PURE__ */ React98.createElement(Route, { path: ":challengeId/join-team/*", element: /* @__PURE__ */ React98.createElement(JoinTeamPage, null) }), /* @__PURE__ */ React98.createElement(Route, { path: ":challengeId/team/:teamId/*", element: /* @__PURE__ */ React98.createElement(TeamLandingPage, null) }), /* @__PURE__ */ React98.createElement(
  Route,
  {
    path: ":challengeId/activities/completed/*",
    element: /* @__PURE__ */ React98.createElement(ChallengeActivitiesHistoryPage, { activityStatus: "completed" })
  }
), /* @__PURE__ */ React98.createElement(
  Route,
  {
    path: ":challengeId/activities/missed/*",
    element: /* @__PURE__ */ React98.createElement(ChallengeActivitiesHistoryPage, { activityStatus: "missed" })
  }
));

// src/hooks/use-get-all-challenges.hook.ts
import { useQuery as useQuery10 } from "react-query";
import { ENABLE_CHALLENGES } from "@leagueplatform/health-journey-common";
import {
  CHALLENGES_PATH as CHALLENGES_PATH5,
  getAllChallenges
} from "@leagueplatform/health-journey-api";
import { useFeatureFlagQuery as useFeatureFlagQuery2 } from "@leagueplatform/user-profile-api";
var useGetAllChallenges = (challengeType) => {
  const { data: isChallengesEnabled } = useFeatureFlagQuery2(ENABLE_CHALLENGES);
  return useQuery10(
    [CHALLENGES_PATH5, challengeType],
    () => getAllChallenges(challengeType),
    {
      enabled: !!isChallengesEnabled
    }
  );
};

// src/hooks/use-is-challenges-enabled.hook.ts
import { useFeatureFlagQuery as useFeatureFlagQuery3 } from "@leagueplatform/user-profile-api";
import { isProduction } from "@leagueplatform/app-environment";
var useIsChallengesEnabled = () => {
  const ENABLE_CHALLENGES2 = "enable_challenges";
  const { isLoading, data: isChallengesFFEnabled } = useFeatureFlagQuery3(ENABLE_CHALLENGES2);
  const isChallengesEnabled = isChallengesFFEnabled || !isProduction();
  return {
    isLoading,
    isChallengesEnabled
  };
};

// src/components/challenge-activity-token-caption/challenge-activity-token-caption.component.tsx
import React99 from "react";
import { useIntl as useIntl64 } from "@leagueplatform/locales";
import { Box as Box43 } from "@leagueplatform/genesis-commons";
import { ChallengeTokenIcon } from "@leagueplatform/rewards-common";
var ChallengeActivityTokenCaption = ({
  tokens,
  activityDesc
}) => {
  const { formatMessage } = useIntl64();
  const tokenCount = typeof tokens === "string" ? parseInt(tokens, 10) : tokens;
  return /* @__PURE__ */ React99.createElement(Box43, { as: "span", display: "inline-flex", alignItems: "center" }, activityDesc, /* @__PURE__ */ React99.createElement(
    Box43,
    {
      as: "span",
      marginInlineStart: "quarter",
      display: "inline-flex",
      alignItems: "center"
    },
    formatMessage(
      { id: "WORD_WITH_EXCLAMATION_POINT" },
      {
        word: /* @__PURE__ */ React99.createElement(ChallengeTokenIcon, { value: tokenCount })
      }
    )
  ));
};

// src/index.tsx
initModule();
export {
  ChallengeActivityTokenCaption,
  ChallengeRoutes,
  isBeforeEnrollmentPeriod,
  isEnrollmentOpen,
  useGetAllChallenges,
  useIsChallengesEnabled
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/challenges'] = window.leagueSDKsPresent['@leagueplatform/challenges'] || [];
    window.leagueSDKsPresent['@leagueplatform/challenges'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/challenges'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/challenges module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map